/*
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';
import 'lodash/lodash.min.js';
import "@polymer/app-route/app-route.js";
import { } from '@polymer/polymer/lib/mixins/dir-mixin.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';
import './mpin-setup-landing.js';
import './fin-auth-otp-landing.js';
import './fin-auth-modes-landing.js';
import './fin-page-footer.js';
import './forget-userid-otp.js';
//import './fin-timer.js';
import '../../../behaviors/app-common-behaviour.js';
const template = html`
         <style include="login-styles">             
             oe-input{
                --paper-input-container-invalid-color:var(--paper-input-label-color);
             }             
             .light-checkbox {
                   --paper-checkbox-unchecked-color: var(--primary-light-color);
                   --paper-checkbox-checked-color: var(--primary-light-color);
                   --paper-checkbox-checkmark-color: var(--brand-color);
                   --paper-checkbox-size: 15px;
               }
           
           .banner-skew[phone] {
               height: 75%;
               top: -20.5vw !important;
           }

           .display-none-phone[phone]{
               display: none;
           }
           
           .logged-in-users {
               max-width: 116px;
           }
           
           .keyboard-position {
                position: absolute;
                top: 33px;
                right: -24px;
           }

           :dir(rtl).keyboard-position {
                position: absolute;
                top: 33px;
                left: -24px;
                right: auto;
           }
           
           app-fab {
               --action-icon-style: {
                   width: 20px;
                   height: 20px;
                   top: auto;
                   right: 2px;
                   bottom: 4px;
                   fill: var(--brand-color);
               }
           }
           
           .view-port {
               overflow-x: auto;
               overflow-y: auto;
           }
           
           .active-user {
               border: 2px solid var(--brand-color);
           }
           
           .add-new-user-fab {
               --app-fab-icon-style: {
                   width: 40%;
               }
           }
           
           .text-transform-none {
               text-transform: none;
           }
           
           

           .pipVideoDiv{
                margin-top: -12px;
            }

            .position-absolute-t-l {
                    position: absolute;
                    top: 0;
                    left: 0;
            }

            :dir(rtl).position-absolute-t-l {
                
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: auto;
            }
            @media (min-width:768px) {
                    .help-link {
                        display:flex;
                    }
                    .need-help-text {
                        padding-right:3px;
                    }
                    .banner-skew {
                        height: 80%;
                        top: 3.6vw !important;
                    }
                    .copyright-text {
                        position: absolute;
                        bottom: 10px;
                        right: 10px;
                    }
                    .faq-text {
                        font-size: var(--a-font-size-m);                        
                    }
                    .disp-only-in-mobile{
                        display:none;
                    }   
                    .login-primary-light-text-xl {
                        display:none;
                    }
                    paper-button.primary-button{
                        color: rgba(255,255,255,1);
                        min-width: 62px;
                        height: 36px;
                        font-size: var(--a-button-font-size) !important;
                        letter-spacing: 0;
                        line-height: 30px;
                        background-color: var(--primary-color-but);
                        font-family: var(--medium-font);
                        font-size: var(--a-button-font-size);
                        padding:8px 16px;
                        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 6px 12px 0 rgba(0, 0, 0, 0.19);
                        transition: all 0.4s;
                        text-shadow: 0 1px 2px rgba(--button-text-shadow-color) !important;
                    }
                    .shadow-div {
                        display:none;
                    }
                }
                @media (max-width:479px){
                    .mb-button-style{
                        display: flex;
                        align-items: center;
                        justify-content: center;        
                    }
                    .login-banner-skew {                        
                        display:none;
                    }                
                    .login-light-checkbox {
                        --paper-checkbox-unchecked-color: var(--primary-dark-color);  
                        opacity:0.57;    
                        font-size: var(--tooltip-font-size);                  
                        margin-top: -4px;
                        letter-spacing: 1px;  
                        --paper-checkbox-size: 21px; 
                        line-height:13px;                
                    }                    
                    .login-primary-light-text-m {
                        opacity: 0.57;
                        font-size: var(--a-button-font-size-small);
                        color: var(--primary-dark-color);
                        letter-spacing: 0;
                        margin-bottom:20px;
                        margin-top:7px;
                    }
                    .login-primary-light-color {
                        font-size: var(--a-button-font-size);
                        color: var(--secondary-dark-color);
                        letter-spacing: 0;
                    }
                    .login-primary-light-text-xl {
                        color:var(--primary-dark-color);
                        font-weight:600;
                        text-align:center;
                        margin-top:38px;
                    }
                    .login-light-input-style,  .login-light-input-stylee{                      
                        border: 1px solid var(--secondary-dark-color); ;
                        border-radius: 6px;    
                    }                    
                    .login-primary-button {                        
                        --paper-button_-_height: 46px !important;
                          margin-top: 20px !important;                          
                          margin-left:-12px;
                          border-radius:0px;   
                          padding: 20px 90px !important;    
                          background: var(--primary-color-but);                                     
                    }
                    .login-secondary-button{
                        --paper-button_-_height: 46px !important;
                          margin-top: 20px !important;                         
                          margin-left:-12px;
                          border-radius:0px;   
                          padding: 20px 90px; 
                    }
                    .login-position-relative {
                        width: 90% !important;
                        margin-left: auto;
                        margin-right: auto;
                        /*background:var(--primary-light-color) !important;*/
                        /*box-shadow: 0 0px 1px 0 rgba(247, 234, 234, 0.75), 0 6px 17px 0 rgba(125, 122, 122, 0.75);*/
                        transition: all 0.4s;
                        /* top : 56px; */
                        top:-75px;   
                        /* margin-bottom: -125px; */
                    }
                    .login-mdl-cell {
                        margin: -110px 0px 0px 2px;
                    }
                    .need-help-text, .faq-text {                        
                        font-size: var(--tooltip-font-size);
                        color: var(--primary-dark-color);
                        letter-spacing: 0;
                        line-height: 16px;
                        opacity: 0.93;
                        position:relative;
                        top:31px;
                    }
                    .copyright-msg {
                        font-size: var(--tooltip-font-size);
                        padding: 0px 0px 16px 29px;
                        position: relative;
                        bottom: 12px;
                    }
                    .atm-locator {                        
                        font-size: var(--tooltip-font-size);
                        color: var(--brand-color) !important;
                        letter-spacing: 0;
                        line-height: 16px;
                        opacity:0.93;
                    }
                   .login-container {
                        margin-top:-127px;
                        padding: 0px 12px;
                    }
                    .atm-locator-paper-button {
                        padding:8px 2px;
                        position:relative;
                        top:26px;
                    }                    
                    .bank-name {
                        text-align:center;
                        font-size: var(--a-font-size-l);  
                        color:var(--primary-light-color); 
                        line-height:20px;                     
                    }
                    .mobile-top-section {
                        width:100%;
                        text-align:center;                        
                        background-attachment: fixed;
                        background-repeat: no-repeat;
                        background-size: 100%;                        
                    }
                    .login-logo-padding {
                        padding: 20px 0px 0px 0px;
                        height: 330px;
                    }                    
                    .authenticate-message{                       
                        position: relative;
                        top: -100px;
                        padding:0px 12px;                                             
                        color: var(--primary-dark-color);
                        letter-spacing: 0;
                        line-height: 30px;
                    }
                    .password-authenticate {                       
                        padding:0px 12px;
                        opacity: 0.57;
                        font-size: var(--a-button-font-size-small);
                        color: var(--primary-dark-color);
                        letter-spacing: 0;                        
                    }
                    .login-primary-light-text-s {
                        position: relative;
                        top: -101px;
                        letter-spacing:1px;
                    }                    
                    .login-button {
                        position: relative;
                        top: -92px;
                        padding: 0px 83px !important;
                        margin-left: -16px;
                        background: var(--primary-color-but);
                    }
                    .login-cancel-button {
                        position: relative;
                        top: 36px;
                        padding: 0px 87px !important;
                        margin-left: -6px;
                        border: 1px solid var(--button-background-dark-color);
                        box-shadow: 0 2px 12px 0 var(--light-shadow-16);
                    }
                    .login-primary-light-textt-xl {
                        display:none;
                    }
                    .no-spacing-phone {
                        padding-bottom:29px;
                    }                   
                    .login-btn-section {
                        text-align:center;
                        position: relative;
                        top: 20px;
                        right:6px;
                    }
                    oe-input{
                        --paper-input-container-invalid-color:var(--primary-color-but);
                     }
                    .login-page-container, .slider-item {
                        width: 100%;
                        /* height: 100px; */
                        line-height: 0px;
                   }
                   /* .height-79px{
                        height:79px;
                   } */
                    .login-page-container {
                        width:90%;
                        margin: 0 auto;
                        /* height: 83px; */
                        text-align: center;
                        background: transparent;
                        position: relative;
                        overflow: hidden;   
                        margin-top:25px;                     
                   }
            
                    .slider-item {
                        /* position: relative; */
                        top: 0;
                        left: 500px;
                   }
                   .bottom-border{
                    border-bottom:1px solid lightgrey
                   }
                    .first {
                        left: 0;
                        opacity: 1;
                        z-index: 0;
                        background: var(--primary-light-color);
                   }
                   .static-first {
                        left: 0;
                        opacity: 1;
                        z-index: 0;
                        background: var(--primary-light-color);
                   }
                    .first {
                        animation: cycleone 20s ease-in-out infinite;
                   }
                    .second {
                        animation: cycletwo 20s ease-in-out infinite;
                        background: var(--primary-light-color);
                   }
                    .third {
                        animation: cyclethree 20s ease-in-out infinite;
                        background: var(--primary-light-color);
                   }
                    .fourth {
                        animation: cyclefour 20s ease-in-out infinite;
                        background: var(--primary-light-color);
                   }
                    @keyframes cycleone {
                        0% {
                            left: 0px;
                            opacity: 1;
                            z-index: 0;
                       }
                        20% {
                            left: 0px;
                            opacity: 1;
                            z-index: 0;
                       }
                        25% {
                            left: -500px;
                            opacity: 0;
                            z-index: 0;
                       }
                        26% {
                            left: -500px;
                            opacity: 0;
                            z-index: -1;
                       }
                        27% {
                            left: 500px;
                            opacity: 0;
                            z-index: -1;
                       }
                        95% {
                            left: 500px;
                            opacity: 0;
                            z-index: 0;
                       }
                        100% {
                            left: 0px;
                            opacity: 1;
                            z-index: 0;
                     }
                   }
                    @keyframes cycletwo {
                        0% {
                            left: 500px;
                            opacity: 0;
                       }
                        20% {
                            left: 500px;
                            opacity: 0;
                       }
                        25% {
                            left: 0px;
                            opacity: 1;
                       }
                        45% {
                            left: 0px;
                            opacity: 1;
                            z-index: 0;
                       }
                        50% {
                            left: -500px;
                            opacity: 0;
                            z-index: 0;
                       }
                        51% {
                            left: 500px;
                            opacity: 0;
                            z-index: -1;
                       }
                        100% {
                            left: 500px;
                            opacity: 0;
                            z-index: -1;
                       }
                   }
                    @keyframes cyclethree {
                        0% {
                            left: 500px;
                            opacity: 0;
                       }
                        45% {
                            left: 500px;
                            opacity: 0;
                            z-index: -1;
                       }
                        50% {
                            left: 0px;
                            opacity: 1;
                            z-index: 0;
                       }
                        70% {
                            left: 0px;
                           opacity: 1;
                            z-index: 0;
                       }
                        75% {
                            left: -500px;
                            opacity: 0;
                            z-index: 0;
                       }
                        76% {
                            left: 500px;
                            opacity: 0;
                            z-index: -1;
                       }
                        100% {
                            left: 500px;
                            opacity: 0;
                            z-index: -1;
                       }
                   }
                    @keyframes cyclefour {
                        0% {
                            left: 500px;
                            opacity: 0;
                            z-index: -1;
                       }
                        70% {
                            left: 500px;
                            opacity: 0;
                            z-index: 0;
                       }
                        75% {
                            left: 0px;
                            opacity: 1;
                            z-index: 0;
                       }
                        95% {
                            left: 0px;
                            opacity: 1;
                            z-index: 0;
                       }
                        100% {
                            left: -500px;
                            opacity: 0;
                            z-index: 0;
                       }
                   }
                   .sliding-text-font {
                    opacity: 0.93;
                    font-size: var(--a-font-size-l);
                    color: var(--primary-dark-color);
                    letter-spacing: 0;
                    line-height: 6px;
                   } 
                   .sliding-text-font-one {
                    opacity: 0.93;
                    font-size: var(--a-font-size-m);
                    color: var(--primary-dark-color);
                    letter-spacing: 0;
                    line-height: 6px;
                   } 
                   .sliding-text-font-heading {
                    font-size: var(--a-font-size-l);
                    color: var(--primary-dark-color);
                    letter-spacing: 0;
                    line-height: 6px;
                    font-weight : bold;
                   }
                   
                   .disp-flex {
                       display:flex;  
                       padding:10px 10px 10px 18px;                    
                   }    
                   .disp-flex-1 {
                       display:flex;  
                       padding:7px 10px 0px 18px;                    
                   }
                   .disp-flex-2 {
                       display:flex;  
                       padding:0px 10px 0px 0px;                    
                   }
                   .disp-flex-floating{
                        display:flex;  
                        z-index:1;
                        position : absolute;
                        width:100%;
                        height:100%;
                   }
                   .iron-icon-background{
                       background-color : lavender;
                       border-radius : 16px
                   }
                   .low-opacity {
                       opacity : 0.10
                   }

                   .slider-padding {
                       padding-left:18px;
                       text-align:left !important;
                   }     
                   .sliding-sub-text-font {
                    opacity: 0.57;
                    font-size: var(--a-font-size-m);
                    color: var(--primary-dark-color);
                    letter-spacing: 0;
                    line-height: 7px;
                   } 
                   .sliding-sub-text-font-one {
                    opacity: 0.57;
                    font-size: var(--a-font-size-s);
                    color: var(--primary-dark-color);
                    letter-spacing: 0;
                    line-height: 12px;
                   } 
                   .login-iron-icon, .login-page-iron-icon,  .login-page-icon{
                    margin: -25px 0px 0px 11px;
                    font-size: 14px;
                    opacity: 0.57;
                    color: var(--primary-dark-color);
                   }               
                   .custom-margin-light-input-style  {
                    border: 1px solid var(--brand-color) !important;
                    border-radius: 6px !important;
                    --primary-color: var(--light-input-style-light-color) !important;
                   }  
                   .login-page-iron-icon {
                       color:var(--brand-color);
                   }                  
                   .login-profile-hello{                        
                        opacity: 0.93;                                     
                        font-weight:800;
                        letter-spacing: 0;
                        line-height: 30px;
                   }  
                   .login-signin {
                    font-size: var(--a-button-font-size);
                    color: var(--primary-light-color);
                    letter-spacing: 0;
                   }
                   .login-confirm {
                    font-size: var(--a-button-font-size);
                    color: var(--primary-light-color);
                    letter-spacing: 0;
                   }
                   .login-cancel {                    
                    letter-spacing: 0;
                   }
                   .shadow-div {
                     height: 112px;
                     width: 100%;
                     position: relative;
                     top: 0px;

                   }
                   .explore-products {
                       font-size: var(--a-button-font-size);
                       color: var(--brand-color) !important; 
                       letter-spacing: 0;
                       line-height: 21px;
                   }
                    .profile-pic {
                       position:relative;
                       top:-99px;
                       left:11px;
                   }
                   .password-style {
                        border: 1px solid var(--brand-color);
                        border-radius: 6px;

                   }
                   .lock-icon {
                       margin: -26px 7px 0px 11px !important;
                   }
                   .loader-mobile-background {
                        background-color: var(--primary-dark-color) !important; 
                        opacity: 0.57;
                        height: 100vh;
                        width:100%;
                        position: relative; 
                        max-height: 100vh !important;
                        max-width: 100vh !important;   
                        margin:0px !important;
                    }
                    .pre-loader-logo{
                        width:50px;
                        display:block;                   
                        margin-left: auto;
                        margin-right: auto;
                    }
                    .pre-loader-text {
                        color:var(--primary-light-color); 
                        text-align:center;
                        margin: 10px auto;
                    }
                    .sub-pre-loader {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        margin-right: auto;
                        transform: translate(-50%, -50%);
                        margin-left: auto;
                    }
                    .oehbox-opacity {
                        opacity:0;
                    }
					.user-name-position-phone{
                        position: relative;
                        top: -99px;
                        left: 8px;
                    }
                    .user-name-font-phone{
                      color: var(--primary-dark-color) !important;
                    }
                }
                @media (min-width:360px) and (max-width:361px){
                    .login-primary-button {                        
                        margin-left: -8px;                        
                        padding: 20px 107px !important;
                    }
                   .login-button {
                        padding: 20px 102px !important;
                    }
                    .login-cancel-button {
                        padding: 0px 105px !important;
                        left:-1px !important;
                    }
                }
                @media (min-width:411px) and (max-width:412px){
                    .login-primary-button {                        
                        margin-left: -8px;    
                        padding: 20px 130px !important;
                    }
                    .login-button {
                        padding: 20px 125px !important;
                    }
                    .login-cancel-button {
                        padding: 0px 128.5px !important;
                        left:-1px;
                    }
                    .login-page-container {                        
                        margin-top: 27px;
                    }
                }
                @media (min-width:375px) and (max-width:376px){
                    .login-primary-button {                       
                        margin-left: -12px;                        
                        padding: 20px 114px !important;
                    }
                    .login-button {
                        padding: 20px 109px !important;
                        margin-left: -18px;
                    }
                    .login-cancel-button {
                        padding: 0px 113px !important;
                        margin-left:-9px;
                    }
                    .login-page-container {
                        margin-top: 24px;
                    }
                }
                @media (min-width:414px) and (max-width:415px){
                    .login-primary-button {                       
                        margin-left: -12px;
                        padding: 20px 131px !important;
                    }
                    .login-button {
                        padding: 20px 126px !important;
                        margin-left: -9px;
                    }
                    .login-cancel-button {
                        padding: 0px 129px !important;
                        left:-1px;
                    }
                }
                @media (max-width:375px) {
                    .login-position-relative {
                        top:-78px;
                    }
                }
                @media (min-width:376px) and (max-width:479px) {
                    .login-position-relative {
                        top:-75px;
                    }
                }
                @media (min-width:320px) and (max-width:321px){ 
                    .login-position-relative {
                        top: -94px;
                    }                    
                    .login-button {                       
                        padding: 0px 85px !important;
                    }
                    .login-cancel-button {
                        padding: 0px 89px !important;
                    }
                    .login-page-container {
                        margin-top: 14px;
                    }
                }
            fin-auth-element-wrapper {
				--message-style: {
					color: var(--primary-light-color);
				}
				--app-border-color: var(--primary-light-color);
				--app-font-color: var(--primary-light-color);
				--font-style: {
					color: var(--primary-light-color);
				}
			}
			
			app-fab {
              --avatar-style: {
                 font-size: 40px;
              }
            }

            .margin_auto {
                margin : auto;
            }
			
			/* Login-Background */
			
			.display-none{
               display: none;
           }
		   
			.login_bckground{
				/*background-image: url(node_modules/sb_Registration_ui/images/en-US/BOB-login-picture.jpg);*/
                background-image:url(node_modules/speedboat_ui/images/NBBUAE/Newbackground.jpg);
			}
			
			div.banner_bckground{
				transform: none;
				background: white;
				border-radius:10px;
			}
			
			.login_container{
				/*margin: 0 auto;*/
				width: 37% !important;
				/*min-height: 625px;*/
			}
			 
			
			.login_text{
                font-size: 20px;
                font-weight: 700;
			}
			.login_logo_div{
				padding-left:0px;
				padding-top:15px;
			}
			div.banner-skew {
                height: 80%;
				top: 6.6vw !important;
			}
			.black_text{
				color:black;
				--paper-input-container-color: black;
				--paper-input-container-input_-_color: black;
				--paper-input-container-shared-input-style_-_color: black !important;
				--paper-input-container_-_min-height:54px;
			}
			.sign_button{
				width:330px;
				border-radius:8px;
			}
			.login_cont_lower{
				margin-left:12% !important;
			}
			.login_cont_upper{
				margin-left:12% !important;
			}
			.frget_pswd_div{
				margin-bottom:25px;
			}
			.frget_pswd_container{
				padding: 0PX !IMPORTANT;
				margin: 0px !IMPORTANT;
				JUSTIFY-CONTENT: normal;
				width: 100%;
				margin-bottom:25px;
			}
			.red_text{
                font-size:14px;
				/*color:red;
				font-weight:bold;
				text-decoration:underline;*/
			}
			.fright{
				float:right;
			}
      /* 13-July-2020 */
      @media (max-width: 479px){
        .info{
            display: flex;
            margin: 20px 0px 0px 0px;
        }
        .login_logo_div{
            padding: 0px 12px;
        }
        .login_container{
          width: 88% !important;
        min-height: 70%;
        }
        div.banner-skew{
          height: 80%;
          min-height: 500px;
        }
        .login_cont_upper{
          margin-left: 2% !important;
        }
        .login_cont_lower{
          margin-left: 2% !important;
        }
        .sign_button{
          width: 180px;
        }
        #btn_loginCancel, #btn_loginConfirm{
          padding: 4px;
          margin: 4px;
        }
        /* 13-July-2020 */

        /* 30-July-2020 */
        div.banner_bckground {
          background: transparent;
        }
        div.banner_bckground_mobile{
            transform: none;
            background: white;
            border-radius:10px;
            padding:10% 3.5%;
        }

        div.banner-skew:before{
          background:none;
        }
        paper-input-container input{
          color: white !important;
        }
		.login-position-relative {
			top:75px !important;
		}
		.login-container {
			margin-top:10px;
		}
      .mobile_login_text{
          font-size:18px;
          font-weight:700;
      }
      .mobile_info_text{
          font-size:12px;
          font-weight:700;
      }
      .mobile_text{
         font-size: 12px;
         font-weight: 700;
        margin-top: 10%;
      }
      .info-text-icon {
          margin-right: 10px;
      }
      .mobile-login-button {
           padding: 20px 130px !important;
           top: 0px;
       }
       .mobile-login-cancel-button {
          top: 0px;
       }
       .mb-top {
          top: 3% !important;
          left: 25px;
       }
       .black_text{
          --paper-input-container-color: none;
      }
      .login-button {
         top: 0px
      }
      .lock-icon {
        margin: -4px 7px 0px 11px !important;
    }
    #originalU{
        --paper-input-container-underline-focus_-_bottom: none;
     --paper-input-container-underline-focus_-_background: none;
     --paper-input-container-label-floating_-_top: 20px;
      --paper-input-container-label-floating_-_left: 50px;
      --paper-input-container-input_-_top: 12px;
      --paper-input-container-label-floating_-_color: #00839B!important;
      --paper-input-container-label_-_padding: 10px 0 6px 15px;
    }
    }
      /* 13-July-2020 */

      @media (max-width: 839px) and (min-width: 480px){
            .disp-only-in-mobile{
                display:none;
            }   
            .login_logo_div{
                padding-top:15%;
            }
            div.banner-skew {
                height: 90%;
                top: 3.6vw !important;
            }
            .login_container {
                min-height: 70%;
                margin-left: 15%;
                width:70% !important;
            }
            .login_container_padd{
                padding:5% 7% 5% 7%;
                min-height: 400px;
			}
            .info-block {
                display: flex;
                margin: 12px 0px;
            }
            .info-block span {
                font-family: SF Pro Display;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 21px;
                display: flex;
                align-items: center;
                letter-spacing: 0.103271px;    
                color: #292E33;
                width: 87%;
            }
            .usernameInput{
                --border-thick: 1px;
                --border-color: #F4F5F7;
                --label-color: #828282;
                --prefix-color: #828282;
                --suffix-color: #828282;
                --paper-input-container-label-floating_-_left: 8px !important;
                --paper-input-container-shared-input-style_-_width: 90% !important;
                --paper-input-container: {
                  font-family: SF Pro Display!important;
                  font: SF Pro Display!important;
                  padding: 0px 0!important;
                  border-width: 0px;
                  box-sizing: border-box;
                  background-color: #F4F5F7;
                  background: #F4F5F7;
                  min-height: 54px;
                }
                --paper-input-container-invalid-color: {
                    color: #636C75;
                }
                --paper-input-container-suffix: {
                    padding: 4px 10px 0 0 !important;
                }

                --paper-input-container-label: {
                    padding: 18px 0 6px 15px;
                    font-family: SF Pro Display;
                    color: var(--label-color, #f4f5f7);
                }

                --paper-input-container-label: {
                    top: 8px;
                }

                --paper-input-container-input: {
                    top: 8px!important;
                    left: 21px!important;
                }

                --paper-input-container-label-floating: {
                    top: 14px;
                    left: 10px;
                    color: #00839B!important;
                }

                --paper-input-container-focus-color: #00839B;
    
                --paper-input-container-underline: {
                    display: none;
                }
    
                --paper-font-caption: {
                    display: none;
                }
    
                --paper-input-container-underline-focus: {
                   position: absolute;
                   left: 0%;
                   right: 0%;
                   bottom: 0%;
                   margin-top:15px!important;
                   background: #00839B;
                  }
    
                --oe-label-mixin: {
                    padding-left: 20px;
                    font-size: 16px!important;
                   color: #636C75;
                }
                --paper-input-container-label_-_padding: 0px 0 6px 15px;
                --paper-input-container-input_-_top: 0px;
                --paper-input-container-input_-_left: 15px;
            }
            .forgot-username {
                color: #00839B;
                font-size: 16px;
                line-height: 17px;
                margin: 15px 0px;
                height: 17px;
            }
            paper-button.primary-button {
                background-color: #003d4c;
                font-family: SF Pro Display;
                font-size: 16px;
                font-weight: 700;
                box-shadow: none;
                transition: all 0.4s;
                --paper-button_-_color: rgba(255,255,255,1);
                --paper-button_-_min-width: 140px;
                --paper-button_-_height: 50px;
                --paper-button_-_font-size: 16px;
                --paper-button_-_letter-spacing: 0;
                --paper-button_-_line-height: 24px;
                --paper-button_-_text-shadow: 0 1px 2px rgba(--button-text-shadow-color);
                --paper-button_-_text-transform: capitalize;
                --paper-button_-_padding: initial;
                --paper-button_-_margin: initial;
            }
            .sign_button {
                width: 100%;
                border-radius: 4px;
                margin-left: 0px;
            }
            .info{
                display: flex;
                margin: 20px 0px;
            }
            .imp-text {
                color: #636c75;
                font-size: 12px;
                /*width: 346px;*/
                line-height: 18px;
            }
            .cancel-button {
                width: 100%;
                border-radius: 4px;
                margin-left: 0px;
                min-height: 50px;
                margin: 10px 0px;
                box-shadow: none;
                color: #00839B;
                text-transform: capitalize;
                font-family: 'SF Pro Display';
                font-size: 16px;
            }
        }
        /* 22- FEB - 2022 */
        #emailAddress{ 
            --oe-required-mixin: {
            display:inherit;
            }
            background: #F4F5F7;
            border-radius: 5px;
            --paper-input-container-underline: {
            display: none;
            }
            --paper-font-caption: {
                display: inline-block; /* For error msg */
                font-size:14px!important;
                }
                --errorclass-padding-top:15px;
            --paper-input-container-underline-disabled: {
                    display: none;
                }
            --paper-input-container-underline-focus_-_margin-top: 10px;
            --paper-input-container-input_-_top: 10px;
            --paper-input-container-input_-_left: 15px;
            --paper-input-container-label-floating_-_left: 5px !important;
            --paper-input-container-label-floating_-_top: 15px !important;
            --paper-input-container-label_-_top: 0px !important;
            --oe-label-mixin_-_color:#828282;
            --paper-input-container-label_-_padding-left: 15px !important;
            
        }
        .buttonAlignment{
            flex-direction: column;
            gap: 15px;
        }
        .view-port::-webkit-scrollbar {
            display: none;
        }
         .reset-link_container{
            margin: 1vh 0vh;
        }
        .inlineErrorSpacing{
            --paper-input-error_-_margin-top:10px;
            --paper-input-container-invalid-color: var(--secondary-color-but);
            --paper-font-caption: {
                display: inline-block; /* For error msg */
                 font-size:12px!important;
            }
          }
          oe-input { 
            --oe-required-mixin: { 
            display:inherit; 
        }
      }
	  #index_paperToolbar{
        background : #003d4c;
        --paper-toolbar-height: 56px;
        }
        .secure-text-icon {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #fff;
            margin-top: 10px;
            justify-content: flex-end;
        }
        .secure-text-icon iron-icon {
            margin-left: 10px;
        }
        .mdl-cell.mdl-cell--12-col.div-transfer {
            margin:0!important;
        }
        @media (min-width: 840px) {
            .mdl-cell--12-col, .mdl-cell--12-col-desktop.mdl-cell--12-col-desktop {
                width: calc(100% - 0px);
            }
        }
        /* 22- FEB - 2022 */
        @media (min-width: 840px) {
            div.banner-skew {
                height: 80%;
                top: 3.6vw !important;
            }
            .login_container {
                margin-left: 8.5%;
                width:30.3% !important;
            }
            .login_container_padd{
                padding:3% 7% 3% 7%;
                min-height: 400px;
			}
            .info-block {
                display: flex;
                margin: 12px 0px;
            }
            .info-block span {
                font-family: SF Pro Display;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 21px;
                display: flex;
                align-items: center;
                letter-spacing: 0.103271px;    
                color: #292E33;
                width: 87%;
            }
            .usernameInput{
                --border-thick: 1px;
                --border-color: #F4F5F7;
                --label-color: #828282;
                --prefix-color: #828282;
                --suffix-color: #828282;
                --paper-input-container-label-floating_-_left: 8px !important;
                --paper-input-container-shared-input-style_-_width: 90% !important;
                --paper-input-container: {
                  font-family: SF Pro Display!important;
                  font: SF Pro Display!important;
                  padding: 0px 0!important;
                  border-width: 0px;
                  box-sizing: border-box;
                  background-color: #F4F5F7;
                  background: #F4F5F7;
                  min-height: 54px;
                }
                --paper-input-container-invalid-color: {
                    color: #636C75;
                }
                --paper-input-container-suffix: {
                    padding: 4px 10px 0 0 !important;
                }

                --paper-input-container-label: {
                    padding: 18px 0 6px 15px;
                    font-family: SF Pro Display;
                    color: var(--label-color, #f4f5f7);
                }

                --paper-input-container-label: {
                    top: 8px;
                }

                --paper-input-container-input: {
                    top: 8px!important;
                    left: 21px!important;
                }

                --paper-input-container-label-floating: {
                    top: 14px;
                    left: 10px;
                    color: #00839B!important;
                }

                --paper-input-container-focus-color: #00839B;
    
                --paper-input-container-underline: {
                    display: none;
                }
    
                --paper-font-caption: {
                    display: none;
                }
    
                --paper-input-container-underline-focus: {
                   position: absolute;
                   left: 0%;
                   right: 0%;
                   bottom: 0%;
                   margin-top:15px!important;
                   background: #00839B;
                  }
    
                --oe-label-mixin: {
                    padding-left: 20px;
                    font-size: 16px!important;
                   color: #636C75;
                }
                --paper-input-container-label_-_padding: 0px 0 6px 15px;
                --paper-input-container-input_-_top: 0px;
                --paper-input-container-input_-_left: 15px;
            }
            .forgot-username {
                color: #00839B;
                font-size: 16px;
                line-height: 17px;
                margin: 15px 0px;
                height: 17px;
            }
            paper-button.primary-button {
                background-color: #003d4c;
                font-family: SF Pro Display;
                font-size: 16px;
                font-weight: 700;
                box-shadow: none;
                transition: all 0.4s;
                --paper-button_-_color: rgba(255,255,255,1);
                --paper-button_-_min-width: 140px;
                --paper-button_-_height: 50px;
                --paper-button_-_font-size: 16px;
                --paper-button_-_letter-spacing: 0;
                --paper-button_-_line-height: 24px;
                --paper-button_-_text-shadow: 0 1px 2px rgba(--button-text-shadow-color);
                --paper-button_-_text-transform: capitalize;
                --paper-button_-_padding: initial;
                --paper-button_-_margin: initial;
            }
            .sign_button {
                width: 100%;
                border-radius: 4px;
                margin-left: 0px;
            }
            .info{
                display: flex;
                margin: 20px 0px;
            }
            .imp-text {
                color: #636c75;
                font-size: 12px;
                /*width: 346px;*/
                line-height: 18px;
            }
            .cancel-button {
                width: 100%;
                border-radius: 4px;
                margin-left: 0px;
                min-height: 50px;
                margin: 10px 0px;
                box-shadow: none;
                color: #00839B;
                text-transform: capitalize;
                font-family: 'SF Pro Display';
                font-size: 16px;
            }
        }
        /* 22- FEB - 2022 */
        #emailAddress{ 
            --oe-required-mixin: {
            display:inherit;
            }
            background: #F4F5F7;
            border-radius: 5px;
            --paper-input-container-underline: {
            display: none;
            }
            --paper-font-caption: {
                display: inline-block; /* For error msg */
                font-size:14px!important;
                }
                --errorclass-padding-top:15px;
            --paper-input-container-underline-disabled: {
                    display: none;
                }
            --paper-input-container-underline-focus_-_margin-top: 10px;
            --paper-input-container-input_-_top: 10px;
            --paper-input-container-input_-_left: 15px;
            --paper-input-container-label-floating_-_left: 5px !important;
            --paper-input-container-label-floating_-_top: 15px !important;
            --paper-input-container-label_-_top: 0px !important;
            --oe-label-mixin_-_color:#828282;
            --paper-input-container-label_-_padding-left: 15px !important;
            
        }
        .buttonAlignment{
            flex-direction: column;
            gap: 15px;
        }
        .view-port::-webkit-scrollbar {
            display: none;
        }
         .reset-link_container{
            margin: 1vh 0vh;
        }
        .inlineErrorSpacing{
            --paper-input-error_-_margin-top:10px;
            --paper-input-container-invalid-color: var(--secondary-color-but);
            --paper-font-caption: {
                display: inline-block; /* For error msg */
                 font-size:12px!important;
            }
          }
          oe-input { 
            --oe-required-mixin: { 
            display:inherit; 
            } 
        }
        .tickerMessageDialog{
            --dialog-background-color_-_background-color: #003d4c !important;
            --app-dialog-width:50%;
            --app-dialog-min-height: 12%;
            
        }
        .ticker-div{
            padding: 4px 0px 10px 4px;
        }
        .scroll-padding{
            padding-bottom: 150px !important;
        }
        paper-button.confirm-email{
            height: auto !important;
            --paper-button_-_padding: 3px;
        }
        #btn_sendCodeToEmailmsg {
            color: #003d4c !important;
        }
        .otp-expiry-countdown{
            margin: 10px;
            color: var(--critical-label-color);
        }
        #forgetUserName{
            --paper-input-container_-_min-height: 42px;
            --paper-input-container-label-floating_-_top:23px;
            --paper-input-container-label-floating_-_left: 6px !important;
            --paper-input-container-input_-_top: 12px!important;
        }
        .info-text-icon{
            padding-right: 5px;
        }
        
           </style>
        <!-- ajax call to fetch the decrypted data from URL user migration mvf:-289442  -->
          <oe-ajax id="userMigartionLogin_ajax" method="post" handle-as="json" content-type="application/json" url="/usermigrationLogin"
          on-response="fetchencryptedData" ></oe-ajax>
          <oe-ajax id="userTheme_ajax" method="get" handle-as="json" content-type="application/json" 
          on-response="themeSetting"></oe-ajax>
         <!-- Security - OS and App version check @Start-->
         <oe-ajax id="osnappchecks" method="post" content-type="application/json" on-response="handleOSnAppChecksResponse"
             on-error="handleOSnAppChecksError"></oe-ajax>
         <!-- Security - OS and App version check @End-->
         <oe-ajax id="loginmode" method="post" content-type="application/json" on-response="handleLoginModeResponse"
             on-error="handleLoginModeError"></oe-ajax>
         <oe-ajax id="tickermessageapi" method="post" content-type="application/json" on-response="handleTickerMessageResponse"
             on-error="handleTickerMessageError"></oe-ajax>
         <oe-ajax id="loginValidate" method="post" content-type="application/json" on-response="handleResponse" on-error="handleError"></oe-ajax>
         <!-- api for email otp -->
         <oe-ajax id="emailValidate" method="post" content-type="application/json" on-response="handleEmailresponse" on-error="handleError"></oe-ajax>
         <!-- api for changeauthmode -->
         <oe-ajax id="authModeChange" method="post" content-type="application/json" on-response="handleAuthModeresponse" on-error="handleError"></oe-ajax>
         <!-- api for resendOTP -->
         <oe-ajax id="resendOTP" method="post" content-type="application/json" on-response="handleresendOTPresponse" on-error="handleError"></oe-ajax>
         <!-- api for forgetUserName -->
         <oe-ajax id="forgetUserName" method="post" content-type="application/json" on-response="handleforgetUserNameresponse" on-error="handleError"></oe-ajax>
         <!-- api for forgetUserNameConfirm -->
         <oe-ajax id="forgetUserNameConfirm" method="post" content-type="application/json" on-response="handleforgetUserNameConfirmresponse" on-error="handleError"></oe-ajax>
         <!--API to login to stage login API -->
         <oe-ajax id="stageLoginValidate" method="post" content-type="application/json" on-response="handleResponseStageLogin" on-error="handleErrorStageLogin"></oe-ajax>
         <oe-ajax id="deepmenuconfig" method="get" content-type="application/json" on-response="handleDeepMenuResponse" on-error="handleDeepMenuError"></oe-ajax>
         <oe-ajax id="homecurrency" content-type="application/json" handle-as="json" url="/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=HOME_CUR_CODE" method="get" on-response="setHomeCurrency" on-error="_showError"></oe-ajax>
         <oe-ajax id="homecountry" content-type="application/json" handle-as="json" url="/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=HOME_COUNTRY" method="get" on-response="setHomeCountry" on-error="_showError"></oe-ajax>
         <oe-ajax id="bannerimages" url="/api/codereferences?filter[where][codeType]=BNR" method="get" handle-as="json" content-type="application/json" on-response="setBannerImageDetails"></oe-ajax>

         <!-- <oe-ajax id="socialLogin" method="post" content-type="application/json" on-response="handleResponse" on-error="handleError"></oe-ajax> -->
         <sb-app-localstorage-document session-only key="navigationLink" data="{{navigationLink}}"></sb-app-localstorage-document>
         <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
         <!-- <literal-cache></literal-cache> -->
         <template is="dom-if" if="{{!phone}}">
            <paper-dialog id="spinnerCard" modal>
                <div><oe-i18n-msg id="spinner-dialog"></oe-i18n-msg></div>
                <oe-hbox class="center-justified layout">
                    <paper-spinner id="confirm-spinner"></paper-spinner>
                </oe-hbox>
            </paper-dialog>
         </template>
         <div hidden$="{{!showTickerMessage}}">
            <app-dialog class="tickerMessageDialog"   id="ticker-message" elementid="ticker-message-dialog" closevisible="{{closevisible}}" closevisiblelabel={{closevisiblelabel}} modal>
                <div class="mdl-grid-no-spacing">    
                    <div class="ticker-div">
                        <div class="mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-grid padding-lr-zero padding-t-zero">
                            <oe-i18n-msg msgid="" class="font-size-s imp-notification mdl-cell--middle font-medium critical-color-new">Important Notification!!!</oe-i18n-msg>
                        </div>
                        <div id="tickerMessageDiv" class="style-scope font-size-s font-medium mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col padding-lr-zero text-align-left">
                        </div>
                    </div>
                </div>
            </app-dialog>
        </div>
         <template is="dom-if" if="{{phone}}">
            <paper-dialog id="spinnerCard" modal class="loader-mobile-background">
                <div id="spinner-dialog">
                    <div class="sub-pre-loader">
                        <img alt="loading" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/loader/your-bank-logo.gif" class="pre-loader-logo loader-mobile">
                        <p class="pre-loader-text">While we are loading...</p> 
                    </div>
                </div>
                 <oe-hbox class="center-justified layout oehbox-opacity">
                    <paper-spinner id="confirm-spinner"></paper-spinner>
                </oe-hbox>
            </paper-dialog>
         </template>
         
 
      <!-- Security - OS and App version check @Start-->
      <iron-pages id="selected" selected="{{selectedPage}}">
        <div id="share-session-wrapper" class="">
        <template is="dom-if" if={{_selectedPageChanged(selectedPage,0)}}>
       
          <div hidden$="{{userMigrationFlag}}"> 
             <!-- Security - OS and App version check @End-->
             <div class="content-wrapper mdl-grid mdl-grid--no-spacing view-port   login_bckground" phone$="{{phone}}" style = "background-size:cover;height:93%">
 
 
 
                 <!--for desktop view only-->
                 <div class="mdl-cell--6-col-desktop mdl-cell--hide-phone mdl-cell--hide-tablet full-height-desktop mdl-cell--hide-desktop"
                     phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" role="region" aria-labelledby="welcomeCarousel">
                     <iron-image id="backgroundImg" class="full-width full-height-desktop" placeholder="data:image/jpg;base64,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
zBZ8Hjwl/C28NYw9TEUcTOxUvFyMZGxsPHQce/yD3IvMk6ybnKOMq3yzbLtsw1zLXNNc21zjbOts83z7jQOdC60TzRvtI/0sHTRNPG1EnUy9VO1dHWVdbY11zX4Nhk2OjZbNnx2nba+9uA3AXcit0Q3ZbeHN6i3ynfr+A24L3hROHM4lPi2+Nj4+vkc+T85YTmDeaW5x/nqegy6LzpRunQ6lvq5etw6/vshu0R7ZzuKO6070DvzPBY8OXxcvH/8ozzGfOn9DT0wvVQ9d72bfb794r4Gfio+Tj5x/pX+uf7d/wH/Jj9Kf26/kv+3P9t////2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAADAAUDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDj/wDgjV471Hwt+xbpVvp/2C1SS7nmlZNPt/MncyMN0j7N0hCqqgsThVAGAAKKKKAP/9k="
                         sizing="cover" preload src="{{backgroundImgSrc}}" desktop$="{{desktop}}"></iron-image>
 
                     <!-- <div id="welcomeCarousel" hidden>
                         <oe-i18n-msg msgid="l_Welcome"></oe-i18n-msg>
                     </div> -->
                     <reg-carousel class="position-absolute-t-l half-width full-height" page="0"></reg-carousel>
                 </div>
                 <!--for desktop view only-->
                 <div class="mobile-top-section disp-only-in-mobile display-none-phone"  style="display:none" id="mobile_background" on-click="_ShowSlider">  
                   <div class="login-logo-padding">                
            <!--  <img src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/login/logo_1.png" id="custom-imageee" alt="Your Bank">
                  <p class="bank-name">Your Bank</p> -->

                    <template is="dom-if" if="{{!viewBalanceFeatureDisabled}}">

                    <template is="dom-if" if="{{viewBalanceButton}}" restamp>
                    <div class="login-page-container full-height" id="custom-slider" hidden$='[[showNotification]]'>
                            <div class="innerr">
                                <div id="one" class="position-absolute slider-item third">
                                        <div>
                                                <div class="row disp-flex-floating content-align-center">
                                                    <paper-button class="text-brand-color" on-tap="viewQuickBalance" disabled$={{!asyncImportsLoaded}}>
                                                        <oe-i18n-msg msgid="b_View"></oe-i18n-msg>&nbsp;
                                                        <oe-i18n-msg msgid="h_balance"></oe-i18n-msg>

                                                    </paper-button>
                                                </div>
                                            <div id="accountHeading" class="row disp-flex-1 low-opacity">
                                                <div class="slider-padding padding-l-zero mdl-cell mdl-cell--3-col-phone">
                                                    <oe-i18n-msg class="sliding-text-font-heading" msgid ="{{quickBalanceAccountData.0.accountId}}"></oe-i18n-msg>&nbsp;
                                                    <!-- <oe-i18n-msg class="sliding-text-font-heading" msgid = "{{accountMask('**8432')}}"></oe-i18n-msg> -->
                                                </div>
                                                <div
                                                    class="slider-padding padding-l-zero mdl-cell mdl-cell--1-col-phone margin-zero content-align-vertical-center content-align-horizontal-end">
                                                    <template is="dom-if" if="{{!viewBalanceButton}}" restamp>
                                                        <iron-icon icon="refresh"></iron-icon>
                                                    </template>
                                                </div>
                                            </div>
                                            <div id="accountAvailableBalance" class="row disp-flex-2 low-opacity">
                                                <div class="slider-padding mdl-cell mdl-cell--4-col-phone margin-b-zero">
                                                    <oe-i18n-msg class="sliding-sub-text-font-one" msgid = "l_TotalBalance"></oe-i18n-msg>&nbsp;&nbsp;
                                                    <currency-formator class="sliding-text-font-one" format-value="{{quickBalanceAccountData.0.totalBalance}}"></currency-formator>
                                                    <!-- <oe-i18n-msg class="sliding-text-font-one" msgid = "{{quickBalanceAccountData.0.totalBalance}}"></oe-i18n-msg> -->
                                                </div>
                                            </div>
                                            <div id="accountCurrentBalance" class="row disp-flex-2 low-opacity">
                                                <div class="slider-padding mdl-cell mdl-cell--3-col-phone">
                                                    <oe-i18n-msg class="sliding-sub-text-font-one" msgid = "l_AvailableBalance"></oe-i18n-msg>&nbsp;&nbsp;
                                                    <currency-formator class="sliding-text-font-one" format-value="{{quickBalanceAccountData.0.availableBalance}}"></currency-formator>
                                                    <!-- <oe-i18n-msg class="sliding-text-font-one" msgid="{{quickBalanceAccountData.0.availableBalance}}"></oe-i18n-msg> -->
                                                </div>
                                                <div class="slider-padding mdl-cell mdl-cell--1-col-phone margin-zero content-align-horizontal-end">
                                                    <template is="dom-if" if="{{!viewBalanceButton}}" restamp>
                                                        <iron-icon hidden$="{{viewExpandMoreBtn}}" class="outlineOffset iron-icon-background" icon="expand-more" on-tap="dropDownList" tabindex="0"></iron-icon>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                <div id="two" class="position-absolute slider-item second" >
                                    <div class="row disp-flex">
                                        <div role="img">
                                        <img alt="slider1" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/login/slider-icon.png">
                                        </div>
                                        <div class="slider-padding">
                                        <p class="sliding-text-font">Investments</p>
                                        <p class="sliding-sub-text-font">Lorem Ipsum is simply</p>
                                        </div>
                                    </div>
                                </div>
                                <div id="three" class="position-absolute slider-item first" >
                                    <div class="row disp-flex">
                                        <div role="img">
                                        <img alt="slider2" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/login/slider-icon.png">
                                        </div>
                                        <div class="slider-padding">
                                        <p class="sliding-text-font">Loans</p>
                                        <p class="sliding-sub-text-font">Lorem Ipsum is simply</p>
                                        </div>
                                    </div>
                                </div>
                                <div id="four" class="position-absolute slider-item fourth" >
                                    <div class="row disp-flex">
                                        <div role="img">
                                        <img alt="slider3" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/login/slider-icon.png">
                                        </div>
                                        <div class="slider-padding">
                                        <p class="sliding-text-font">Others</p>
                                        <p class="sliding-sub-text-font">Lorem Ipsum is simply</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    </template>

                    <template is="dom-if" if="{{!viewBalanceButton}}" restamp>

                        <div class="login-page-container full-height" id="custom-slider" hidden$='[[showNotification]]'>
                            <div class="innerr">
                            <template is="dom-if" if="{{!displayTransactionList}}">
                                <div id="one" class="position-relative slider-item static-first">
                                        <div>
                                            <template is="dom-if" if="{{viewBalanceButton}}" restamp>
                                                <div class="row disp-flex-floating content-align-center">
                                                    <paper-button class="text-brand-color" on-tap="viewQuickBalance" disabled$ = {{viewBalanceFeatureDisabled}}>
                                                        <!-- <oe-i18n-msg msgid="b_View BALANCE"></oe-i18n-msg> -->
                                                    </paper-button>
                                                </div>
                                            </template>
                                            <div id="accountHeading" class="row disp-flex-1 ">
                                                <div class="slider-padding padding-l-zero mdl-cell mdl-cell--3-col-phone">
                                                    <oe-i18n-msg class="sliding-text-font-heading" msgid = {{quickBalanceAccountData.0.accountId}}></oe-i18n-msg>&nbsp;
                                                    <!-- <oe-i18n-msg class="sliding-text-font-heading" msgid = "{{accountMask('**8432')}}"></oe-i18n-msg> -->

                                                </div>
                                                <div
                                                    class="slider-padding padding-l-zero mdl-cell mdl-cell--1-col-phone margin-zero content-align-vertical-center content-align-horizontal-end">
                                                    <template is="dom-if" if="{{!viewBalanceButton}}" restamp>
                                                        <iron-icon icon="refresh" on-tap="refreshAccountBalance" tabindex="0" class="outlineOffset"></iron-icon>
                                                    </template>
                                                </div>
                                            </div>
                                            <div id="accountAvailableBalance" class="row disp-flex-2 ">
                                                <div class="slider-padding mdl-cell mdl-cell--4-col-phone margin-b-zero">
                                                    <oe-i18n-msg class="sliding-sub-text-font-one" msgid = "{{quickBalanceAccountData.0.totalBalanceHeader}}"></oe-i18n-msg>&nbsp;&nbsp;
                                                    <currency-formator class="sliding-text-font-one" format-value="{{quickBalanceAccountData.0.totalBalance}}"></currency-formator> 
                                                    <!--<oe-i18n-msg class="sliding-text-font-one" msgid = "{{quickBalanceAccountData.0.totalBalance}}"></oe-i18n-msg>{{quickBalanceAccountData.0.totalBalance}}-->
                                                </div>
                                            </div>
                                            <div id="accountCurrentBalance" class="row disp-flex-2">
                                                <div class="slider-padding mdl-cell mdl-cell--3-col-phone">
                                                    <oe-i18n-msg class="sliding-sub-text-font-one" msgid = "{{quickBalanceAccountData.0.availableBalanceHeader}}"></oe-i18n-msg>&nbsp;&nbsp;
                                                    <currency-formator class="sliding-text-font-one" format-value="{{quickBalanceAccountData.0.availableBalance}}"></currency-formator>
                                                    <!-- <oe-i18n-msg class="sliding-text-font-one" msgid="{{quickBalanceAccountData.0.availableBalance}}"></oe-i18n-msg> -->
                                                </div>
                                                <div class="slider-padding mdl-cell mdl-cell--1-col-phone margin-zero content-align-horizontal-end">
                                                    <template is="dom-if" if="{{!viewBalanceButton}}" restamp>
                                                        <iron-icon hidden$="{{viewExpandMoreBtn}}" class="outlineOffset iron-icon-background" icon="expand-more" on-tap="dropDownList" tabindex="0"></iron-icon>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                </template>

                                <template is="dom-if" if="{{displayTransactionList}}" restamp>
                                    <template is="dom-repeat" items="{{quickBalanceAccountData}}" restamp>
                                        <div class="position-relative bottom-border slider-item static-first">
                                        <div>
                                            <div id="accountHeading_{{index}}" class="row disp-flex-1">
                                                <div class="slider-padding padding-l-zero mdl-cell mdl-cell--4-col-phone">
                                                    <oe-i18n-msg class="sliding-text-font-heading" msgid="{{item.accountId}} {{item.accountNumber}}">
                                                    </oe-i18n-msg>
                                                </div>
                                            </div>

                                            <div id="accountAvailableBalance_{{index}}" class="row disp-flex-2">
                                                <div class="slider-padding mdl-cell mdl-cell--4-col-phone margin-b-zero">
                                                    <oe-i18n-msg class="sliding-sub-text-font-one" msgid="{{item.availableBalanceHeader}}"></oe-i18n-msg>&nbsp;&nbsp;
                                                    <currency-formator class="sliding-text-font-one" format-value="{{item.availableBalance}}"></currency-formator>
                                                    <!-- <oe-i18n-msg class="sliding-text-font-one" msgid="USD {{item.availableBalance}}"> -->
                                                    </oe-i18n-msg>
                                                </div>
                                            </div>

                                            <div id="accountCurrentBalance_{{index}}" class="row disp-flex-2">
                                                <div class="slider-padding mdl-cell mdl-cell--3-col-phone">
                                                    <oe-i18n-msg class="sliding-sub-text-font-one" msgid="{{item.totalBalanceHeader}}"></oe-i18n-msg>&nbsp;&nbsp;
                                                    <currency-formator class="sliding-text-font-one" format-value="{{item.totalBalance}}"></currency-formator>
                                                    <!-- <oe-i18n-msg class="sliding-text-font-one" msgid="USD {{item.totalBalance}}"> -->
                                                    </oe-i18n-msg>
                                                </div>
                                                <div class="slider-padding mdl-cell mdl-cell--1-col-phone margin-zero content-align-horizontal-end">
                                                    <template is="dom-if" if="{{item.displayUpIcon}}" restamp>
                                                        <iron-icon class="outlineOffset iron-icon-background" icon="expand-less" on-tap="hideDetails" tabindex="0"></iron-icon>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </template>

                    </template>

                    <template is="dom-if" if="{{viewBalanceFeatureDisabled}}">
                        <div class="login-page-container full-height" id="custom-slider" hidden$='[[showNotification]]'>
                            <div class="innerr">
                                <div id="one" class="position-absolute slider-item third">
                                <div class="row disp-flex">
                                    <div role="img">
                                    <img alt="slider" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/login/slider-icon.png">
                                    </div>
                                    <div class="slider-padding">
                                    <p class="sliding-text-font">Loans</p>
                                    <p class="sliding-sub-text-font">Lorem Ipsum is simply</p>
                                    </div>
                                </div>
                                </div>
                                <div id="two" class="position-absolute slider-item second" >
                                    <div class="row disp-flex">
                                        <div role="img">
                                        <img alt="slider" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/login/slider-icon.png">
                                        </div>
                                        <div class="slider-padding">
                                        <p class="sliding-text-font">Investments</p>
                                        <p class="sliding-sub-text-font">Lorem Ipsum is simply</p>
                                        </div>
                                    </div>
                                </div>
                                <div id="three" class="position-absolute slider-item first">
                                    <div class="row disp-flex">
                                        <div role="img">
                                        <img alt="slider" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/login/slider-icon.png">
                                        </div>
                                        <div class="slider-padding">
                                        <p class="sliding-text-font">Loans</p>
                                        <p class="sliding-sub-text-font">Lorem Ipsum is simply</p>
                                        </div>
                                    </div>
                                </div>
                                <div id="four" class="position-absolute slider-item fourth">
                                    <div class="row disp-flex">
                                        <div role="img">
                                        <img  alt="slider" src="{{imageBaseUrl}}/node_modules/speedboat_ui/images/{{tenantId}}/login/slider-icon.png">
                                        </div>
                                        <div class="slider-padding">
                                        <p class="sliding-text-font">Others</p>
                                        <p class="sliding-sub-text-font">Lorem Ipsum is simply</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    </div>
                 </div>

                <div class="mdl-cell--12-col mdl-cell--hide-phone" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" role="region" aria-labelledby="welcomeCarousel">

                        <div slot="header" isiosandroiddevice="{{isiosandroiddevice}}" class="overflow-hidden header_height" ev-floating-title-target="" id="index_paperToolbar" role="banner">
                            <paper-icon-button icon="menu" paper-drawer-toggle="" id="index-paperDrawer-Toggle" hidden="" slot="top"></paper-icon-button>
                            <div slot="top" class="flex-1" style="display: -webkit-flex;">
                                <div id="mainContainer" class="mdl-cell mdl-cell--10-col header_background mdl-cell--6-col-tablet">
                                    <div class="mdl-cell--2-col mdl-cell margin-b-zero margin-t-zero image_div header_background margin-zero">
                                        <img role="heading" aria-level="1" id="pageLogo" width="105" height="50" class="cursor-pointer img_header_style" alt="l_bank" title="Dashboard" src="node_modules/speedboat_ui/images/sb_icons/en-US/nbb_lgo.PNG">
                                    </div>
                                </div>
                                <div id="secureIcon" class="mdl-cell mdl-cell--2-col mdl-cell--2-col-tablet">  
                                    <div class="mdl-cell--12-col mdl-cell margin-b-zero margin-t-zero image_div header_background margin-zero">
                                        <div class="secure-text-icon">Secure <iron-icon icon="lock"></iron-icon> </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>
  <template is="dom-if" if="{{phone}}">
       <div class="mdl-cell--4-col-phone">
              <paper-toolbar slot="header" isiosandroiddevice="{{isiosandroiddevice}}" class="overflow-hidden header_height" ev-floating-title-target="" id="index_paperToolbar" role="banner">
              <paper-icon-button icon="menu" paper-drawer-toggle="" id="index-paperDrawer-Toggle" hidden="" slot="top"></paper-icon-button>
              <div slot="top" class="mdl-grid flex-1">
                  <div id="mainContainer" class="mdl-cell mdl-cell--2-col header_background">
                      <div class="mdl-cell--2-col mdl-cell margin-b-zero margin-t-zero image_div header_background margin-zero">
                          <img role="heading" aria-level="1" id="pageLogo" width="105" height="50" class="cursor-pointer img_header_style" alt="l_bank" title="Dashboard" src="node_modules/speedboat_ui/images/sb_icons/en-US/nbb_lgo.PNG">
                      </div>
                  </div>
                  <div id="mainContainer" class="mdl-cell mdl-cell--2-col">  
                      <div class="mdl-cell--12-col mdl-cell margin-b-zero margin-t-zero image_div header_background margin-zero">
                          <div class="secure-text-icon">Secure <iron-icon icon="lock"></iron-icon> </div>
                      </div>
                  </div>
              </div>
          </paper-toolbar>
      </div> 
  </template>

                 <div class="mdl-cell--8-col mdl-cell--6-col-desktop position-relative mb-top login_container" role="region" aria-labelledby="signInRegion">
                     <!-- added as accessibility landmark region -->
                     <!-- <div id="signInRegion" hidden>
                         <oe-i18n-msg msgid="b_login"></oe-i18n-msg>
                     </div> -->
                 <!--    <div hidden$={{show}}>
                        <div class="primary-light-text-xl login-primary-light-text-xl display-none-phone" role="header" heading-level="1">
                             <oe-i18n-msg id="profile_hello" class="mdl-cell--12-col-desktop login-profile-hello" msgid="l_Hello"></oe-i18n-msg>
							 <oe-i18n-msg id="profile_hello" class="mdl-cell--12-col-desktop" msgid="m_defaultText"></oe-i18n-msg>&nbsp;
                             <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                            </div>
                        </div>
                     <div class="banner-skew login-banner-skew full-width banner_bckground" phone$="{{phone}}"></div>
                     -->
                     <div class="root-container mdl-grid mdl-right-no-spacing-phone no-spacing-phone login_container_padd banner_bckground_mobile light-background" style="border-radius: 15px;">
 
                         <!--for desktop view only-->
                         <div class="mdl-grid mdl-cell--12-col-desktop position-relative mdl-grid--no-spacing">  
                            <div class="mdl-cell--12-col-desktop mdl-cell--12-col-tablet mdl-cell login_logo_div mdl-cell--1-offset-tablet" hidden$={{show}}>
								<!--<img style="display:block;"role="heading" aria-level="1" id="pageLogo" class="cursor-pointer mdl-cell--hide-phone" width="80px" height="80px" alt="l_bank" title="Dashboard" src="node_modules/speedboat_ui/images/sb_icons/en-US/yb_logo.svg" />-->
            <!--	<img style="display:block;"role="heading" aria-level="1" id="pageLogo" class="cursor-pointer mdl-cell--hide-desktop mdl-cell--hide-tablet" width="80px" height="35px" alt="l_bank" title="Dashboard" src="node_modules/speedboat_ui/images/sb_icons/en-US/yb_logo_transparent.png" /> -->
								<!--<oe-i18n-msg id="profile_hello" class="mdl-cell--12-col-desktop mdl-cell--12-col-tablet black_text login_text mdl-cell--hide-phone" msgid="l_Online_Bank"></oe-i18n-msg>-->
                                <oe-i18n-msg id="profile_hello" class="mdl-cell--9-col-desktop mdl-cell--12-col-tablet black_text login_text mdl-cell--hide-phone" msgid="l_loginText"></oe-i18n-msg>
								<oe-i18n-msg id="profile_hello" class="mdl-cell--12-col-desktop  black_text  login_text mdl-cell--hide-desktop mdl-cell--hide-tablet content-align-center" msgid="l_Mobile_Bank"></oe-i18n-msg>
							</div>
 
                             <!--Remember User Name block-->
                             <div hidden$="{{!showProfileName}}">
                                 <div class="">
                                     <paper-item class="padding-zero">
                                         <app-fab id="profilePpicDefault" role="button" tabindex=0 on-keydown="keyEventForPopUp" class="outlineOffset cursor-pointer profile-pic" large icon="profilePpicDefault" on-tap="_openAppFab">
                                         </app-fab>
                                         <div class="mdl-grid padding-r-zero"></div>
                                         <paper-item-body class="ie-preferences user-name-position-phone" two-line>
                                             <div id="profilename" class="mdl-grid margin-zero padding-lr-zero padding-t-zero primary-light-text-xl user-name-font-phone">
                                               <span><oe-i18n-msg msgid="l_Hi"></oe-i18n-msg>&nbsp;{{rememberedUserName}}!</span>
                                             </div>
                                         <!--<div class="primary-light-color font-size-m">
                                                 <oe-i18n-msg msgid="m_YourStatusVisibleAll"></oe-i18n-msg>
                                             </div>-->
                                         </paper-item-body>
                                     </paper-item>
 
                                     <!--Pop up for Switch User-->
                                     <paper-dialog id="selectUser" class="font-size-inherit mdl-cell" modal>
                                         <div class="mdl-cell content-align-vertical-center margin-l-zero margin-r-zero mdl-cell--12-col padding-r-zero">
                                             <div class="primary-dark-text-l font-medium mdl-cell mdl-cell--6-col-desktop">
                                                 <oe-i18n-msg msgid="l_SwitchUser"></oe-i18n-msg>
                                             </div>
                                             <div class="outlineOffset mdl-cell mdl-cell--6-col-desktop text-align-right" tabindex=0 on-keydown="closeSelectUserDialog" on-tap="closeSelectUserDialog" id="closeWindow" role="button">
                                                 <iron-icon class="cursor-pointer" icon="close" dialog-dismiss></iron-icon>
                                             </div>
                                         </div>
                                         <div class="mdl-grid mdl-cell--12-col-desktop margin-t-zero padding-t-zero content-align-center">
                                             <div class="outlineOffset mdl-grid margin-zero content-align-center mdl-grid--no-spacing logged-in-users cursor-pointer" tabindex=0 on-keydown="keySwitchNewUser" on-tap="_SwitchNewUser" role="button">
                                                 <app-fab id="add" class="border-1px secondary-dark-text-m add-new-user-fab"
                                                     large icon="add">
                                                 </app-fab>
                                                 <div id="new" class="full-width text-align-center secondary-dark-text-m">
                                                     <oe-i18n-msg msgid="l_New"></oe-i18n-msg>
                                                 </div>
                                             </div>
                                             <template is="dom-if" if="{{checkUserList}}" restamp>
                                                 <template id="resultList" is="dom-repeat" items="{{rememberedUserLists}}"
                                                     restamp>
                                                     <div class="outlineOffset mdl-grid margin-zero content-align-center mdl-grid--no-spacing logged-in-users text-overflow-ellipsis cursor-pointer" tabindex=0 on-keydown="keyswichUser" on-tap="_SwitchUser" dialog-dismiss role="button">
                                                         <app-fab id="profile_{{item.username}}" class$="outlineOffset border-1px {{item.activeClass}}" tabindex=0 large name="{{item.rememberedUserName}}" action-icon-indicator="{{actionIconIndicator}}" data-item="{{index}}" action-icon="close_icon_failure" index="{{index}}">
                                                         </app-fab>
                                                         <div id="{{item.username}}" class="full-width text-align-center secondary-dark-text-m">{{item.rememberedUserName}}</div>
                                                     </div>
                                                 </template>
                                             </template>
                                         </div>
                                         <div class="mdl-grid mdl-cell mdl-cell--12-col-desktop margin-t-zero padding-t-zero">
                                         </div>
                                     </paper-dialog>
                                     <!--Pop up for Switch User-->
 
                                     <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                                   
                                 </div>
                             </div>
                             <!--Remember User Name block-->
 
                             <!--First time login block-->
                             <div hidden$="{{showProfileName}}">
                                 <div hidden$={{show}}>
                                     <div class="primary-light-text-xl login-primary-light-textt-xl display-none">
                                         <!--<oe-i18n-msg id="profile_hello" class="mdl-cell--12-col-desktop" msgid="l_Hello"></oe-i18n-msg>&nbsp;
										 <oe-i18n-msg id="profile_hello" class="mdl-cell--12-col-desktop" msgid="m_defaultText"></oe-i18n-msg>&nbsp;
                                         !-->
                                         <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                                     </div>
                                 </div>
                                 <div hidden$={{!show}} class="display-none-phone">
                                     <!--<div class="mdl-cell--12-col-desktop primary-light-text-xl mdl-cell margin-l-zero">
                                        <oe-i18n-msg msgid="h_Authenticate" class="authenticate-message"></oe-i18n-msg>
                                     </div>-->
                                     <template is=dom-if if="{{!isPrimaryAuthMPin}}" >
                                    <div hidden$={{isPrimaryAuthOtp}} >
                                        <!--<div class="primary-light-text-s login-primary-light-text-s">
                                            <oe-i18n-msg msgid="m_passwordAutenticate" class="password-authenticate"></oe-i18n-msg>
                                            <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                                        </div>-->
                                     </div>
                                     </template>
                                     <template is=dom-if if="{{isPrimaryAuthMPin}}" >
                                     <div hidden$={{isPrimaryAuthOtp}} >
                                        <div class="primary-light-text-s login-primary-light-text-s">
                                            <oe-i18n-msg msgid="m_mpinAutenticate" class="password-authenticate"></oe-i18n-msg>
                                            <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                                        </div>
                                     </div>
                                     </template>
                                 </div>
                                 <!--First time login block-->
                             </div>
                         </div>
 
                         <!--for desktop view only-->
                         
 
                         <div class="main-container mdl-cell--1-offset-tablet mdl-cell--6-col-tablet mdl-cell--12-col-desktop login-container position-relative"
                             wide-layout$="{{wide}}" extra-wide-layout$="{{extra-wide}}">
                        
                        <template is="dom-if" if={{!forgetUserNameFlag}}>
                             <div class="list-card background-transparent" phone$="{{phone}}" desktop$="{{desktop}}"
                                 tablet$="{{tablet}}" elevation="0">
                                <div hidden$={{show}}>
                                     <div hidden$="{{showProfileName}}">
                                         <!--<oe-combo id="langCombo" class="custom-langCombo light-input-style login-light-input-stylee mdl-cell margin-l-zero mdl-cell--12-col black_text display-none-phone"
                                             on-change="languageChanged" listdata={{supportedLanguages}} displayproperty="language"
                                             valueproperty="language-id" value={{selectedLanguage}}>
                                             <iron-icon class="login-page-icon disp-only-in-mobile" icon="language" slot="prefix"></iron-icon>
                                             </oe-combo>-->
                                             <template is="dom-if" if="{{!phone}}">
                                             <div class="info-block">
                                                <iron-icon style="color: #00839B;margin-right: 8px;" icon="info-outline"></iron-icon>
                                              <span> <oe-i18n-msg msgid="l_userIdText" class="mobile_info_text"></oe-i18n-msg></span>
                                            </div>
                                            </template>
                                         <!--First time login block-->
                                         <oe-input  class="light-input-style login-light-input-style mdl-cell margin-l-zero mdl-cell--12-col black_text usernameInput inlineErrorSpacing"
                                             phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" id="originalU" maxlength=65
                                             label="l_corpiduserId" value="{{username}}" error-message="l_EnterUserName"
                                             user-error-message="l_EnterUserName" required pattern="[[usernameValidationPattern]]"
                                             oncopy="return false" onpaste="return false" on-focus="closeVirtualKeyboard" on-click="_HideSlider" on-keydown="navigateLogin">
                                             <iron-icon class="login-iron-icon disp-only-in-mobile lock-icon" icon="perm-identity" slot="prefix"></iron-icon>
                                             </oe-input>
                                         <div class="mdl-grid"></div>
										 
										 <div class="content-align-horizontal-end mdl-cell mdl-grid padding-t-zero padding-b-zero mdl-cell--12-col frget_pswd_container mdl-cell--hide-phone">
												 <div id="login.ForgotPassword.btn" class="primary-light-text-m position-relative red_text frget_pswd_container"
													 tabindex=0 on-keydown="forgotPwd" >
													 <oe-i18n-msg class="forgot-username  cursor-pointer " id="login.action.ForgotPassword.btn" msgid="l_ForgotUsernameMark" on-tap="_handleForgotUsernameFlag"></oe-i18n-msg>
													 <!--<oe-i18n-msg style="text-decoration:underline;"class="fright" id="login.action.ForgotPassword.btn" msgid="l_ForgotPassword"></oe-i18n-msg>-->
												 </div>
                                                 <div id="login.resetLink.btn" class="primary-light-text-m position-relative cursor-pointer red_text reset-link_container"
                                                 tabindex=0 on-keydown="forgotPwd" on-tap="resetMpinFunction">
                                                 <oe-i18n-msg class="forgot-username" id="login.action.ForgotPassword.btn" msgid="l_resetAdvanceSecurityLink"></oe-i18n-msg> 
                                             </div>

										 </div>
										 
                                         <!--<paper-checkbox checked="{{rememberMe}}" class="light-checkbox login-light-checkbox outlineOffset">
                                            <oe-i18n-msg id="rememberMe_id" class="primary-light-color login-primary-light-color" msgid="l_RememberMe"></oe-i18n-msg>
                                         </paper-checkbox>-->
                                         <!--First time login block-->
                                     </div>
                                 </div>
                                 <div hidden$={{!show}}>
                                     <div class="position-relative mdl-cell mdl-cell--12-col margin-l-zero margin-t-zero">
                                         <!--This is to reset or restamp virtual keyboard-->
                                         
                                         <template is=dom-if if="{{!isPrimaryAuthMPin}}" restamp>
                                         <template is=dom-if if="{{resetVirtualKeyboard}}" restamp>
                                             <div hidden$={{isPrimaryAuthOtp}} >
                                             <div hidden="{{biometricEnabled}}">
                                              <oe-input id="originalP" class="outlineOffset login-light-input-style light-input-style password-style black_text usernameInput" label="{{lpassword}}" value="{{accessCode}}" type="password" auto-validate required pattern="[[passwordValidationPattern]]" user-error-message="l_EnterPassword" error-message="l_EnterPassword" oncopy="return false" onpaste="return false" virtual-keyboard on-tap='closeVirtualKeyBoard' tabindex="0">
                                              </oe-input>
                                              </div>
                                             </div>
                                             
                                             
                                            <div on-tap="showBiometricLogin" hidden="{{!biometricEnabled}}" class="outlineOffset mdl-grid content-align-center mdl-cell--hide-desktop mdl-cell--hide-tablet" tabindex="0">
                                                <template is="dom-if" if="{{biometricFinger}}">
                                                    <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="fingerPrintWithCircle" ></iron-icon>
                                                </template>
                                                <template is="dom-if" if="{{biometricFace}}">
                                                    <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="faceLogin" ></iron-icon>
                                                </template>
                                                <template is="dom-if" if="{{biometricCommon}}">
                                                    <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="biometricCommonIcon" ></iron-icon>
                                                </template>
                                            </div>

                                            <div on-tap="showOtherLoginMode" hidden="{{!biometricEnabled}}" class="outlineOffset mdl-grid mdl-cell--hide-desktop mdl-cell--hide-tablet" tabindex="0">
                                                <!-- <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="lock_icon" ></iron-icon> -->
                                                <div class="text-brand-color mdl-grid mdl-cell--12-col margin-t-zero"><oe-i18n-msg class="font-size-m" msgid="l_LoginWith" ></oe-i18n-msg></div>
                                                <template is="dom-if" if="{{biometricPassword}}">
                                                    <iron-icon class="container-left-padding cursor-pointer iron-icon-style-xxl" icon="passwordLogin" ></iron-icon>
                                                    <div class="text-brand-color mdl-grid mdl-cell--12-col margin-t-zero"><oe-i18n-msg class="font-size-m" msgid="l_Password" ></oe-i18n-msg></div>
                                                </template>
                                                <template is="dom-if" if="{{biometricMpin}}">
                                                    <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="mpinLogin" ></iron-icon>
                                                    <div class="text-brand-color mdl-cell--12-col margin-t-zero"><oe-i18n-msg class="font-size-m" msgid="l_MPIN" ></oe-i18n-msg></div>
                                                </template>
                                            </div>

                                         </template>
                                         <template is=dom-if if="{{!resetVirtualKeyboard}}" restamp>
                                            <div hidden$={{isPrimaryAuthOtp}} >
                                              <div hidden="{{biometricEnabled}}">
                                              <div class="mdl-cell--9-col login_logo_div" style="padding-bottom: 25px;" hidden={{!loginTextShow}}>
                                                <oe-i18n-msg id="profile_hello" class="mdl-cell--9-col-desktop mdl-cell--12-col-tablet black_text login_text mdl-cell--hide-phone" msgid="l_loginText"></oe-i18n-msg>
                                              </div>
                                              <oe-input id="originalP" class="outlineOffset login-light-input-style light-input-style password-style black_text usernameInput inlineErrorSpacing" label="{{lpassword}}" value="{{accessCode}}" type="password" auto-validate required pattern="[[passwordValidationPattern]]" user-error-message="l_EnterPassword" error-message="l_EnterPassword" oncopy="return false" onpaste="return false" virtual-keyboard on-tap='closeVirtualKeyBoard' on-click="_HidePasswordBar" on-keydown="navigateLogin" tabindex="0">
                                                 <iron-icon class="login-page-iron-icon disp-only-in-mobile lock-icon" icon="lock-outline" slot="prefix"></iron-icon>  
                                              </oe-input>
                                              </div>
                                             </div>

                                             <div on-tap="showBiometricLogin" hidden="{{!biometricEnabled}}" class="outlineOffset mdl-grid content-align-center mdl-cell--hide-desktop mdl-cell--hide-tablet" tabindex="0">
                                                <template is="dom-if" if="{{biometricFinger}}">
                                                    <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="fingerPrintWithCircle" ></iron-icon>
                                                </template>
                                                <template is="dom-if" if="{{biometricFace}}">
                                                    <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="faceLogin" ></iron-icon>
                                                </template>
                                                <template is="dom-if" if="{{biometricCommon}}">
                                                    <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="biometricCommonIcon" ></iron-icon>
                                                </template>
                                            </div>

                                            <div on-tap="showOtherLoginMode" hidden="{{!biometricEnabled}}" class="outlineOffset mdl-grid mdl-cell--hide-desktop mdl-cell--hide-tablet" tabindex="0">
                                                <div class="text-brand-color mdl-grid mdl-cell--12-col margin-t-zero"><oe-i18n-msg class="font-size-m" msgid="l_LoginWith" ></oe-i18n-msg></div>
                                                <template is="dom-if" if="{{biometricPassword}}">
                                                    <iron-icon class="container-left-padding cursor-pointer iron-icon-style-xxl" icon="passwordLogin" ></iron-icon>
                                                    <div class="text-brand-color mdl-grid mdl-cell--12-col margin-t-zero"><oe-i18n-msg class="font-size-m" msgid="l_Password" ></oe-i18n-msg></div>
                                                </template>
                                                <template is="dom-if" if="{{biometricMpin}}">
                                                    <iron-icon class="cursor-pointer iron-icon-style-xxl" icon="mpinLogin" ></iron-icon>
                                                    <div class="text-brand-color mdl-cell--12-col margin-t-zero"><oe-i18n-msg class="font-size-m" msgid="l_MPIN" ></oe-i18n-msg></div>
                                                </template>
                                            </div>

                                              <template is=dom-if if="{{isPrimaryAuthOtp}}" restamp>
                                                <div  hidden$={{showProfileName}}>
                                               <!--     <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>   -->
                                                </div>
                                                <div hidden={{!EmailFlag}}> 
                                                    <div> 
                                                        <div hidden={{buttondisplayFlag}} >
                                                            <oe-i18n-msg id="profile_hello" class="mdl-cell--9-col-desktop mdl-cell--12-col-tablet black_text login_text mdl-cell--hide-phone" msgid="l_OtpValidationMsg"></oe-i18n-msg>
                                                            <div class="vertical layout" style="padding-top: 15px;" >
                                                                <oe-i18n-msg class="font-14 secondary-color " msgid="l_OTPsentToRegNum" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}"></oe-i18n-msg>
                                                                <oe-i18n-msg class="font-14 secondary-color " msgid="l_OTPDescription" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}"></oe-i18n-msg>
                                                            </div>
                                                            <!--Below code is to display the phonenumber -->                                                        
                                                            <div class="content-align-vertical-center horizontal layout margin-l-zero mdl-cell mdl-cell--12-col" >
                                                                <iron-icon style="color: #00839B;margin-right: 8px;" class="iron-icon-style-xs" icon="telephone"></iron-icon>&nbsp;&nbsp;&nbsp;
                                                                <oe-i18n-msg class="font-14 secondary-color " msgid="h_Phonenumber" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}"></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <span class="font-13 font-weight-700">{{phoneNumber}}</span>
                                                            </div>
                                                        </div>
                                                        <div hidden={{!buttondisplayFlag}} >
                                                            <oe-i18n-msg id="profile_hello" class="mdl-cell--9-col-desktop mdl-cell--12-col-tablet black_text login_text mdl-cell--hide-phone" msgid="l_forgotusernameotpmsg"></oe-i18n-msg>
                                                            <div class="vertical layout" style="padding-top: 15px;padding-bottom: 5px;">
                                                                <oe-i18n-msg class="font-14 secondary-color " msgid="l_OTPsentToReEmail" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}"></oe-i18n-msg>
                                                                <oe-i18n-msg class="font-14 secondary-color " msgid="l_OTPDescription" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}"></oe-i18n-msg>
                                                            </div>
                                                            <!--Below code is to display the email -->                                                        
                                                            <div class="content-align-vertical-center horizontal layout margin-l-zero mdl-cell mdl-cell--12-col" >
                                                                <iron-icon style="color: #00839B;margin-right: 8px;" class="iron-icon-style-xs" icon="email-new"></iron-icon>&nbsp;&nbsp;&nbsp;
                                                                <oe-i18n-msg class="font-14 secondary-color " msgid="h_EmailAddress" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}"></oe-i18n-msg>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <span class="font-13 font-weight-700">{{maskedEmail}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <!-- For showing input in case of SOTP as primary authentication -->
                                                    <fin-auth-element-wrapper custom-label={{customLabel}} otp-link={{otpLink}}  isvalid="{{isvalid}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet" id="authWrapperStepUp" auth-method="{{authMethods}}" user-name={{username}}></fin-auth-element-wrapper>
                                                </div> 

                                                
                                                

                                                <div hidden={{EmailFlag}}>  
                                                    <div class="vertical layout" style="padding-left: 5px;padding-bottom: 5px;">
                                                        <oe-i18n-msg class="font-18 font-weight-600 mdl-cell mdl-cell--12-col  margin-l-zero" msgid="l_pleaseEnterEmailId"></oe-i18n-msg>
                                                        <oe-i18n-msg id="profile_hello" class="mdl-cell mdl-cell--12-col-desktop mdl-cell--12-col-tablet secondary-color mdl-cell--hide-phone font-15  margin-l-zero" msgid="l_willSendOtpnote"></oe-i18n-msg>                                                    
                                                        <oe-input  class="maininput" style="--paper-input-container-invalid-color: red;" id="emailAddress" label="l_emailaddress" required="true" value={{emailAddress}} >
                                                        </oe-input>
                                                    </div>
                                                </div> 
                                               </template>
                                              <template is="dom-if" if="{{testFlag}}">
                                                        <oe-i18n-msg id="profile_hello" class="mdl-cell mdl-cell--9-col-desktop mdl-cell--12-col-tablet black_text login_text mdl-cell--hide-phone" msgid="enter OTP"></oe-i18n-msg>
                                                        <!-- For showing input in case of SOTP as primary authentication -->
                                                        <fin-auth-element-wrapper otp-link={{otpLink}}  isvalid="{{isvalid}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet" id="authWrapperStepUp" auth-method="{{authMethods}}" user-name={{username}}></fin-auth-element-wrapper>
                                              </template>
                                            <!-- <template is=dom-if if="{{crontoImageDataFlag}}" restamp>
   													                    <fin-auth-playstore></fin-auth-playstore>
   											                    </template>
                                                                   -->
                                         </template>
                                    </template>
                                    

                                    <template is=dom-if if="{{isPrimaryAuthMPin}}" restamp>
                                    <oe-input id="mpinId" class="login-light-input-style password-style" label="{{lmpin}}"
                                                  value="{{mpinInputValue}}" type="password" auto-validate required                                                   user-error-message="l_EnterMpin" error-message="l_EnterMpin"
                                                  oncopy="return false" onpaste="return false" >
                                              </oe-input>
                                    </template>
                                         <!--This is to reset or restamp virtual keyboard-->
                                         
                                     </div>
                                   <template is=dom-if if="{{!isPrimaryAuthOtp}}" restamp>
                                   <template is=dom-if if="{{!isPrimaryAuthMPin}}" restamp>
                                   <template is=dom-if if="{{!biometricEnabled}}" restamp>
                                     <div class="content-align-horizontal-end mdl-cell mdl-grid padding-t-zero padding-b-zero mdl-cell--12-col">
                                     <!-- <div id="login.ForgotPassword.btn" class="primary-light-text-m position-relative cursor-pointer login-primary-light-text-m outlineOffset"
                                             tabindex=0 on-keydown="forgotPwd" on-tap="handleForgotPassword" role="link">
                                             <oe-i18n-msg class="" id="login.action.ForgotPassword.btn" msgid="l_ForgotPassword"></oe-i18n-msg>
                                         </div>-->
                                     </div>
                                      </template>
                                    </template>
                                  </template>

                                  <template is=dom-if if="{{!isPrimaryAuthOtp}}" restamp>
                                  <template is=dom-if if="{{isPrimaryAuthMPin}}" restamp>
                                    <div class="content-align-horizontal-end mdl-cell mdl-grid padding-t-zero padding-b-zero mdl-cell--12-col">
                                        <div id="login.ForgotPassword.btn" class="primary-light-text-m position-relative cursor-pointer login-primary-light-text-m outlineOffset"
                                            tabindex=0 on-keydown="forgotPwd" on-tap="gotoMpinflow">
                                            <oe-i18n-msg class="" id="login.action.ForgotPassword.btn" msgid="l_ForgotMPIN" role="link"></oe-i18n-msg>
                                        </div>
                                    </div>
                                     </template>
                                   </template>
                                 </div>
                                 <div hidden$={{!show}}>
                                     <div class="position-relative" hidden$="{{hideCaptcha}}" id="loginCaptchaDiv"></div>
                                 </div>
 
                                 <!--Ends here-->
                             </div>
                        </template>
                        <template is="dom-if" if={{forgetUserNameFlag}} >
                            <template is="dom-if" if={{!forgetUserOtpFlag}} >
                                    <oe-i18n-msg class="font-18 font-weight-600 mdl-cell mdl-cell--12-col  margin-l-zero" msgid="l_pleaseEnterEmailId"></oe-i18n-msg>
                                    <oe-i18n-msg id="profile_hello" class="mdl-cell mdl-cell--12-col-desktop mdl-cell--12-col-tablet secondary-color mdl-cell--hide-phone font-15  margin-l-zero" msgid="l_willSendOtpnote"></oe-i18n-msg>  
                                <div>
                                    <oe-input class="light-input-style login-light-input-style mdl-cell margin-l-zero mdl-cell--12-col black_text usernameInput"
                                        phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" id="forgetUserName"
                                        label="l_emailid" value="{{forgetEmailIdValue}}" auto-validate required  
                                        on-focus="closeVirtualKeyboard"  on-keydown=" "> 
                                        </oe-input>
                                </div>
                            
                                <div class="mdl-grid padding-b-zero padding-l-zero padding-r-zero buttonAlignment">
                                    <paper-button class="margin-l-zero primary-button "  on-click="forgetUserNameFunction" style="width: -webkit-fill-available;">
                                        <oe-i18n-msg msgid="b_Proceed" class="text-transform-capitalize"></oe-i18n-msg>
                                    </paper-button>
                                    <paper-button class=" margin-l-zero secondary-button "  on-click="backtoMainLogin" style="width: -webkit-fill-available;">
                                        <oe-i18n-msg msgid="l_Back" class="text-transform-capitalize"></oe-i18n-msg>
                                    </paper-button>
                                </div>
                            </template>
                            <template is="dom-if" if={{forgetUserOtpFlag}} >
                                <div>
                                    <forget-userid-otp forget-email-id-value={{forgetEmailIdValue}}></forget-userid-otp>
                                </div>
                                <div class="mdl-grid padding-b-zero padding-l-zero padding-r-zero">
                                    <paper-button class="margin-l-zero secondary-button "  on-click="backtoMainLogin" style="width: -webkit-fill-available;">
                                            <oe-i18n-msg msgid="l_Back" class="text-transform-capitalize"></oe-i18n-msg>
                                    </paper-button>
                                </div>
                            </template>
                        </template>
                             <!--for desktop view only-->
                             <template is="dom-if" if={{!forgetUserNameFlag}}>
                             <div class="btn align-end full-width">
                                 <div class="mdl-cell--12-col-desktop mdl-grid--no-spacing  margin-b-zero" style = "margin-top:5%;">
                                     <div class="mdl-cell--12-col-desktop content-align-center" hidden$={{show}}>
                                         <!--<paper-button hidden="{{showProfileName}}" id="desktopCancel" class="secondary-button"
                                             on-tap="handleSignup" raised>
                                             <oe-i18n-msg class="" msgid="b_SignUp"></oe-i18n-msg>
                                         </paper-button>-->
 
                                         <paper-button hidden="{{showProfileName}}" id="desktoploginModes" class="primary-button login-primary-button outlineOffset sign_button"
                                            on-tap="handleLoginmodes" disabled$={{!asyncImportsLoaded}} raised on-click="_HideBorderBottom">
                                             <oe-i18n-msg msgid="b_Proceed" class="login-signin"></oe-i18n-msg>
                                         </paper-button>

                                         
                                     </div>
                                     <div hidden$={{notFirstTimeUser}} class="login-btn-section mdl-cell--12-col-desktop">
                                         <div hidden$={{!show}} class="padding-zero mdl-grid">
                                         <template is=dom-if if="{{!biometricEnabled}}" restamp>
                                         <template is=dom-if if="{{!enableOneSpan}}" restamp>
                                            <div class="vertical layout mdl-cell--12-col">
                                                <div class="dummyclass" style="padding-bottom:15px;">
                                                    <paper-button id="btn_loginConfirm" class="mdl-cell--12-col primary-button margin_auto login-primary-button login-button outlineOffset" on-tap="handleLogin" 
                                                        disabled$={{!asyncImportsLoaded}} raised on-click="_BtnLoginCnfrm">
                                                        <oe-i18n-msg msgid="b_proceed" class="login-confirm"></oe-i18n-msg>
                                                    </paper-button>
                                                </div>
                                                <div style="">
                                                  <paper-button id="btn_loginCancel" class="mdl-cell--12-col margin_auto login-cancel-button outlineOffset mobile-login-cancel-button" on-tap="goToCancel"  
                                                        disabled$={{!asyncImportsLoaded}}  on-click="_BtnLoginCnfrm">
                                                        <oe-i18n-msg msgid="b_Cancel" class="login-cancel"></oe-i18n-msg>
                                                    </paper-button>
                                                </div>
                                              <div class="info mobile_text">
                                                    <div style="margin-right: 10px">
                                                        <iron-icon style="color:#00839B;" icon="lock-outline"></iron-icon>
                                                    </div>
                                                    <template is="dom-if" if="{{checkTenentIdNBB()}}">
                                                        <div class="imp-text">
                                                            <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginText"></oe-i18n-msg>
                                                        </div>
                                                    </template>
                                                    <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                                                        <div class="imp-text">
                                                            <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginTextNBBUAE"></oe-i18n-msg>
                                                        </div>
                                                    </template>
                                                    <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                                                        <div class="imp-text">
                                                            <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginText"></oe-i18n-msg>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                         </template>
                                         <template id="checkCounter" is=dom-if if="{{enableOneSpan}}" restamp>
                                            <div  class="vertical layout mdl-cell--12-col" hidden={{!EmailFlag}}>  
                                                <div class="horizontal layout" style="padding-bottom:15px;" hidden={{buttondisplayFlag}} class="mdl-cell--12-col">
                                                    <div class="mdl-cell--6-col">
                                                        <paper-button class="font-15 text-transform-capitalize padding-l-zero font_familySFPro" on-tap="resendOTPFunction" disabled$={{resendOtpDisabled}}>
                                                            <oe-i18n-msg msgid="b_ResendOTP"></oe-i18n-msg>
                                                        </paper-button> 
                                                    </div>
                                                    <template is=dom-if if="{{enableOtpCounter}}" restamp>
                                                        <div class="mdl-cell--6-col" style="padding-left: 25px">
                                                            <span class="otp-expiry-countdown primary-dark-text-m content-align-horizontal-end" id="time">&nbsp;&nbsp;{{countDownTime}}</span>
                                                        </div>
                                                        <!--<div class="font-14" id="counter">
                                                        <fin-timer></fin-timer>
                                                        </div>-->
                                                    </template>
                                                </div>
                                                <div class="vertical layout mdl-cell--12-col">
                                                    <div class="mdl-cell mdl-cell--12-col"  hidden={{!buttondisplayFlag}}></div>
                                                    <paper-button id="btn_loginConfirm" class=" primary-button outlineOffset" on-tap="handleLogin"
                                                        disabled$={{!asyncImportsLoaded}} raised on-click="_BtnLoginCnfrm"  style="margin-bottom:10px;">
                                                        <oe-i18n-msg msgid="b_Proceed" class="login-confirm"></oe-i18n-msg>
                                                    </paper-button> 
                                                    <paper-button id="btn_loginConfirmEmail" hidden={{buttondisplayFlag}} class="confirm-email secondary-button text-transform-capitalize outlineOffset" on-tap=" "
                                                        disabled$={{!asyncImportsLoaded}} raised on-click="_emailchange" style="">
                                                        <oe-i18n-msg id="btn_sendCodeToEmailmsg" msgid="b_sendCodeToEmail" class="login-confirm"></oe-i18n-msg>
                                                    </paper-button> 
                                                    <paper-button id="btn_loginCancel" class="outlineOffset text-transform-capitalize" on-tap="goToCancel"
                                                        disabled$={{!asyncImportsLoaded}}   on-click=" ">
                                                        <oe-i18n-msg msgid="b_Cancel" class="login-cancel teal-color"></oe-i18n-msg>
                                                    </paper-button>
                                                    <div class="info" hidden={{!loginTextShow}} >
                                                        <div style="margin-right: 10px">
                                                            <iron-icon style="color:#00839B;" icon="lock-outline"></iron-icon>
                                                    </div>
                                                        <template is="dom-if" if="{{checkTenentIdNBB()}}">
                                                            <div class="imp-text">
                                                                <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginText"></oe-i18n-msg>
                                                            </div>
                                                        </template>
                                                        <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                                                            <div class="imp-text">
                                                                <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginTextNBBUAE"></oe-i18n-msg>
                                                            </div>
                                                        </template>
                                                        <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                                                            <div class="imp-text">
                                                                <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginText"></oe-i18n-msg>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="vertical layout mdl-cell--12-col" hidden={{EmailFlag}} style="width: 100%;">  
                                                <div class="mdl-cell mdl-cell--12-col"></div>
                                                <div class="vertical layout mdl-cell--12-col">
                                                    <paper-button id="btn_loginConfirm" class=" primary-button" on-tap=" "
                                                        disabled={{emailEnteredFlag}}  on-click="_navigateToEmailOtp"  style="margin-bottom:10px;">
                                                        <oe-i18n-msg msgid="l_emailMe" class="login-confirm"></oe-i18n-msg>
                                                    </paper-button> 
                                                    <paper-button id="btn_loginCancelEmail" class="outlineOffset" on-tap="goToCancel"
                                                        disabled$={{!asyncImportsLoaded}}  on-click=" ">
                                                        <oe-i18n-msg msgid="b_Cancel" class="login-cancel"></oe-i18n-msg>
                                                    </paper-button>
                                                    
                                                </div>
                                            </div>
                                            <div  class="vertical layout mdl-cell--12-col" hidden={{!testFlag}}>  
                                                <div class="vertical layout mdl-cell--12-col">
                                                    <paper-button id="btn_loginConfirm" class=" primary-button outlineOffset" on-tap="handleLogin"
                                                        disabled$={{!asyncImportsLoaded}} raised on-click="_BtnLoginCnfrm"  style="margin-bottom:10px;">
                                                        <oe-i18n-msg msgid="b_Proceed" class="login-confirm"></oe-i18n-msg>
                                                    </paper-button>
                                                    <paper-button id="btn_loginCancel" class="outlineOffset" on-tap="goToCancel"
                                                        disabled$={{!asyncImportsLoaded}} raised on-click=" ">
                                                        <oe-i18n-msg msgid="b_Cancel" class="login-cancel"></oe-i18n-msg>
                                                    </paper-button>                                                    
                                                </div>
                                                
                                            </div>
                                        </template>

                                        </template>
                                             <div on-tap="gotoMpinflow" hidden$={{enableMPINRegistration}} class="outlineOffset mdl-cell--hide-desktop mdl-cell--hide-tablet" tabindex="0">
                                                <template is="dom-if" if="{{!isCorporateUser}}">
                                                    <template is="dom-if" if="{{isMobileApp}}">
                                                        <iron-icon class="cursor-pointer iron-icon-style-xxl outlineOffset" icon="lock_icon" ></iron-icon>
                                                        <div class="text-brand-color mdl-cell mdl-grid mdl-cell--12-col content-align-center margin-t-zero"><oe-i18n-msg class="font-size-m" msgid="l_RegisterForMpin" ></oe-i18n-msg></div>
                                                    </template>
                                                </template>
                                            </div>
                                             
                                         </div>
                                     </div>
                                     <div hidden$={{!notFirstTimeUser}}>
                                         <div hidden$={{!show}}>
                                         <template is=dom-if if="{{!biometricEnabled}}" restamp>
                                             <paper-button id="btn_signIn" class="primary-button outlineOffset" on-tap="handleLogin"
                                                 disabled$={{!asyncImportsLoaded}} raised>
                                                 <oe-i18n-msg msgid="b_login"></oe-i18n-msg>
                                             </paper-button>
                                        </template>
                                        
											</paper-button>
                                              <template is="dom-if" if="{{!isPrimaryAuthOtp}}">
                                                 <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                                             </template>
                                         </div>
                                     </div>
                                 </div>
                                 <div class="full-width content-align-center display-none">
                                     <paper-button hidden="{{showProfileName}}" id="createAccount" on-tap="createAccount"
                                         class="primary-light-color">
                                         <oe-i18n-msg class="text-transform-none explore-products" msgid="b_ExploreYourProducts"></oe-i18n-msg>
                                     </paper-button>
                                     <paper-button hidden="{{showProfileName}}" id="enableUser" on-tap="onlineRegistration"
                                         class="primary-light-color">
                                         <oe-i18n-msg class="text-transform-none custom-explore-text" msgid="b_SignUp"></oe-i18n-msg>
                                     </paper-button>
                                 </div>                               
                                 <!--<div class="mdl-grid"></div>
                                 <div class="mdl-grid"></div>
                                 <div class="mdl-grid"></div>
                                 <div class="mdl-grid"></div> 
                                 <div class="mdl-grid"></div> -->
                               <div class="info mobile_text" hidden$={{show}}>
                                    <div class="info-text-icon">
                                        <iron-icon style="color:#00839B;" icon="lock-outline"></iron-icon>
                                    </div>
                                    <template is="dom-if" if="{{checkTenentIdNBB()}}">
                                        <div class="imp-text">
                                            <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginText"></oe-i18n-msg>
                                        </div>
                                    </template>
                                    <template is="dom-if" if="{{checkTenentIdNBBUAE()}}">
                                        <div class="imp-text">
                                            <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginTextNBBUAE"></oe-i18n-msg>
                                        </div>
                                    </template>
                                    <template is="dom-if" if="{{checkTenentIdNBBKSA()}}">
                                        <div class="imp-text">
                                            <strong><oe-i18n-msg msgid="l_Important"></oe-i18n-msg></strong><oe-i18n-msg msgid="l_ImportantLoginText"></oe-i18n-msg>
                                        </div>
                                    </template>
                                </div>                                                                                                                                                                
                             </div>
                             </template>
                             <div class="mdl-cell login-mdl-cell help-link display-none">
                                 <oe-i18n-msg class="secondary-dark-text-m need-help-text" msgid="l_NeedSomeHelp"></oe-i18n-msg>
                                 <a class="cursor-pointer" on-tap="openFaq" rel="noopener noreferrer"
                                     style="text-decoration:none;display:inline-block" class="outlineOffset" role="link" tabindex="0">
                                    <oe-i18n-msg class="text-brand-color font-medium faq-text" msgid="l_Faq"></oe-i18n-msg>
                                 </a>
                             </div>
                             <!--<paper-button id="login.ATMLocator.btn" class="margin-zero font-medium atm-locator-paper-button outlineOffset" on-tap="handleATMLocator">
                                 <oe-i18n-msg id="login.action.ATMLocator.btn" role="link" class="text-transform-none text-brand-color atm-locator"
                                     msgid="h_ATM&BranchLocator"></oe-i18n-msg>
                             </paper-button>-->
                         </div>
                     </div>
                 </div>                
             </div>
             <template is="dom-if" if="{{desktop}}">
                <fin-page-footer class="mdl-cell mdl-cell--12-col"  />
                <div class="shadow-div" on-click="_ShowSlider"></div>
            </template>
            </div>
         </template>
         </div>
         <div class="view-port"> 
            <template is="dom-if" if={{_selectedPageChanged(selectedPage,1)}}>
                <fin-auth-otp-landing selected-page={{selectedPage}} cronto-response={{crontoResponse}} data-body={{dataBody}} from-qr-success={{fromQrSuccess}} from-playstore={{fromPlaystore}}></fin-auth-otp-landing>
            </template>
         </div>
         <div class="view-port">
            <template is="dom-if" if={{_selectedPageChanged(selectedPage,2)}}>
                <fin-auth-modes-landing auth-mode-object={{authModeObject}} selected-page={{selectedPage}} auth-mode-response={{authModeResponse}} auth-mode-body={{authModeBody}} auth-success={{authSuccess}} softtoken-otp={{softtokenOtp}} selected-value = {{selectedValue}} auth-mode-list={{authModeList}} reset-mpin={{resetMpin}}></fin-auth-modes-landing>
            </template>
         </div>
         </iron-pages>
         <app-dialog name="h_Authentication" id="secondAuthDialog" elementid="secondAuthElement" on-dialogclosed="_authDialogClosed">
             <stepup-auth auth-methods="{{authMethods}}" header="{{header}}" on-successsingon="{{signonsuccess}}"></stepup-auth>
         </app-dialog>

         <app-dialog id="firstTimeBiometricPopup" closevisible="{{closevisible}}" elementid="firstTimeBiometricPopup" name="h_BiometricAuthentication">
            <div class="mdl-grid">
                <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
                    <oe-i18n-msg msgid="m_FirstTimeRegisterForBiometric" class="font-size-m"></oe-i18n-msg>
                </div>
                <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                    <paper-button id="registerForBiometric" on-tap="clickedYes" on-keypress="clickedYes" class="flat-button outlineOffset">
                        <oe-i18n-msg id="first-time-biometric-okButton" class="text-brand-color" msgid="b_Yes"></oe-i18n-msg>
                    </paper-button>
                    <paper-button id="unRegisterForBiometric" on-tap="clickedNo" on-keypress="clickedNo" class="flat-button outlineOffset">
                        <oe-i18n-msg id="first-time-biometric-cancelButton" class="text-brand-color" msgid="b_No"></oe-i18n-msg>
                    </paper-button>
                </div>
            </div>
        </app-dialog>
         <app-data app-data="{{appData}}"></app-data>
    `; // This function remains outside the scope of Polymer element ev-login; as it is passed as callback function to a URL

/* eslint-disable-next-line */

function onCaptchaloadCallback() {
    grecaptcha.render('loginCaptchaDiv', {
        'sitekey': config.SpeedBoat.App.Captcha.key
    });
}

Polymer({
    is: "ev-login",
    _template: template,
    behaviors: [corpBehaviours.appCommonBehaviour],
    properties: {
        enableOneSpan: {
            type: Boolean,
            value: false,
            notify: true
        },
        username: {
            type: String,
            value: "",
            notify: true,
            observer: '_changeOnespan'
        },
        eleId: {
            type: String,
            value: 'DialogPUP'
        },
        actionIconIndicator: {
            type: Boolean,
            value: false,
            notify: true
        },

        rememberMe: {
            type: Boolean,
            value: false,
            notify: true
        },
        showProfileName: {
            type: Boolean,
            value: false,
            notify: true
        },
        accessCode: {
            type: String,
            value: ""  
        },
        resetVirtualKeyboard: {
            type: Boolean,
            value: false,
            notify: true
        },
        currentPassword: {
            type: String,
            value: "",
            notify: true
        },
        corporateId: {
            type: String,
            value: ""
        },
        locale: {
            type: String,
            observer: '_localeChanged'
        },
        loggedin: {
            type: Boolean,
            value: false,
            notify: true
        },
        tenant_id: {
            type: String,
            observer: '_tenantIdChanged'
        },
        selected: {
            type: Number,
            notify: true
        },
        // baseurl: {
        //     type: String,
        //     observer: '_onChangeBaseurl'
        // },
        navigationLink: {
            type: Object,
            notify: true
        },
        token: {
            type: String,
            value: "",
            observer: '_onChangeToken',
            notify: true
        },
        logoutPostFlow: {
            type: Boolean,
            value: false
        },
        authMethods: {
            type: Array,
            notify: true
        },
        isCorporateUser: {
            type: Boolean,
            value: true,
            notify: true
        },
        isNotificationsEnabled: {
            type: Boolean,
            notify: true
        },
        hideCaptcha: {
            type: Boolean
        },
        supportedLanguages: {
            type: Array,
            value: function () {
                return config.SpeedBoat.App.supportedLanguages;
            }
        },
        selectedLanguage: {
            type: String,
            value: function () {
                var allLang = config.SpeedBoat.App.supportedLanguages;
                var defaultLang = config.SpeedBoat.App.Environment.locale;
                for (var i = 0; i < allLang.length; i++) {
                    var lang = allLang[i];
                    if (lang.locale.trim().toLowerCase() === defaultLang.trim().toLowerCase()) {
                        return lang['language-id'];
                    }
                }
                return allLang.length && allLang[0]['language-id'] ? allLang[0]['language-id'] :
                    '001';
            }
        },
        selectedDir: {
            type: String,
            value: function () {
                var allLang = config.SpeedBoat.App.supportedLanguages;
                var defaultLang = config.SpeedBoat.App.Environment.locale;
                for (var i = 0; i < allLang.length; i++) {
                    var lang = allLang[i];
                    if (lang.locale.trim().toLowerCase() === defaultLang.trim().toLowerCase()) {
                        document.body.setAttribute('dir', lang['dir']);
                        document.documentElement.dir = lang['dir'];
                        return lang['dir'];
                    }
                }
                var dirCurrent = allLang.length && allLang[0]['dir'] ? allLang[0]['dir'] :
                    'ltr';
                document.setAttribute('dir', dirCurrent);
                document.documentElement.dir = dirCurrent;
                return dirCurrent;
            }
        },
        show: {
            type: Boolean,
            value: false,
            notify: true
        },
        enableMPINRegistration: {
            type: Boolean,
            value: false,
            notify: true
        },
        isMobileApp: {
            type: Boolean,
            value: false,
            notify: true
        },
        keyboardOpen: {
            type: Boolean,
            value: false,
            notify: true
        },
        forgotUserList: {
            type: Object,
            notify: true
        },
        mpinAuthList: {
            type: Object,
            notify: true
        },
        appData: {
            type: Object,
            value: {}
        },
        notFirstTimeUser: {
            type: Boolean,
            value: false
        },
        checkUserList: {
            type: Boolean,
            value: false
        },
        rememberedUserLists: {
            type: Array,
            notify: true,
            value: [],
            observer: "showrememberedUserLists"
        },
        loginModeData: {
            type: Object,
            notify: true
        },
        userlogDet: {
            type: Object,
            notify: true
        },
        rememberedUserName: {
            type: String,
            notify: true
        },
        lpassword: {
            type: String,
            notify: true,
            value: getLabel('l_Password')
        },
        loggedInUserInfo: {
            type: Object,
            notify: true,
            value: []
        },
        showUserName: {
            type: String,
            notify: true
        },

        /* removed this property from speedconfig and made to elemenet specific due to speed-config cleanup reason */
        maxUsers: {
            type: Number,
            notify: true,
            vlaue: 3
        },
        shortcutsData: {
            type: Object,
            notify: true
        },
        showLoginPageFlag: {
            type: Boolean,
            notify: true,
            value: true
        },
        otpcallCount: {
            type: Number,
            notify: true,
            value: 0
        },
        menuProfiles: {
            type: Array,
            notify: true,
            value: []
        },
        initLoadQueue: {
            type: Array,
            value: []
        },
        showLoginPage: {
            type: Boolean,
            value: true
        },
        isDemoMode: {
            type: Boolean,
            value: false,
            notify: true
        },
        tenantId: {
            type: String,
            value: sessionStorage.getItem("tenantId")
        },
        backgroundImgSrc: {
            type: String,
            value: "./node_modules/sb_Registration_ui/images/" + sessionStorage.getItem("tenantId") + "/background_Image.jpg",
            notify: true
        },
        //property to store the decrypted data of user Migration mvf:-289442.
        decryptedData: {
            type: Object,
            notify: true
        },
        // property to check whether flow is login flow for user Migration mvf:-289442.
        isLoggedInFlow: {
            type: Boolean,
            notify: true,
            value: false
        },
        //property to check whether flow is forgot password  for user Migration mvf:-289442.
        isForgotPwdFlow: {
            type: Boolean,
            notify: true,
            value: false
        },
        //property to check whether flow is force change password  for user Migration mvf:-289442.
        isForceChangePasswordFlow: {
            type: String,
            value: "N",
            notify: true
        },
        isForceTransactionChangePasswordFlow: {
            type: String,
            value: "N",
            notify: true
        },
        imageBaseUrl: {
            type: String,
            value: window.OEUtils.uibaseroute
        },
        //property to store data for user migration in case of shopping mall for user Migration.
        shoppingMallMigrationDetails: {
            type: Array,
            notify: true,
            value: []
        },
        //property for checking whether primary authentication is OTP or not.
        isPrimaryAuthOtp: {
            type: Boolean,
            notify: true,
            value: false
        },
    crontoImageDataFlag: {
	      type: Boolean,
	      notify: true,
	      value: false,
          observer:'test'
    },
        //property for checking whether primary authentication is MPIN  or not.
        isPrimaryAuthMPin: {
            type: Boolean,
            notify: true,
            value: false
        },
        //property for showing resend button for OTP.
        otpLink: {
            type: Boolean,
            notify: true,
            value: false
        },
        //Property for enable and disable confirm button based on validations in case of OTP.
        isvalid: {
            type: Boolean,
            value: true,
            notify: true,
            observer: '_isValidChanged'
        },
        //Property for hide or show username input screen in case of user migration flow.
        userMigrationFlag: {
            type: Boolean,
            notify: true,
            value: true
        },
        publicKey: {
            type: Object,
            observer: 'publicKeySet'
        },
        accessTokenServiceParam: {
            type: String,
            notify: true
        },
        refreshTokenServiceParam: {
            type: String,
            notify: true
        },
        //If Biometric enabled in phone then this parameter will be set to true
        biometricAvailable: {
            type: Boolean,
            notify: true,
            value: false
        },
        //This parameter shows whether user is enabled for biometric login or not
        biometricEnabled: {
            type: Boolean,
            notify: true,
            value: false
        },
        //This stores the wrong password error
        biometricError: {
            type: Boolean,
            notify: true,
            value: false
        },
        //This parameter holds event required for biometric login in handleSuccessSignOn
        eventDataBiometric: {
            type: Object,
            notify: true
        },
        //This Parameter holds true if face biometric is present in phone
        biometricFace: {
            type: Boolean,
            notify: true,
            value: false
        },
        //This Parameter holds true if fingerprint biometric is present in phone
        biometricFinger: {
            type: Boolean,
            notify: true,
            value: false
        },
        //This Parameter holds true if plugin will not identify biometric type
        biometricCommon: {
            type: Boolean,
            notify: true,
            value: false
        },
        //This parameter holds true if mod eof authnetication is Password
        biometricPassword: {
            type: Boolean,
            notify: true,
            value: false
        },
        //This parameter holds true if mod eof authnetication is MPIN
        biometricMpin: {
            type: Boolean,
            notify: true,
            value: false
        },
        //To hide close button from back navigation popup
        closevisible: {
            type: Boolean,
            value: false
        },
        closevisiblelabel: {
            type: String,
            value: "b_Close"
        },
        //Stores accessCode un encrypted
        biometricAccessCode: {
            type: String,
            notify: true
        },
        //Stores final account details with balances
        quickBalanceAccountData: {
            type: Object,
            notify: true
        },
        //Enable view balance option when accounts are available
        viewBalanceButton: {
            type: Boolean,
            value: true,
            notify: true
        },
        //Enabled view balance feature only for remembered users
        viewBalanceFeatureDisabled: {
            type: Boolean,
            notify: true,
            value: true
        },
        //This parameter determines whether the dropdown is clicked or not to view quick balance accounts
        displayTransactionList: {
            type: Boolean,
            value: false,
            notify: true
        },
        height: {
            type: String,
            notify: true
        },
        //Stores quick balance account without balances
        quickBalanceAccounts: {
            type: Array,
            notify: true
        },
        viewExpandMoreBtn: {
            type: Boolean,
            notify: true
        },
        isPreloginQuickBalance : {
            type: String,
            value: "N",
            notify: true
        },
        showFooter: {
            type: Boolean,
            value: false,
            notify: true
        },
        proceedFlag: {
            type: Boolean,
            value: false,
            notify: true
        },
        selectedPage: {
            type: Number,
            notify: true,
            value: 0,
            observer:'_loginAgainFunc'
        },
        crontoResponse: {
            type: Object,
            notify: true,
            observer:'test'
        },
        dataBody:{
            type: Object,
            notify: true
        },
        EmailFlag: {
            type: Boolean,
            value: true,
            notify: true
        },
        emailAddress:{
            type: String,
            value: "",
            notify: true,
            observer:"_changeEmailFlag"
        },
        fromQrSuccess:{
            type: Boolean,
            notify: true 
        },
        testFlag:{
            type: Boolean,
            value: false,
            notify: true 
        },
        fromPlaystore:{
            type: Boolean,
            notify: true,
            value:false,
            observer:'_backtologin'
        },
        emailEnteredFlag:{
            type: Boolean,
            notify: true,
            value:true
        },
        primaryAuthMode : {
            type: String,
            value: "",
            notify: true
        },
        buttondisplayFlag:{
            type: Boolean,
            value: false,
            notify: true 
        },
        oneSpanPass: {
            type: String,
            value: "",
            notify: true 
        },
        oneSpanOtp: {
            type: String,
            value: "",
            notify: true 
        },
        phoneNumber: {
            type: String,
            value: "",
            notify: true 
        },
        authModeResponse: {
            type: Object,
            notify: true 
        },
        authModeBody: {
            type: Object,
            notify: true 
        },
        authSuccess: {
            type: Boolean,
            notify: true,
            observer:'_checkAuthSuccess'
        },
        checkData: {
            type: Object,
            notify: true 
        },
        softtokenOtp:{
            type: String,
            notify: true,
            observer:'_checkstkn'
        },
        selectedValue: {
            type: String,
            notify: true 
        },
        authModeList: {
            type: Array,
            notify: true 
        },
        resetMpin:{
            type: Boolean,
            value: false,
            notify: true,
            observer:'_clearusername' 
        },
        //login top text and bottom infotext Flag 
        loginTextShow: {
            type: Boolean,
            notify: true,
            value:false
        },
        maskedEmail: {
            type: String,
            notify: true 
        },
        checkphone: {
            type: String,
            notify: true,
            observer:'_checkMasked'
        },
    subpathPattern: {
      type: String,
      value: window.OEUtils.subPath,
      notify: true
    },
    finalRoute: {
      type: Object,
      value: {
	  path: "/"
	  },
      notify: true
    },
    route: {
      type: String,
      notify: true
    },
    subroute: {
      type: String,
      notify: true
    },
        forgetUserNameFlag: {
            type: Boolean,
            value: false,
            notify: true
        },
        forgetEmailIdValue: {
            type: String,
            notify: true 
        },
        forgetUserOtpFlag: {
            type: Boolean,
            value: false,
            notify: true
        },
        forgetuserIdValue: {
            type: String,
            notify: true 
        },
        resendOtpDisabled: {
            type: Boolean,
            value: true,
            notify: true,
            observer:"resenddisabled"
        },
        otpExpTime: {
            type: Number,
            notify: true
        },
        authModeObject:{
            type: Object,
            notify: true 
        },
        showTickerMessage:{
            type: Boolean,
            value: false 
        },
        backdrop:{
            type: Boolean,
            value: false
        },
        enableOtpCounter: {
            type: Boolean,
            value: false
        },
        customLabel: {
            type: String,
            value: "l_OtpValidationMsg",
            notify: true
        },
        openBankingLoggedin: {
            type: Boolean,
            value: false,
            notify: true
        }
    },
    listeners: {
        'app-fab-action': '_removeUser' //Remove user from remebered user lists

  },
  observers: ['showrememberedUserLists(rememberedUserLists.userDetailsList)',
  '_computeRoute(route,subroute)'],
  //This function is called when clicked Yes
  _computeRoute: function (route, subroute) {
        if (subroute && subroute.path) {
            this.finalRoute = subroute;
        } else {
            this.finalRoute = route;
        }
 },

  clickedYes: function (e) {
    var self = this;
    var bioData = clientStorage.get(storageType.local, 'BiometricEnabledData');
    var loginModeData = clientStorage.get(storageType.local, 'loginModeData');
    var modeOfAuthentication;

        if (this.loginModeData != undefined) {
            modeOfAuthentication = this.loginModeData.primaryAuthenticationMode.cmCode;
        } else if (loginModeData != undefined) {
            modeOfAuthentication = JSON.parse(loginModeData)[this.username.toUpperCase()][0];
        }

        //Store password in secure key chain for mobile. The value depends on loginModeData so we have 2 if conditions
        if ((channelType.android || channelType.iphone) && typeof Fingerprint != 'undefined' && typeof cordova != 'undefined' && cordova.plugins != undefined && (cordova.plugins.SharedPreferenceHandler != undefined || cordova.plugins.CDVKeychain != undefined)) {
            if (this.biometricAvailable && this.loginModeData != undefined && this.biometricAccessCode != undefined) {
                if (channelType.android) {
                    cordova.plugins.SharedPreferenceHandler.setDataString("my_app", "PID" + this.username.toUpperCase() + this.loginModeData.primaryAuthenticationMode.cmCode, this.biometricAccessCode, function (key) {
                        successCallBiometric(self); //console.log("Returns key on success " + key); 
                    }, function (error) { //console.log("Returns error on failure " + error);
                    });
                } else {
                    cordova.plugins.CDVKeychain.setForKey("PID" + this.username.toUpperCase() + this.loginModeData.primaryAuthenticationMode.cmCode, this.biometricAccessCode, function (key) {
                        successCallBiometric(self); //console.log("Returns key on success " + key); 
                    }, function (error) { //console.log("Returns error on failure " + error);
                    });
                }
            }


            if (this.biometricAvailable && this.loginModeData == undefined && this.accessCode != undefined) {
                var loginModeData = JSON.parse(clientStorage.get(storageType.local, 'loginModeData'));

                if (channelType.android) {
                    cordova.plugins.SharedPreferenceHandler.setDataString("my_app", "PID" + this.username.toUpperCase() + loginModeData[this.username.toUpperCase()][0], this.biometricAccessCode, function (key) {
                        successCallBiometric(self); //console.log("Returns key on success " + key); 
                    }, function (error) { //console.log("Returns error on failure " + error);
                    });
                } else {
                    cordova.plugins.CDVKeychain.setForKey("PID" + this.username.toUpperCase() + loginModeData[this.username.toUpperCase()][0], this.biometricAccessCode, function (key) {
                        successCallBiometric(self); //console.log("Returns key on success " + key); 
                    }, function (error) { //console.log("Returns error on failure " + error);
                    });
                }
            }
        }

        function successCallBiometric(self) {
            var temp = {}; //Setting BiometricEnabledData data for a user, show success message and continue login
            var username = self.username != undefined ? self.username : clientStorage.get(storageType.local, 'username');

            if (bioData == undefined) {
                temp[username.toUpperCase()] = [];
                temp[username.toUpperCase()].push(modeOfAuthentication);
                clientStorage.set(storageType.local, 'BiometricEnabledData', JSON.stringify(temp));
                if (!self.biometricError) {
                    self.fire('oe-show-success', {
                        message: getLabel("m_RegisterForBiometric")
                    });
                } else {
                    self.biometricError = false;
                }
                self.handleSuccessSignOn(self.eventDataBiometric);
            } else {
                var temp = JSON.parse(bioData);
                temp[username.toUpperCase()] = [];
                temp[username.toUpperCase()].push(modeOfAuthentication);
                clientStorage.set(storageType.local, 'BiometricEnabledData', JSON.stringify(temp));
                if (!self.biometricError) {
                    self.fire('oe-show-success', {
                        message: getLabel("m_RegisterForBiometric")
                    });
                } else {
                    self.biometricError = false;
                }
                self.handleSuccessSignOn(self.eventDataBiometric);
            }
        }
    },
    //This function is called when clicked No
    clickedNo: function (e) {
        //If clicked No then redirect to success login
        this.handleSuccessSignOn(this.eventDataBiometric);
    },
    //This navigates to other login mode Ex Password or MPIN login
    showOtherLoginMode: function () {
        this.biometricEnabled = false;
    },
    //This shows finger print scanner for login
    showBiometricLogin: function () {
        var self = this;
        //this.handleLogin("biometric");
        //This is to show finger print scanner and authenticate using Finger print scanner
        if ((channelType.android || channelType.iphone) && typeof Fingerprint != 'undefined' && typeof cordova != 'undefined' && cordova.plugins != undefined && (cordova.plugins.SharedPreferenceHandler != undefined || cordova.plugins.CDVKeychain != undefined)) {
            var newData;
            if (clientStorage.get(storageType.local, 'BiometricEnabledData') != undefined) {
                newData = JSON.parse(clientStorage.get(storageType.local, 'BiometricEnabledData'));
            }
            var userName = this.username;
            var loginModeData = clientStorage.get(storageType.local, 'loginModeData');
            //Check if biometric is enabled for a loggedin user and then proceed to show fingerprint scanner
            if ((newData != undefined) && (userName != undefined) && (loginModeData != undefined)) {
                var checkBiometricEnabled = newData[userName.toUpperCase()].indexOf(JSON.parse(loginModeData)[userName.toUpperCase()][0]);
                if (checkBiometricEnabled > -1) {
                    //Show finger print scanner
                    Fingerprint.show({
                        clientId: "BankName",
                        localizedReason: "Use TouchID to authenticate login",
                        clientSecret: "password", //Only necessary for Android
                        disableBackup: true
                    },
                        function successCallback() {
                            //Get stored password and continue login

                            if (channelType.android) {
                                cordova.plugins.SharedPreferenceHandler.getDataString("my_app", "PID" + this.username.toUpperCase() + JSON.parse(loginModeData)[userName.toUpperCase()][0],
                                    function (value) {
                                        self.accessCode = value;
                                        self.handleLogin();
                                    },
                                    function (error) { //console.log("Returns error on failure " + error);
                                    });
                            } else {
                                cordova.plugins.CDVKeychain.getForKey("PID" + this.username.toUpperCase() + JSON.parse(loginModeData)[userName.toUpperCase()][0],
                                    function (value) {
                                        self.accessCode = value;
                                        self.handleLogin();
                                    },
                                    function (error) { //console.log("Returns error on failure " + error);
                                    });
                            }


                        }.bind(this),
                        function errorCallback(err) {
                            //console.log(err);
                            this.fire('oe-show-error', getLabel('m_BiometricAuthenticationError'));
                        }.bind(this));
                }
            }

        } else {
            //Continue with normal flow if its not device and not registered for biometric
            this.handleLogin();
        }
    },
    languageChanged: function (e) {
        sessionStorage.lang = e.currentTarget.selectedItem.locale;
        var url = 'locales' + '/' + sessionStorage.lang + '.json';
        if (window.OEi18nMsg._loading.indexOf(url) < 0) {
            this.fire('start-processing-loader');
        }
        document.documentElement.setAttribute('lang', sessionStorage.lang);
        document.dir = e.currentTarget.selectedItem.dir;
        document.documentElement.dir = document.dir;
        document.body.setAttribute('dir', e.currentTarget.selectedItem.dir);
        this.$$('reg-carousel').$$('l2t-paper-slider').direction = document.dir;
        this.updateStyles(); //Changes for literals call

        var language = sessionStorage.lang || window.navigator.userLanguage || window.navigator.language || 'en-US';
        OEi18nMsg._loading.push('locales/' + language + '.json');
        OEi18nMsg.lang = language;

        this.backgrndLoc();
        Platform.performMicrotaskCheckpoint();

        var self = this;
        //stopping loader when oe-i18n-language-ready event is triggered from oe-i18n-mixin.js;
        window.addEventListener('oe-i18n-language-ready', function () {
            self.fire('stop-processing-loader');
        });
        if (sessionStorage.lang == "en-US") {
          self.fire('stop-processing-loader');
        }
    },

    _HideSlider: function (e) {
        // this.set('showNotification', !this.showNotification);
        if (screen.width <= 767) {
            // this.shadowRoot.querySelector("#custom-slider").setAttribute("style", 'opacity:0;');
            this.shadowRoot.querySelector(".login-iron-icon").setAttribute("style", 'color:var(--brand-color);');
            this.shadowRoot.querySelector(".login-light-input-style").setAttribute("style", 'border: 1px solid var(--brand-color);border-radius: 6px; ');
            this.shadowRoot.querySelector("#custom-imageee").setAttribute("style", 'width:80px;');
            this.shadowRoot.querySelector(".bank-name").setAttribute("style", 'font-size: var(--a-font-size-m);color: var(--primary-light-color);');
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:-204px;');
            if (this.shadowRoot.querySelector('#originalU')) this.shadowRoot.querySelector('#originalU').shadowRoot.querySelector("paper-input-container").querySelector('label').setAttribute("style", 'display:none;');
        }
    },
    _ShowSlider: function (e) {
        // this.set('showNotification', !this.showNotification);
        if (screen.width >= 320 && screen.width <= 321) {
            // this.shadowRoot.querySelector("#custom-slider").setAttribute("style", 'opacity:1;');
            this.shadowRoot.querySelector("#custom-imageee").setAttribute("style", 'width:auto;');
            this.shadowRoot.querySelector(".bank-name").setAttribute("style", 'font-size:var(--a-font-size-l);color: var(--primary-light-color);');

            if (this.displayTransactionList == false) {
                this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top: -94px;');
            } else {
                var lengthOfList = this.quickBalanceAccountData.length;
                var top = (lengthOfList - 1) * this.height - 94 + "px";
                this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:' + top);
            }
        }

        if (screen.width >= 322 && screen.width <= 375) {
            // this.shadowRoot.querySelector("#custom-slider").setAttribute("style", 'opacity:1;');
            this.shadowRoot.querySelector("#custom-imageee").setAttribute("style", 'width:auto;');
            this.shadowRoot.querySelector(".bank-name").setAttribute("style", 'font-size:var(--a-font-size-l);color: var(--primary-light-color);');

            if (this.displayTransactionList == false) {
                this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top: -78px;');
            } else {
                var lengthOfList = this.quickBalanceAccountData.length;
                var top = (lengthOfList - 1) * this.height - 78 + "px";
                this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:' + top);
            }
        }

        if (screen.width >= 376 && screen.width <= 479) {
            // this.shadowRoot.querySelector("#custom-slider").setAttribute("style", 'opacity:1;');
            this.shadowRoot.querySelector("#custom-imageee").setAttribute("style", 'width:auto;');
            this.shadowRoot.querySelector(".bank-name").setAttribute("style", 'font-size:var(--a-font-size-l);color: var(--primary-light-color);');

            if (this.displayTransactionList == false) {
                this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top: -75px;');
            } else {
                var lengthOfList = this.quickBalanceAccountData.length;
                var top = (lengthOfList - 1) * this.height - 75 + "px";
                this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:' + top);
            }
        }

        if (screen.width >= 480 && screen.width <= 767) {
            // this.shadowRoot.querySelector("#custom-slider").setAttribute("style", 'opacity:1;');
            this.shadowRoot.querySelector("#custom-imageee").setAttribute("style", 'width:auto;');
            this.shadowRoot.querySelector(".bank-name").setAttribute("style", 'font-size:var(--a-font-size-l);color: var(--primary-light-color);');

            if (this.displayTransactionList == false) {
                this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top: -75px;');
            } else {
                var lengthOfList = this.quickBalanceAccountData.length;
                var top = (lengthOfList - 1) * this.height - 75 + "px";
                this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:' + top);
            }
        }
    },
    _HidePasswordBar: function (e) {
        if (screen.width <= 767) {
            this.shadowRoot.querySelector(".login-page-iron-icon").setAttribute("style", 'color:var(--brand-color);');
            //Added this condition for error handling of undefined check
            if (this.shadowRoot.querySelector(".custom-margin-light-input-style")) {
                this.shadowRoot.querySelector(".custom-margin-light-input-style").setAttribute("style", 'border: 1px solid var(--brand-color);border-radius: 10px;--primary-color: transparent !important; ');
            }
        }
    },
    // Method to call Login on click of enter in Password Field
    navigateLogin: function (e) {
        //checks whether the pressed key is "Enter"
        if (e.keyCode === 13) {
            //checks for username and calling loginmodes method
            if (e.currentTarget.id === 'originalU') {
                this.handleLoginmodes();
            }
            //checks for password and calling login method
            if (e.currentTarget.id === 'originalP') {
                this.handleLogin();
            }
        }
    },
    _HideBorderBottom: function (e) {
        if (screen.width <= 767) {
            if (this.shadowRoot.querySelector('#originalU')) this.shadowRoot.querySelector('#originalU').shadowRoot.querySelector("paper-input-container").querySelector('label').setAttribute("style", 'display:none;');
            if (this.shadowRoot.querySelector('#originalU')) this.shadowRoot.querySelector('#originalU').shadowRoot.querySelector("paper-input-container").shadowRoot.querySelector('.underline').querySelector('.focused-line').setAttribute("style", 'border-color: transparent;');
        }
    },
    _BtnLoginCnfrm: function (e) {
		
		// code to mark the performance of Login....executed on click of confirm button on the UI
		if (window.config.SpeedBoat.App.uplodPerformanceLogsToDb === true) {
		  document.body.addEventListener('dom-changed', e => {
			if (performance.getEntriesByName("Login").length === 0) {
			  if (performance.getEntriesByName('Login_button_clicked').length === 0) {
				performance.mark('Login_button_clicked');
			  }

			  if (
				e.detail[0].target.id == "opacity-screen" &&
				sessionStorage.isCorporateUser === "false"
			  ) {
				performance.mark('Login_completed');
				performance.measure('Login', 'Login_button_clicked', 'Login_completed');
				performance.clearMarks();
				sendPerformance("login_to_dashboard");
			  }
			  if (
				e.detail[0].type == "childList" &&
				e.detail.length === 1 &&
				e.detail[0].target.localName === "body" &&
				sessionStorage.isCorporateUser === "true"
			  ) {
				performance.mark('Login_completed');
				performance.measure('Login', 'Login_button_clicked', 'Login_completed');
				performance.clearMarks();
				sendPerformance("login_to_dashboard");
			  }
			}
		  });
		}
		
        //To reset biometric value enabled
        this.biometricEnabled = false;
        if (screen.width <= 767) {
            if (this.shadowRoot.querySelector('#originalP')) this.shadowRoot.querySelector('#originalP').shadowRoot.querySelector("paper-input-container").querySelector('label').setAttribute("style", 'display:none;');
        }
    },

    /*Remove user from remebered user lists*/
    _removeUser: function (e) {
        // commented since e.path is not defined in IE browser.
        var index = e.path[0].__data.index;
        // var index = e.srcElement.__dataCounter;

        if (localStorage.userDetails) {
            var tempUserList = JSON.parse(localStorage.userDetails);
        }

        if (tempUserList.userDetailsList.length > 0) {
            var i = 0;

            while (i < tempUserList.userDetailsList.length) {
                if (i === index) {
                    if (tempUserList.userDetailsList[i] === tempUserList.prevLoggedIn) {
                        tempUserList.prevLoggedIn = tempUserList.userDetailsList[i - 1];

                        this._SwitchUser(this.rememberedUserLists[i - 1]);

                        if (this.rememberedUserLists[i].activeClass === 'active-user') {
                            var temp = this.rememberedUserLists[i - 1];
                            if (temp != undefined) temp.activeClass = 'active-user';
                            this.splice('rememberedUserLists', index - 1, 1);
                            this.splice('rememberedUserLists', index - 1, 0, temp);
                        }
                    } else {
                        this._SwitchUser(this.rememberedUserLists[i + 1]);
                    }
                    this.splice('rememberedUserLists', index, 1);

                    tempUserList.userDetailsList.splice(index, 1);
                }

                i++;
            }

            if (tempUserList.userDetailsList.length === 0) {
                this._SwitchNewUser();
            }

            localStorage.userDetails = JSON.stringify(tempUserList);
        }
    },
    /*Remove user from remebered user lists*/


    /*Login as new user */
    checkUserName: function () {
        if (this.username != "" && this.rememberedUserName != this.username) {
            this.notFirstTimeUser = true;
        } else {
            this.notFirstTimeUser = false;
        }
    },
    _SwitchNewUser: function () {
        this.showProfileName = false;
        this.isPrimaryAuthOtp = false;
        this.show = false;
        this.username = '';
        this.$$("#originalU").invalid = false;
        this.$$('#selectUser').close();
        this.notFirstTimeUser = false;
        this.showUserName = '';
        //Added this code to hide previos user quick balance view
        this.viewBalanceFeatureDisabled = true;
        this.viewBalanceButton = true;
    },
    /*Login as new user */

    /*Switch User*/
    _SwitchUser: function (e) {
        var temp;
        if (e === undefined) {
            this._SwitchNewUser();
        } else if (e.model != undefined) {
            temp = e.model.item;
            this.username = temp.username;
            this.rememberedUserName = temp.rememberedUserName;
            var activeUser = this.shadowRoot.querySelector('.active-user');
            activeUser.classList.remove('active-user');
            e.currentTarget.querySelector('app-fab').classList.add('active-user');
            // below function is to call auth mode and Genreate OTP in case SOTP 
            this.handleLoginmodes();
            this.viewBalanceFeatureDisabled = true;
            this.viewBalanceButton = true;
            this.toggleViewBalanceFlag();
            this.$$('#selectUser').close();
        } else {
            temp = e;
            this.username = temp.username;
            this.rememberedUserName = temp.rememberedUserName;
        }
        if (temp != undefined && temp.rememberedUserName != undefined)
            this.showUserName = temp.rememberedUserName;

    },
    /*Switch User*/

    goToCancel: function () {
        this.show = false;
        this.username = "";
        this.rememberMe = false;
        this.customLabel = "l_OtpValidationMsg";
        // set focus on username field
        this.$$("#originalU").focus();
        this.$$("#originalU").errorMessage = "l_EnterUserName";
        this.$$("#originalU").invalid = false;
        this.isPrimaryAuthOtp = false;
        //fix for defect 299437
        if (this.accessCode != "") {
            this.$$("#originalP").value = "";
            this.$$("#originalP").invalid = false;
        }
        this.EmailFlag=true;
    },
    gotoMpinflow: function () {
        // this.shadowRoot.querySelector('literal-cache')._fetchLanguage();
        this.closeVirtualKeyboard(); //this.selected = 4;
        if (typeof device != 'undefined') {
            var self = this;
            device.getInfo(function (result) {
                var bodyDet = {
                    "userId": self.loginModeData.userId,
                    "orgId": self.loginModeData.userId,
                    "mobileNumber": device.number ? device.number : "9999900000",
                    "userType": self.loginModeData.userType,
                    "deviceId": result.uuid,
                    "deviceName": result.deviceName,
                    "deviceType": "deviceType"
                };

                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/UserDevices";
                ajaxCall.method = "post";
                ajaxCall.body = bodyDet;
                ajaxCall.addEventListener('error', function (err) {
                    self.userMigrationFlag = false;
                    self.ErrMsg = "";
                    if (err.detail.request.__data.response.error && err.detail.request.__data.response.error.message) {
                        var response = err.detail.request.__data.response.error.message;
                        response.deviceName = result.deviceName;
                        self.mpinAuthList = response;
                    }
                    // self.fire('stop-processing-loader');
                });
                oeAjaxEventListner(ajaxCall);
                /* Payload Encryption code - START */
                ajaxCall.body = document.getElementById('keyManagement').setSymKey(ajaxCall.body);
                /* Payload Encryption code - ENDS */
                // self.fire('start-processing-loader');
                ajaxCall.generateRequest();
            }, function (err) {
                //handle error or show mpin 
            });
        } else {
            var bodyDet = {
                "userId": this.loginModeData.userId,
                "orgId": this.loginModeData.userId,
                "mobileNumber": device.number ? device.number : "9999900000",
                "userType": this.loginModeData.userType,
                "deviceId": "result.uuid",
                "deviceName": "result.deviceName",
                "deviceType": "deviceType"
            };
            var self = this;
            var ajaxCall = document.createElement('oe-ajax');
            ajaxCall.contentType = "application/json";
            ajaxCall.handleAs = "json";
            ajaxCall.url = "/api/UserDevices";
            ajaxCall.method = "post";
            ajaxCall.body = bodyDet;
            ajaxCall.addEventListener('error', function (err) {
                self.userMigrationFlag = false;
                self.ErrMsg = "";
                if (err.detail.request.__data.response.error && err.detail.request.__data.response.error.message) {
                    self.mpinAuthList = err.detail.request.__data.response.error.message;
                }
                // self.fire('stop-processing-loader');
            });
            oeAjaxEventListner(ajaxCall);
            /* Payload Encryption code - START */
            ajaxCall.body = document.getElementById('keyManagement').setSymKey(ajaxCall.body);
            /* Payload Encryption code - ENDS */
            // self.fire('start-processing-loader');
            ajaxCall.generateRequest();
        }

    },
    handleATMLocator: function () {
        //this.shadowRoot.querySelector('literal-cache')._fetchLanguage();
        this.selected = 2;
        clientStorage.set(storageType.session, 'ATMLocatorOpenBeforeLogin', true);
        /* This condition is added to load chunk file in webpack build and actual file in polymer build. Once webpack build is enabled
        the condition and addImportLink function can be replaced with the import statement alone */
        if (window.webpackEnabled) {
            import(/* webpackChunkName: "elements-locator" */ './elements-locator.js').then(() => {
                console.debug('retail locator elements import loaded!!!');
            });
        } else {
            addImportLink('./node_modules/speedboat_ui/elements/elements-locator.js', true, function () { });
        }
    },
    showrememberedUserLists: function () {
        this.checkUserList = true;
    },
    closeVirtualKeyboard: function () {
        if (document.querySelector('.keyboard-container') != null) {
            document.querySelector('.keyboard-container').classList.remove('visible');
        }
    },
    checkIfDevice: function () {
        if (navigator.userAgent.match(/Android|iPhone|iPad/i)) return true;
        return false;
    },
    // _onChangeBaseurl: function () {
    //     window.localStorage.setItem('baseurl', this.baseurl);
    //     clientStorage.set(storageType.local,'baseurl', this.baseurl);
    // },
    _onChangeToken: function () {
        if (this.token != "") this.handleLogin();
    },
    importsToLoad: function () {
        var self = this; //disable the login button untill all required element imports are loaded

        self.asyncImportsLoaded = false;
        var mbody = document.getElementById('mainbody');
        document.addEventListener('connection-is-ok', function () {
            self.connectionStatus = true;
            if (mbody.asyncImportsLoaded) self.asyncImportsLoaded = true;
        }); //after elements-speedup this event is triggered in main document index.html

        document.addEventListener('async-imports-loaded', function () {
            if (self.connectionStatus) self.asyncImportsLoaded = true;
        });
        this.connectionStatus = window._no_connection ? false : true; //in the rare case of asynch imports getting loaded before the ev-login is ready,
        //the above event would have already happened. so check the flag set in main document.

        if (mbody.asyncImportsLoaded && this.connectionStatus) {
            self.asyncImportsLoaded = true;
        } //this.baseurl  = clientStorage.get(storageType.local,'baseurl');


        this.baseurl = window.localStorage.getItem('baseurl');
        this.voiceInputHidden = false;
        if (channelType.iphone || channelType.android) this.voiceInputHidden = true;
    },
    addKeyboardId: function () {
        if (!this.shadowRoot.querySelector("#vkeyboard").getAttribute("data-target-id")) {
            var self = this;
            var script = document.createElement('script');
            script.type = "application/javascript";
            script.src = "node_modules/sb_virtualkeyboard_ui/dist/virtual-keyboard.min.js";

            script.onload = function () {
                var styles = document.createElement('link');
                styles.type = "text/css";
                styles.rel = "stylesheet";
                styles.href = "node_modules/sb_virtualkeyboard_ui/dist/virtual-keyboard.css";

                styles.onload = function () {
                    document.dispatchEvent(new Event('VirtualKeyboardCSSLoaded'))
                    self.shadowRoot.querySelector("#vkeyboard").setAttribute('data-target-id', 'originalP');
                    self.shadowRoot.querySelector("#vkeyboard").click();
                };
                document.head.appendChild(styles);
            };
            document.head.appendChild(script);

            var styles2 = document.createElement('link');
            styles2.type = "text/css";
            styles2.rel = "stylesheet";
            styles2.href = "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
            document.head.appendChild(styles2);
        } else {
            this.accessCode = ''; //This is for resetting value of password when virtual keyboard event is triggered. This is done for security reasons
            this.resetVirtualKeyboard = !this.resetVirtualKeyboard;
            this.$$("#originalP").invalid = false;
        }
    },
    _tenantIdChanged: function (tenant) {
        if (tenant) {
            sessionStorage.tenantId = tenant;
            this.hideLangPicker = false;
        }
    },


    isVersionPresent: function (version, versionArray) {
        for (var i = 0; i < versionArray.length; i++) {
            if (window.compareVersions(version, versionArray[i]) === 0) {
                return true;
            }
        }
        return false;
    },

    _localeChanged: function (newLocale) {
        OEi18nMsg.lang = newLocale;
        sessionStorage.lang = newLocale;
        Platform.performMicrotaskCheckpoint();
    },

    //Shortcuts Plugin Android: @Start
    getShortcutsData: function (data) {
        this.shortcutsData = data;
    },
    shortcuts: function () {
        const self = this;
        if (isDevMode() && typeof ShortCutPlugin != 'undefined') {

            var jsonArray = [];
            jsonArray.push({
                "ShortcutsSelected": []
            });

            if (typeof ShortCutPlugin != 'undefined') {
                ShortCutPlugin.modifyShortCutList(function (data) {

                    //var myPage2 = document.querySelector('ev-login');
                    self.getShortcutsData(data);
                    return;

                }, function () {

                }, function () {

                }, jsonArray);
            }
        }

    },
    //Shortcuts Plugin Android: @End

    //Security - OS and App version check @Start
    osVersionCheck: function () {

        var body = {
            device: window.device,
            appVersion: window.AppVersion.version
        };

        // making call for os and app version //
        this.$.osnappchecks.url = "/auth/versionchecks";
        this.$.osnappchecks.body = JSON.stringify(body);
        this.$.osnappchecks.generateRequest();
    },

    // method for handling success response when device is compatible.It wil render login screen //
    handleOSnAppChecksResponse: function (e) {
        if (e.detail.response.status === "SUCCESS") {
            this.exitQueue(true);
        } else {
            this.exitQueue(false);
        }
    },

    // method for handling error response when device is not compatible. It wil not render login screen //
    handleOSnAppChecksError: function (e) {
        // alert("inside handleOSnAppChecksError");
        if (e != undefined && e.detail.error != undefined) {

            //Present an ovrelay to prevent the app from showing the login screen on error

            this.showLoginPageFlag = false;
            var errCode = e.detail.request.response.error.code;
            if (errCode === 'OS_VERSION_CHECK_FAILED') {
                this.fire('oe-show-error', {
                    code: "l_updateOS",
                    forever: true
                });
                this.exitQueue(false);
            } else if (errCode === 'APP_VERSION_CHECK_FAILED') {
                this.fire('oe-show-error', {
                    code: "l_updateApp",
                    forever: true
                });
                this.exitQueue(false);
            } else {
                this.fire('oe-show-error', {
                    code: "l_SomethingWentWrong",
                    forever: true
                });
                this.exitQueue(false);
            }
        }
    },
    enterQueue: function () {
        this.initLoadQueue.push("1");
    },
    exitQueue: function (state) {
        this.initLoadQueue.pop();
        if (state == false) {
            this.showLoginPage = state;
        }
        if ((this.initLoadQueue.length == 0)) {
            this.set('showLoginPageFlag', this.showLoginPage);
        }
    },

    //Security - OS and App version check @End

    attached: function () {
        this.$.tickermessageapi.url = "/auth/customtickerdetails";
        var body = {
            channel_id: window.getChannelId(),
            tenantId: this.tenantId
        };
        this.$.tickermessageapi.body = JSON.stringify(body);
        this.$.tickermessageapi.generateRequest();
        this.userMigrationFlag = false;
        var self = this;
        window.deeplink = {};
        window.deeplink.enabled = false;
        window.deeplink.url = "";

        if (window.location.href.includes("business-components")) {
            import('../../@polymer/app-layout/app-layout.js').then(function () {
                this.selected = 16;
                mainbody.initializeBusinessComponentsList();
            }.bind(this))
            return;
        }

        if ((window.location.href.indexOf("?OCH_DATA=") >= 0 || window.location.href.indexOf("&OCH_DATA=") >= 0) && document.querySelector("#preLoginIronPages") != undefined) {
            import('./customer-assist-login-landing.js').then(function () {
                this.selected = 13;
            }.bind(this));
            return;
        }

        if (window.location.href.includes("shopping-mall")) {
            import('./shopping-mall-landing.js').then(function () {
                this.selected = 15;
            }.bind(this));
            return;
        }
        if (window.location.href.includes("observe")) {
            import('../../sb_observable_ui/elements/observability-ui.js').then(function () {
                this.selected = 17;
            }.bind(this));
            return;
        }
        if (window.location.href.includes("log")) {
            import('./logs-reader.js').then(function () {
                this.selected = 18;
            }.bind(this));
            return;
        }
        if (window.location.href.indexOf("?OPB_ERROR=") >= 0 || window.location.href.indexOf("&OPB_ERROR=") >= 0) {
            import('./open-banking-error-handler.js').then(function () {
                this.selected = 21;
            }.bind(this));
            return;
        }
        /*if (window.location.href.includes("component-catalog")) {
            import('../../sb_component_catalog_ui/elements/component-catalog.js').then(function () {
                this.selected = 19;
            }.bind(this));
            return;
        }*/
        // below logic check for service_resolver_param in URl for user migration flow mvf:-289442.
        if (window.location.href.includes("service_resolver_param")) {
            this.userMigrationFlag = true;
        }


        if (isDevMode()) {
            this.isDemoMode = true;
        }
        // this.$$("#fmpwd2").value = "dummy";
        // this.$$("#pwd1").value = "dummy";
        //this._initGoogleDrive();
        this._loadCaptcha();
        this.shortcuts();
        this.importsToLoad();
        //var fetchedUserName = window.localStorage.getItem('username');
        //  if(fetchedUserName!=undefined && fetchedUserName!=null)
        //     this.username=fetchedUserName;
        if (sessionStorage.tenantId && sessionStorage.tenantId != 'undefined') {
            this.tenant_id = sessionStorage.tenantId;

            this.locale = this.lang || sessionStorage.lang || window.navigator.userLanguage ||
                window.navigator.language;

            //To stop first literals call
            // OEi18nMsg._loading = [];
            // OEi18nMsg._loading.push('locales/' + locale + '.json');

            // this.locale = locale;


            this.hideLangPicker = false;
            this.hideLoginSection = false;
        } else {
            this.hideLangPicker = true;
            this.hideLoginSection = true;
        }
        this.selected = 0;
        this.corporateId = -1;

        //Security - OS and App version check @Start
        this._deviceready = this.onDeviceready.bind(this);
        //Use this event listener to call plugins and other reated operations
        document.addEventListener("deviceready", this._deviceready, false);
        //Security - OS and App version check @End

        //TrulyHybrid - Attaching ShareSession Call
        var self = this;
        document.addEventListener("shareSession", function (e) {
            try {
                if (typeof e == "string") {
                    e = JSON.parse(e);
                }
                var event = new CustomEvent("login-req");
                document.dispatchEvent(event);
                self.loginModeData = e.detail.response.loginModeData;
                var mbody = document.getElementById('mainbody');
                mbody.loginModeData = e.detail.response.loginModeData;
          if (e.detail.response.loginModeData.primaryAuthenticationMode.cmCode == "MPIN") {
                window.showMpinButton = true;
          }
                self._setShareSessionSymKey(atob(e.detail.response.activeSymKey));
                
                self._setShareSessionParams(e.detail.response.loginData);
                if(e.detail.response.tempAccessCode) {
					self._setTempAccessCode(e.detail.response.tempAccessCode);
				}
                self.handleResponse(e.detail.response.loginData);
            } catch (error) {
                console.log("shareSession " + error);
            }
        });
        //TrulyHybrid - Attaching ShareSession Call @end
        document.addEventListener("Deeplink", function (e) {
            window.deeplink = {};
            window.deeplink.enabled = true;
            window.deeplink.url = e.detail.response.url;
        });

        document.addEventListener("goToPasswordLanding", function (e) {
            self.closeVirtualKeyboard(); //this.selected = 4;
            if (window.webpackEnabled) {
                import(/* webpackChunkName: "forgot-password-landing" */ "./forgot-password-landing.js").then(() => {
                    console.debug("forgot password landing import loaded!!!");
                });
            } else {
                addImportLink('./node_modules/speedboat_ui/elements/forgot-password-landing.js', true, function () { });
            }
            
            self.forgotUserList = e;
        });

        document.addEventListener("_goToCreateAccount", function () {
            self.createAccount();
        });

        document.addEventListener("_goToATMLocator", function () {
            self.handleATMLocator();
        });

        if (localStorage.userDetails) {
            this.rememberedUserLists = [];
            this.rememberedUserListsTemp = [];

            var temp = JSON.parse(localStorage.userDetails).userDetailsList;
            var prevLoggedIn = JSON.parse(localStorage.userDetails).prevLoggedIn;
            var indexOf = temp.indexOf(prevLoggedIn);
            if (prevLoggedIn != undefined) {
                var prevLoggedInVal = prevLoggedIn.split('=');
                if (prevLoggedInVal.length > 0) {
                    this.rememberedUserName = unescape(prevLoggedInVal[0]);
                    this.username = unescape(prevLoggedInVal[1]);
                }
            }
            /*Fetching all the remebered user list*/
            for (var i = 0; i < temp.length; i++) {
                var arr = temp[i].split('=');
                if (arr.length > 0) {
                    var tempObj = {};
                    tempObj.rememberedUserName = unescape(arr[0]);
                    tempObj.username = unescape(arr[1]);
                    if (i === indexOf) {
                        tempObj.activeClass = 'active-user';
                    } else {
                        tempObj.activeClass = '';
                    }
                    this.rememberedUserListsTemp.push(tempObj);
                    this.showProfileName = true;
                    this.hideCaptcha = true;
                    this.show = true;
                    // to fetch the value for isPrimaryAuthOtp from localstorage in case of remember username flow.
                    this.isPrimaryAuthOtp = JSON.parse(localStorage.userDetails).isPrimaryAuthOtp;
                    if (this.isPrimaryAuthOtp || this.isPrimaryAuthMPin) {
                        this.handleLoginmodes();
                    }
                }
            }
            this.set('rememberedUserLists', this.rememberedUserListsTemp);
            /*Fetching all the remebered user list*/

        } else {
            this.showProfileName = false;

        }
        this.checkUserName();
        if (this.rememberedUserName != '') {
            this.showUserName = this.rememberedUserName;
        } else {
            this.showUserName = '';
        }
        if (channelType.iphone || channelType.android) {
            document.querySelector('body').classList.add('device-phone');
        }
        this.backgrndLoc();
        if (isDevMode()) {
            //this.backgrndLoc();
        }

        window.addEventListener("WebComponentsReady", () => {
            if (screen.width <= 767) {
                if (this.shadowRoot.querySelector('#originalU'))
                    this.shadowRoot.querySelector('#originalU').shadowRoot.querySelector("iron-input").querySelector('input').setAttribute("style", 'position: relative;top: -13px;left: 0px;font-size: var(--a-button-font-size);color: var(--primary-dark-color);opacity:0.93;');
                if (this.shadowRoot.querySelector('#originalP'))
                    this.shadowRoot.querySelector('#originalP').shadowRoot.querySelector("iron-input").querySelector('input').setAttribute("style", 'position: relative;top: -13px;left: 0px;font-size: var(--a-button-font-size);color: var(--primary-dark-color);opacity:0.93; ');
                if (this.shadowRoot.querySelector('#langCombo'))
                    this.shadowRoot.querySelector('#langCombo').shadowRoot.querySelector("paper-input-container").querySelector('input').setAttribute("style", 'margin: -24px 0px 0px 8px;font-size: var(--a-button-font-size);color: var(--primary-dark-color);opacity:0.93;');
                if (this.shadowRoot.querySelector('#langCombo'))
                    this.shadowRoot.querySelector('#langCombo').shadowRoot.querySelector("paper-input-container").querySelector('#dropdownicon').setAttribute("style", 'position: relative;top: -11px;color: var(--secondary-dark-color);');
                if (this.shadowRoot.querySelector('#langCombo'))
                    this.shadowRoot.querySelector('#langCombo').shadowRoot.querySelector("paper-input-container").querySelector('#dropdownicon').setAttribute("style", 'position: relative;top: -11px;color: var(--secondary-dark-color);');
                if (this.shadowRoot.querySelector('#originalU'))
                    this.shadowRoot.querySelector('#originalU').shadowRoot.querySelector("paper-input-container").querySelector('label').setAttribute("style", 'margin: -11px 0px 0px 0px;font-size: 15px;color: var(--primary-dark-color);opacity:0.57;');
                if (this.shadowRoot.querySelector('#originalP'))
                    this.shadowRoot.querySelector('#originalP').shadowRoot.querySelector("paper-input-container").querySelector('label').setAttribute("style", 'display:none;');
                if (this.shadowRoot.querySelector('#originalU'))
                    this.shadowRoot.querySelector('#originalU').shadowRoot.querySelector("paper-input-container").shadowRoot.querySelector('.underline').querySelector('.focused-line').setAttribute("style", 'border-color: transparent;');
                if (this.shadowRoot.querySelector('#originalP'))
                    this.shadowRoot.querySelector('#originalP').shadowRoot.querySelector("paper-input-container").shadowRoot.querySelector('.underline').querySelector('.focused-line').setAttribute("style", 'border-color: transparent;');

            } else {
                if (this.shadowRoot.querySelector('#originalU'))
                    this.shadowRoot.querySelector('#originalU').shadowRoot.querySelector("iron-input").querySelector('input').setAttribute("style", 'color:white');
                if (this.shadowRoot.querySelector('#langCombo'))
                    this.shadowRoot.querySelector('#langCombo').shadowRoot.querySelector("iron-input").querySelector('input').setAttribute("style", 'color:white');
            }
        });

        var self = this;
        document.addEventListener("onEnterKey_VK", () => {
            self.closeVirtualKeyboard();
            self.handleLogin();
        });

        if (channelType.android) {
            this.toggleViewBalanceFlag();
        }

        if (channelType.iphone) {
            this.toggleViewBalanceFlag();
        }

        //TODO This is for Android. Need to merge code android specific block in attached
        //Check if biometric is available in the device or not
        if ((channelType.android) && typeof Fingerprint != 'undefined' && typeof cordova != 'undefined' && cordova.plugins != undefined && (cordova.plugins.SharedPreferenceHandler != undefined || cordova.plugins.CDVKeychain != undefined)) {
            Fingerprint.isAvailable(isAvailableSuccess, isAvailableError);

            //Success function called if biomtric is enabled in mobile
            function isAvailableSuccess(result) {
                /*
                result depends on device and os.
                iPhone X will return 'face' other Android or iOS devices will return 'finger'
                */

                self.biometricAvailable = true;
                if (result == 'face') {
                    self.biometricFace = true;
                }
                if (result == 'finger') {
                    self.biometricFinger = true;
                }
                if (result == 'biometric') {
                    self.biometricCommon = true;
                }

                //check whether user is enabled for biometric or not
                if (self.username != undefined) {
                    var biometricEnabledData = clientStorage.get(storageType.local, 'BiometricEnabledData');
                    var userName = self.username.toUpperCase();
                    var loginModeData = clientStorage.get(storageType.local, 'loginModeData');
                    //Based on the authentication mode check whether user is enabled for biometric or not and set biometricEnabled flag
                    if (biometricEnabledData != undefined && (Object.keys(JSON.parse(biometricEnabledData)).length != 0) &&
                        (JSON.parse(biometricEnabledData)[userName] != undefined) && (loginModeData != undefined) && (Object.keys(JSON.parse(loginModeData)).length != 0) &&
                        (JSON.parse(biometricEnabledData)[userName].indexOf(JSON.parse(loginModeData)[userName][0]) > -1)) {

                        self.biometricEnabled = true;

                        if (JSON.parse(loginModeData)[userName][0] == "SPWD") {
                            self.biometricPassword = true;
                        } else if (JSON.parse(loginModeData)[userName][0] == "MPIN") {
                            self.biometricMpin = true;
                        }

                    } else {
                        self.biometricEnabled = false;
                    }
                }
            }

            //Failure function caaled if biometric is enabled in mobile
            function isAvailableError(error) {
                //console.log(error);
                self.biometricAvailable = false;
                // 'error' will be an object with an error code and message
            }
        }
        
        window.addEventListener('useridotpValue',  this.otpValueFunction.bind(this)); 
    },
    ready: function ready() {
        const self = this;
        if (channelType.iphone || channelType.android) {
            var backgroundImgSrc = this.imageBaseUrl + "/node_modules/speedboat_ui/images/" + sessionStorage.getItem("tenantId") + "/login/Login_background.jpg";
            document.querySelector('body').classList.add('device-phone');
            setTimeout(() => {
                this.shadowRoot.querySelector("#mobile_background").style.backgroundImage = "url(" + backgroundImgSrc + ")";
            }, 1000);
        }
    },
    onDeviceready: function () {
        /*
            Important: We manage a queue here to perform various initialization
            checks. The queue is to determine the completion of all tasks.
            When the queue is exhausted, we perfom additional steps.
           
            
            Therefore, any such tasks must call "window.AppVersion) {
               this.enterQueue()" function before the task
            and call "window.AppVersion) {
               this.exitQueue()" function after the task
           
            In addition the flag "this.showLoginPage" must also be set to control
            the display of login screen
           */

        // Now safe to use device APIs
        //Security - OS and App version check @Start

        var self = this;
        if (typeof routerPolicy != "undefined") {
            window.goToNative = {};
            goToNative.enabled = true;
            self.shadowRoot.querySelector("#share-session-wrapper").setAttribute("style", 'display:none;');
        }

        if (typeof cordova != "undefined" && typeof (cordova.InAppBrowser) != "undefined" && (typeof (cordova.InAppBrowser.open) == "function")) {
            window.open = cordova.InAppBrowser.open;
        }


        if (window.navigator.network.connection.type !== "none" && window.navigator.network.connection.type !== "unknown") {
            this.set('showLoginPageFlag', false);
            if (window.AppVersion) {
                this.enterQueue();
                this.osVersionCheck();
            } else {
                self.exitQueue(false);
                //  console.log(
                //      "Missing cordova plugins: 1) cordova-plugin-device 2) cordova-plugin-appversion"
                //  );

            }
        }
        //Security - OS and App version check @End

        //EVAuth @Start

        //On successful EVAuth initialization, check registration status
        //  var successFun = function () {

        //      var successRegCheckFun = function (response) {

        //          if (typeof (response) === 'object') {
        //              if (response["Reg_State"] != undefined) {
        //                  if (response["Reg_State"] === true) {
        //                      // Store registration state in storageType.session
        //                      clientStorage.set(storageType.session, 'Reg_State',
        //                          true);
        //                  }
        //              }
        //          }
        //      };

        //      var errorRegCheckFun = function () {
        //          alert('Error dashboard-settings');
        //      };

        //      evauth.isRegistered(successRegCheckFun, errorRegCheckFun);

        //  };

        //  var errorFun = function () {

        //  };

        /*if (evauth) {
        evauth.setup(successFun, errorFun)
        }*/
        //EVAuth @End

        if (device.platform == "Android" || device.platform == "iOS") {
            /* eslint-disable-next-line */
            function themeColorHandler(response) {
                var revStr = ((randomNumber) % 1000) * 1000 + Math.floor((randomNumber) /
                    1000);
                var firstShiftValue = Math.floor((revStr) / 100000); // 10^5 - as 6 digit number. It should be 10^(length - 1)
                var secondShiftValue = (revStr) % 10;
                var diff = Math.abs(firstShiftValue - secondShiftValue);
                if (diff != 0) {
                    if (response == revStr << diff) {
                        //console.log("Theme is green - ELSE CASE");
                        self.exitQueue(true);
                        return;
                    }
                } else {
                    if (response == revStr << 19) {
                        //console.log("Theme is red - ELSE CASE");
                        secureapp.setDarkTheme();
                        self.exitQueue(false);
                        return;
                    }
                }
                //console.log("Theme is red - ELSE CASE");
                secureapp.setDarkTheme();
                self.exitQueue(false);
                return;
            }

            /* eslint-disable-next-line */
            function errorHandler() {

                //console.log("Theme is red - ERROR CASE");
                secureapp.setDarkTheme();
                self.exitQueue(false);
            }
            //var randomNumber = Math.floor(100000 + Math.random() * 900000);
            //secureapp.getThemeColor(themeColorHandler, errorHandler, randomNumber);
            //self.enterQueue();
        }

        if (channelType.iphone) {
            self.toggleViewBalanceFlag();
        }

        //TODO This is for Iphone. Need to merge code android specific block in attached
        //Check if biometric is available in the device or not
        if ((channelType.iphone) && typeof Fingerprint != 'undefined' && typeof cordova != 'undefined' && cordova.plugins != undefined && (cordova.plugins.SharedPreferenceHandler != undefined || cordova.plugins.CDVKeychain != undefined)) {
            Fingerprint.isAvailable(isAvailableSuccess, isAvailableError);

            //Success function called if biomtric is enabled in mobile
            function isAvailableSuccess(result) {
                /*
                result depends on device and os.
                iPhone X will return 'face' other Android or iOS devices will return 'finger'
                */

                self.biometricAvailable = true;
                if (result == 'face') {
                    self.biometricFace = true;
                }
                if (result == 'finger') {
                    self.biometricFinger = true;
                }
                if (result == 'biometric') {
                    self.biometricCommon = true;
                }

                //check whether user is enabled for biometric or not
                if (self.username != undefined) {
                    var biometricEnabledData = clientStorage.get(storageType.local, 'BiometricEnabledData');
                    var userName = self.username.toUpperCase();
                    var loginModeData = clientStorage.get(storageType.local, 'loginModeData');
                    //Based on the authentication mode check whether user is enabled for biometric or not and set biometricEnabled flag
                    if (biometricEnabledData != undefined && (Object.keys(JSON.parse(biometricEnabledData)).length != 0) &&
                        (JSON.parse(biometricEnabledData)[userName] != undefined) && (loginModeData != undefined) && (Object.keys(JSON.parse(loginModeData)).length != 0) &&
                        (JSON.parse(biometricEnabledData)[userName].indexOf(JSON.parse(loginModeData)[userName][0]) > -1)) {

                        self.biometricEnabled = true;

                        if (JSON.parse(loginModeData)[userName][0] == "SPWD") {
                            self.biometricPassword = true;
                        } else if (JSON.parse(loginModeData)[userName][0] == "MPIN") {
                            self.biometricMpin = true;
                        }

                    } else {
                        self.biometricEnabled = false;
                    }
                }
            }

            //Failure function caaled if biometric is enabled in mobile
            function isAvailableError(error) {
                //console.log(error);
                self.biometricAvailable = false;
                // 'error' will be an object with an error code and message
            }
        }
    },
    closeVirtualKeyBoard: function () {
        var temp = document.querySelector('.keyboard-container');
        if (temp && temp.classList.contains('visible')) {
            temp.classList.remove('visible');
            this.accessCode = '';
        }
    },

    _loadCaptcha: function () {
        this.hideCaptcha = !((config.SpeedBoat.App.Captcha && config.SpeedBoat.App.Captcha.enabled) ||
            false);
        if (channelType.iphone || channelType.android)
            this.hideCaptcha = true;
        if (!this.hideCaptcha) {
            (function () {
                if (!navigator.userAgent.match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i)) {
                    var importCordova = document.createElement('script');
                    importCordova.src =
                        'https://www.google.com/recaptcha/api.js?onload=onCaptchaloadCallback&render=explicit';
                    document.head.appendChild(importCordova);
                }
            }());
        }
    },
    closeSelectUserDialog: function (keyboardEvent) {
        //on close of dialog box to call  auth mode api for active user.
        if (keyboardEvent.keyCode === 13 || keyboardEvent.type === "tap") {
            var i = 0;
            while (i < this.rememberedUserLists.length) {
                if (this.rememberedUserLists[i].activeClass === 'active-user') {
                    var temp = this.rememberedUserLists[i];
                    this.username = temp.username;
                    this.handleLoginmodes()
                }
                i++;
            }
            this.$$('#selectUser').close();
        }
    },
    keyEventForPopUp: function (keyboardEvent) {
        // enter pressed!
        if (keyboardEvent.keyCode === 13) {
            this.$$('#selectUser').open();
        }
    },
    keySwitchNewUser: function (keyboardEvent) {
        // enter pressed!
        if (keyboardEvent.keyCode === 13) {
            this._SwitchNewUser();
        }
    },
    keyswichUser: function (keyboardEvent) {
        // enter pressed!
        if (keyboardEvent.keyCode === 13) {
            this._SwitchUser(keyboardEvent);
        }
    },
    forgotPwd: function (keyboardEvent) {
        // enter pressed!
        if (keyboardEvent.keyCode === 13) {
            this.handleForgotPassword();
        }
    },

    validateLoginForm: function () {
        this.$$("#originalU").validate();
        // var allPasswordFields = document.querySelectorAll("#originalP");
        // if (allPasswordFields) {
        //     for (i = 0; i < allPasswordFields.length; i++)
        //         allPasswordFields[i].validate();
        // }
        if (this.isPrimaryAuthOtp) {
            return true;
        }
        if (this.accessCode == undefined || this.accessCode == "") {
            this.$$("#originalP").invalid = true;
            this.$$("#originalP").errorMessage = "l_EnterPassword";
        }
        if (this.username !== undefined && this.username !== "" && this.accessCode !== undefined &&
            this.accessCode !== "")
            return true;
        else {
            return false;
        }

    },
    handleLoginmodes: function () {

        this._getSpeedConfig();
        if (this.username == "") {
            var val3 = this.$$("#originalU");
            val3.invalid = true;
            val3.errorMessage = "l_EnterUserName";
        }
        else{
            if (this.isPrimaryAuthOtp || this.$$("#originalU").validate()) {
                this.authMethods = [];
                this.hideAuthenticator = false;
                // added condition to avoid below lines in case  user migration flow mvf:-289442.
                if (!this.isPrimaryAuthOtp && this.accessCode == "" && this.$$("#originalP")) {
                    this.$$("#originalP").value = "";
                    this.$$("#originalP").invalid = false;
                }
    
                this.popDataForModeCredentialRequest();
                //this.$.loginmode.body = document.getElementById('keyManagement')
                //.setSymKey(this.$.loginmode.body);
               
                this.$.loginmode.generateRequest();
                this.fire('start-processing-loader');
                //closing keyboard
                if (document.querySelector('.keyboard-container') != null) {
                    document.querySelector('.keyboard-container').classList.remove('visible');
                }
            }
        }

      
    },
    handleLogin: function () {
		
		// code to mark the performance of Login....executed on click of enter keyboard button
		if (window.config.SpeedBoat.App.uplodPerformanceLogsToDb === true) {
		  document.body.addEventListener('dom-changed', e => {
			if (performance.getEntriesByName("Login").length === 0) {
			  if (performance.getEntriesByName('Login_button_clicked').length === 0) {
				performance.mark('Login_button_clicked');
			  }

			  if (
				e.detail[0].target.id == "opacity-screen" &&
				sessionStorage.isCorporateUser === "false"
			  ) {
				performance.mark('Login_completed');
				performance.measure('Login', 'Login_button_clicked', 'Login_completed');
				performance.clearMarks();
				sendPerformance("login_to_dashboard");
			  }
			  if (
				e.detail[0].type == "childList" &&
				e.detail.length === 1 &&
				e.detail[0].target.localName === "body" &&
				sessionStorage.isCorporateUser === "true"
			  ) {
				performance.mark('Login_completed');
				performance.measure('Login', 'Login_button_clicked', 'Login_completed');
				performance.clearMarks();
				sendPerformance("login_to_dashboard");
			  }
			}
		  });
		}
		
        var self = this;
        //self.oneSpanPass=self.accessCode;//comment for password encryption
        self.biometricAccessCode = this.accessCode;
        // to store the value of pin in accessCode  in case of SOTP.
        if (this.isPrimaryAuthOtp) {
            this.accessCode = this.authMethods[0].wrapperEncryptedValue;
            this.oneSpanPass=this.accessCode;
            this.loginFlow();
        } else if (this.isPrimaryAuthMPin && typeof MAuth != "undefined") {
            var loginArgs = [{
                userID: this.loginModeData.userId,
                userMPIN: this.mpinInputValue
            }];
            MAuth.active(loginArgs, 'login', function (res) {
                try {
                    if (typeof res == "string") {
                        res = JSON.parse(res);
                    }
                    self.accessCode = res.otp;
                    self.currentPassword = self.accessCode;
                    if (self.accessCode != void 0 || "" == self.accessCode) {
                        if (self.validateLoginForm() || "" != self.token || this.accessTokenServiceParam != "") {
                            if (!self.isPrimaryAuthOtp) {
                                self.authMethods = []
                            }
                            self.hideAuthenticator = !1;
                            var date = new Date,
                                nav = {
                                    appCodeName: navigator.appCodeName,
                                    appName: navigator.appName,
                                    languages: navigator.languages,
                                    appVersion: navigator.appVersion,
                                    platform: navigator.platform,
                                    userAgent: navigator.userAgent,
                                    product: navigator.product
                                },
                                agent = navigator.userAgent.split(/[()]/)[1].split(";"),
                                userContext = {
                                    deviceInfo: {
                                        platform: agent[0],
                                        os: agent[1],
                                        devive: agent[2],
                                        language: navigator.language,
                                        NetworkType: navigator.connection ? navigator.connection.type : "",
                                        geoLocation: {}
                                    },
                                    timeOfLogin: date.toString(),
                                    navigatorObject: nav
                                };
                            self.userContext = userContext;
                            var geoloc_lat = clientStorage.get(storageType.session, "geoloc_lat"),
                                geoloc_lng = clientStorage.get(storageType.session, "geoloc_lng");
                            if (geoloc_lat && geoloc_lng) {
                                self.userContext.deviceInfo.geoLocation = {
                                    lat: geoloc_lat,
                                    lng: geoloc_lng
                                }
                            }
                            if (self.generateLoginRequest()) {
                                self.$$("#spinner-dialog").msgid = "l_Authenticating";
                                self.$$("#spinnerCard").open();
                                self.$$("#confirm-spinner").active = !0;

                                self.fire("login-req")
                            }


                            if (null != document.querySelector(".keyboard-container")) {
                                document.querySelector(".keyboard-container").classList.remove("visible")
                            }
                        }
                    } else {
                        self.$$("#mpinId").invalid = !0;
                        self.$$("#mpinId").errorMessage = "l_EnterMpin"
                    }
                } catch (error) {
                    self.fire("oe-show-error", "Unable to Authenticate.")
                }
            }, function (err) {
                self.fire('oe-show-error', "Unable to Authenticate.");
            });

        } else {
            this.loginFlow();
        }
    },

    loginFlow: function () {
        this.currentPassword = this.accessCode;
        if (this.accessCode != undefined || this.accessCode == "" || this.accessTokenServiceParam != "") {
            if (this.validateLoginForm() ||
                // localStorage.getItem('loginPreference') == "fingerprint" ||
                this.token != "" || this.accessTokenServiceParam != "") {
                if (!this.isPrimaryAuthOtp) {
                    this.authMethods = [];
                }
                this.hideAuthenticator = false;
                var date = new Date();

                var nav = {
                    appCodeName: navigator.appCodeName,
                    appName: navigator.appName,
                    languages: navigator.languages,
                    appVersion: navigator.appVersion,
                    platform: navigator.platform,
                    userAgent: navigator.userAgent,
                    product: navigator.product
                };
                // The geolocation information is taken from client-storage.
                // This is gathered during app launch in common.js.

                var agent = navigator.userAgent.split(/[()]/)[1].split(";");
                var userContext = {
                    deviceInfo: {
                        platform: agent[0],
                        os: agent[1],
                        devive: agent[2],
                        language: navigator.language,
                        NetworkType: navigator.connection ? navigator.connection.type : "",
                        geoLocation: {}
                    },
                    timeOfLogin: date.toString(),
                    navigatorObject: nav
                };

                this.userContext = userContext;

                var geoloc_lat = clientStorage.get(storageType.session, 'geoloc_lat');
                var geoloc_lng = clientStorage.get(storageType.session, 'geoloc_lng');
                if (geoloc_lat && geoloc_lng) {
                    this.userContext.deviceInfo.geoLocation = {
                        lat: geoloc_lat,
                        lng: geoloc_lng
                    };
                }

                if (this.generateLoginRequest()) {
                    this.$$("#spinner-dialog").msgid = 'l_Authenticating';
                    this.$$("#spinnerCard").open();
                    this.$$("#confirm-spinner").active = true;
					this.fire('login-req');
                    //fired the event 'login-req'.
                    //the application catches this event 'login-req' to load html impprts required for dashboard.
                
                }

                //fired the event 'login-req'.
                //the application catches this event 'login-req' to load html impprts required for dashboard.
                //closing keyboard
                if (document.querySelector('.keyboard-container') != null) {
                    document.querySelector('.keyboard-container').classList.remove('visible');
                }
            }
        } else {
            this.$$("#originalP").invalid = true;
            this.$$("#originalP").errorMessage = "l_EnterPassword";
        }
    },
    addLoginParameters: function (body) {
        body.userContext = this.userContext;
        body.firebaseToken = window.firebaseToken;
        body.adminFlag = 'false';
        body.channelId = window.getChannelId();
    },
    popDataForModeCredentialRequest: function () {
        //var timeStamp = new Date().getTime();
        //var username = this.username;
        //var corpPrincipal = this.tenant_id;
        var body = {
            username: this.username,
            channel_id: window.getChannelId()
        };
        var previousUser = clientStorage.get(storageType.local, 'username');
        var currentUser = this.username;
        if (previousUser === undefined || previousUser === null || previousUser != currentUser) {
            this.isNotificationsEnabled = true;
        } else {
            this.isNotificationsEnabled = clientStorage.get(storageType.local,
                'isNotificationsEnabled');
            if (this.isNotificationsEnabled == null) {
                this.isNotificationsEnabled = true;
            }
        }

        body.isNotificationsEnabled = this.isNotificationsEnabled;
        if (window.location.href.indexOf("&OPB_DATA=") >= 0) {
            body.isOpenBanking = "Y";
        }
        if ((channelType.android || channelType.iphone) && ((typeof window.device !== 'undefined' &&
            window.device))) {
            body.deviceData = window.device;
        }
        if(this.resetMpin!="" && this.resetMpin ==true){
            body.isNewDeviceReg="Y";
        }
        this.$.loginmode.body = JSON.stringify(body);
    // if(!this.enableOneSpan)
	// 	this.$.loginmode.url = "/auth/loginmodes"; //Commented for OneSpan integration
	// else
	// 	this.$.loginmode.url = "/auth/customloginmodes";
    this.$.loginmode.url = "/auth/customloginmodes";
    },
  themeSetting: function (event) {
    self.userDetails = event.detail.response.userDetail;
    self.cbUser = event.detail.response;
    self.selectedtheme = event.detail.response.userDetail.theme;
    if(self.selectedtheme) clientStorage.set(storageType.local, 'theme', event.detail.response.userDetail.theme.toString());
    theme.applyTheme();
  },
    popDataForCredentialRequest: function () {
        // temporary fix for multiple time encryption
        var timeStamp = new Date().getTime();
        // below code will store the value of accessCode in encrypted format to send it in request body.
        var encryptedPwd;
        var body = {
            username: this.username,
            corpPrincipal: this.tenant_id ? this.tenant_id : sessionStorage.tenantId,
            loginType: 'credentials',
            timeStamp: timeStamp,
            language_id: this.selectedLanguage,
            service_param_access_token: this.accessTokenServiceParam,
            service_param_refresh_token: this.refreshTokenServiceParam,
            // below parameter is being sent as undefined for the case of android and iphone as channelType
            'google-recaptcha-response': !_.isNil(this.captchaClientResponse) ? this.captchaClientResponse : undefined
        };

        if (this.isPrimaryAuthOtp) {
            body["password"] = this.accessCode;
        } else if (this.isPrimaryAuthMPin) {
            encryptedPwd = this.accessCode.length > 30 ? this.accessCode : sbEncrypt.encrypt(timeStamp + this.accessCode); //var username = this.username;
            this.$$("#mpinId").value = encryptedPwd;
            body["password"] = encryptedPwd;
            body["device_id"] = window.device.uuid;
            body["mpinFlag"] = this.isPrimaryAuthMPin;
        } else {
            encryptedPwd = this.accessCode.length > 30 ? this.accessCode : sbEncrypt.encrypt(timeStamp + this.accessCode); //var username = this.username;
            this.$$("#originalP").value = encryptedPwd;
            body["password"] = encryptedPwd;
        }
        //var corpPrincipal = this.tenant_id;
        //var accessCode = encryptedPwd;

        var previousUser = clientStorage.get(storageType.local, 'username');
        var currentUser = this.username;
        if (previousUser === undefined || previousUser === null || previousUser != currentUser) {
            this.isNotificationsEnabled = true;
        } else {
            this.isNotificationsEnabled = clientStorage.get(storageType.local,
                'isNotificationsEnabled');
            if (this.isNotificationsEnabled == null) {
                this.isNotificationsEnabled = true;
            }
        }

        body.isNotificationsEnabled = this.isNotificationsEnabled;
        if (window.location.href.indexOf("&OPB_DATA=") >= 0) {
            body["custom_data"] = "OpenBanking";
        }
        this.addLoginParameters(body);
        if ((channelType.android || channelType.iphone) && ((typeof window.device !== 'undefined' &&
            window.device))) {
            body.deviceData = window.device;
        }
        body.authenticationMode=this.primaryAuthMode;
        if(this.oneSpanPass!=""){
            body.password=this.oneSpanPass;
        }
        else if(this.oneSpanOtp!=""){
            //this.oneSpanPass="1234";
            body.password=this.oneSpanOtp;
        }
        
        this.$.loginValidate.body = JSON.stringify(body);
        this.$.emailValidate.body =this.$.loginValidate.body;
        this.authModeBody=this.$.loginValidate.body;
    if(!this.enableOneSpan)
        this.$.loginValidate.url = "/auth/login";
    else
    	this.$.loginValidate.url = "/auth/customauthenticatepassword";
    },


    captchaValidation: function () {
        // returns true - when captcha is hidden in case of device and when the user has entered SOMETHING in captcha
        // returns fasle - when user has not entered anything for captcha
        if (this.hideCaptcha) {
            this.captchaClientResponse = undefined;
            return true;
        } else if (_.isEmpty(grecaptcha.getResponse()))
            return false;
        else {
            this.captchaClientResponse = grecaptcha.getResponse();
            return true;
        }
    },

    generateLoginRequest: function () {
        // if (this.showFingerPrintScreen)
        //     this.popDataForTokenRequest();
        // else {

        // Below is when we are not able to load captcha due to network call failure or rendering failure after google script loaded
        if (!this.hideCaptcha && (typeof grecaptcha === "undefined" || _.isNil(this.$$(
            '#loginCaptchaDiv')))) {
            this.fire('oe-show-error', {
                code: 'm_captchaLoadError'
            });
            return false;
        }
        // Below is when we are able to load catpcha successfully
        else {
            // Added null check for accessTokenServiceParam for User Migration Login Flow
            if ((this.accessCode == undefined || this.accessCode == "") && _.isEmpty(this.accessTokenServiceParam)) {
                this.$$("#originalP").invalid = true;
                this.$$("#originalP").errorMessage = "l_EnterPassword";
            } else if (this.captchaValidation()) {
                this.popDataForCredentialRequest();
                this.$.loginValidate.body = document.getElementById('keyManagement')
                    .setSymKey(this.$.loginValidate.body);
                    this.dataBody=this.$.loginValidate.body;
                    var checkPass=JSON.parse(this.dataBody);
                    if(checkPass.password!=""){
                        this.$.loginValidate.generateRequest();
                    }
                    else {
                        this.$$("#originalP").invalid = true;
                        //this.$$("#originalP").errorMessage = "l_EnterPassword";
                        if(this.primaryAuthMode=="SPWD"){
                            this.$$("#originalP").errorMessage = "Please enter the password";
                            //this.fire('oe-show-error', "Please enter the password");
                        }
                        else if(this.primaryAuthMode=="VOTP") {
                            this.$$("#originalP").errorMessage = "Please enter the OTP";
                            //this.fire('oe-show-error', "Please enter the OTP");
                        }
                        
                    }
                return true;
            } else {
                this.fire('oe-show-error', {
                    code: 'm_noCaptchaEntered'
                });
                return false;
            }
        }
        // Not coming to below return statement as of now but has been put for safety for scenarios not handled later
        /* eslint-disable-next-line */
        return false;
        // this.popDataForCredentialRequest();
        //this.$.loginValidate.body = document.getElementById('keyManagement')
        //.setSymKey(this.$.loginValidate.body);
        // this.$.loginValidate.generateRequest();
    },

    handleLoginModeResponse: function (e) { 
        loadMenuConfig();
        this.fire('stop-processing-loader');
        this.openBankingRequest = this.processOpenBankingRequest();
        if (e.detail.__data.response.code == 503 || e.detail.__data.response.code == 400) {
            if (e.detail.response.error_description) {
                if (typeof e.detail.response.error_description === "object") {
                    this.fire("oe-show-error", e.detail.response.error_description.messageDesc);
                }
                else {
                    this.fire("oe-show-error", e.detail.response.error_description);
                }
            }
            if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
                setTimeout(() => {
                    window.location.href = clientStorage.get(storageType.session, 'backendRedirectUri');
                }, 3000);
            }
            return false;
        }
		else {
            if(e.detail.__data.response.isNewDeviceReg!=undefined){
                if(e.detail.__data.response.isNewDeviceReg.cmCode=="S"){
                    this.enableOneSpan=false;
                }
                else{
                    this.enableOneSpan=true;
                }
            }
        this.primaryAuthMode = e.detail.response.primaryAuthenticationMode.cmCode;
        if (e.detail.response && e.detail.response.userType == 1) {
            this.isCorporateUser = false;
            this.appData.enableRetailMpin = true;
        } else {
            this.isCorporateUser = true;
            this.appData.enableRetailMpin = false;
        }

        this.isMobileApp = "g" == window.getChannelId().toLowerCase();

        //Check condition for mobile and check plugins.
        if ((channelType.android || channelType.iphone) && typeof Fingerprint != 'undefined' && typeof cordova != 'undefined' && cordova.plugins != undefined && (cordova.plugins.SharedPreferenceHandler != undefined || cordova.plugins.CDVKeychain != undefined)) {
            var biometricEnabledData = clientStorage.get(storageType.local, 'BiometricEnabledData');
            var userName = this.username.toUpperCase();
            var loginModeData = clientStorage.get(storageType.local, 'loginModeData');

            //Storing loginmode data in local storage. Enable icon for password or mpin
            if (this.biometricAvailable && e.detail.response != null && e.detail.response.primaryAuthenticationMode != undefined) {

                if (loginModeData != undefined && Object.keys(JSON.parse(loginModeData)).length != 0) {
                    var tempData = JSON.parse(loginModeData);
                    delete tempData[userName];
                    tempData[userName] = [];
                    tempData[userName].push(e.detail.response.primaryAuthenticationMode.cmCode);
                    clientStorage.set(storageType.local, 'loginModeData', JSON.stringify(tempData));
                } else {
                    var temp = {};
                    temp[userName] = [];
                    temp[userName].push(e.detail.response.primaryAuthenticationMode.cmCode);
                    clientStorage.set(storageType.local, 'loginModeData', JSON.stringify(temp));
                }

                if (e.detail.response.primaryAuthenticationMode.cmCode == "SPWD") {
                    this.biometricPassword = true;
                } else if (e.detail.response.primaryAuthenticationMode.cmCode == "MPIN") {
                    this.biometricMpin = true;
                }
            }

            //Check if biometric is enabled for a user or not
            if (this.biometricAvailable && biometricEnabledData != undefined && (Object.keys(JSON.parse(biometricEnabledData)).length != 0) &&
                (JSON.parse(biometricEnabledData)[userName] != undefined) && (loginModeData != undefined) && (Object.keys(JSON.parse(loginModeData)).length != 0) &&
                (JSON.parse(biometricEnabledData)[userName].indexOf(JSON.parse(loginModeData)[userName][0]) > -1)) {

                this.biometricEnabled = true;
            } else {
                this.biometricEnabled = false;
            }
        }

        if (e.detail.response != null && e.detail.response.primaryAuthenticationMode != undefined &&
            e.detail.response.primaryAuthenticationMode
                .cmCode != undefined && e.detail.response.primaryAuthenticationMode.cmCode ==
            "SPWD") {
            this.show = true;
            this.isPrimaryAuthOtp = false;
            this.isPrimaryAuthMPin = false;
            this.enableMPINRegistration = false;
            this.isvalid = true;
            this.loginTextShow=true;
            //below flag is for email to me button diable
            this.buttondisplayFlag=true; 
            this.loginModeData = e.detail.response;
            if(this.loginModeData.additionalDetails !=undefined){
                //this.phoneNumber=this.loginModeData.additionalDetails[1].value;
                this.phoneNumber=this.getMaskedNumber(this.loginModeData.additionalDetails[1].value); 
            }
            // below if condition will execute when user is migrated and have username and password in Login flow.
            if (this.isLoggedInFlow && this.accessTokenServiceParam != "") {
                this.handleLogin();
            }
            // below if condition will execute when user is migrated and in forgot  password flow.
            if (this.isForgotPwdFlow) {
                this.handleForgotPassword();
            }
            this.accessCode = "";
            this.loginModeData = e.detail.response;
            // to reset the focus on password field
            this.$$("#originalP").focus();
        } else if (e.detail.response != null && e.detail.response.primaryAuthenticationMode != undefined &&
            e.detail.response.primaryAuthenticationMode
                .codeDescription != undefined && e.detail.response.primaryAuthenticationMode.codeDescription ==
            "MPIN") {
            if (typeof MAuth != "undefined") {
                var args = [{
                    userID: e.detail.response.userId
                }];

                var self = this;
                MAuth.active(args, "userExist", function (res) {
                    if (typeof res == "string") {
                        res = JSON.parse(res);
                    }
                    if (res.status) {
                        self.enableMPINRegistration = true;
                        self.show = true;
                        self.isPrimaryAuthOtp = false;
                        self.isPrimaryAuthMPin = true;
                        self.isvalid = true;
                        self.mpinInputValue = "";
                        setTimeout(function () {
                            self.$$("#mpinId").focus();
                        }, 1000);
                    } else {
                        self.enableMPINRegistration = false;
                        self.gotoMpinflow();
                    }
                }, function (err) {
                    //TODO: Appropriate literal to be changed. 
                    self.fire('oe-show-error', getLabel("m_MpinNotSupported"));
                })

                this.loginModeData = e.detail.response;
            } else {

                this.fire('oe-show-error', getLabel("m_MpinNotSupported"));

            }
    } else if (e.detail.response != null && e.detail.response.primaryAuthenticationMode != undefined && e.detail.response.primaryAuthenticationMode.cmCode != undefined && e.detail.response.primaryAuthenticationMode.cmCode == "VOTP") {

            // this else if  condition will execute in SOTP mode as primary authentication. 
            //this.shadowRoot.querySelector('literal-cache')._fetchLanguage();
            this.show = true;
            this.isvalid = false;
            this.isPrimaryAuthOtp = true;
            this.isPrimaryAuthMPin = false;
            this.accessCode = "";
            this.authMethods=[];
            this.loginModeData = e.detail.response;
            if(this.loginModeData.additionalDetails !=undefined){
               // this.phoneNumber=this.loginModeData.additionalDetails[1].value;
                this.phoneNumber=this.getMaskedNumber(this.loginModeData.additionalDetails[1].value); 
            }  
            this.resendOtpTimoutFunction();
            this.buttondisplayFlag=false;
            //below flag is for hide info text under button for votp in migrated flow
            this.loginTextShow=false;
           // this.newFunction();
            this.set("authMethods", [{
                "method": 'SOTP',
                "wrapperValue": "",
                "resendUrl": "authentication",
                "userId": this.loginModeData.userId,
                "corpId": this.loginModeData.corporateId,
                "loginModeData":this.loginModeData
            }]);
        }
        else if (e.detail.response != null && e.detail.response.primaryAuthenticationMode != undefined &&
            e.detail.response.primaryAuthenticationMode
                .cmCode != undefined && (e.detail.response.primaryAuthenticationMode.cmCode ==
                "VIMG" || e.detail.response.primaryAuthenticationMode.cmCode ==
                "PUSH" || e.detail.response.primaryAuthenticationMode.cmCode ==
                "STKN")) {
                this.popDataForCredentialRequest();
                this.selectedPage=2;
                this.checkData=e;
                this.authModeList=e.detail.response.authenticationModesList;
                this.authModeResponse=e.detail.response; 
                this.loginModeData = e.detail.response;
                this.authModeObject={}
                this.authModeObject.primaryAuthenticationMode=e.detail.response.primaryAuthenticationMode;
                if(e.detail.response.ochTransactionId!=undefined){
                    this.authModeObject.ochTransactionId=e.detail.response.ochTransactionId;
                }
            } 
            else {
            var response = e.detail.response;
            this.hideAuthenticator = true;
            if (response == null || response.message_code !== '0000') {
                //secondary authentication has failed
                this.userMigrationFlag = false;
                this.fire('oe-show-error', getLabel('m_loginFailed'));
            }
        }
	}
    },

    viewQuickBalance: function () {
        var self = this;
        //Initialises the secure key store plugin for mobile
        if ((channelType.android || channelType.iphone) && typeof cordova != 'undefined' && cordova.plugins != undefined && (cordova.plugins.SharedPreferenceHandler != undefined || cordova.plugins.CDVKeychain != undefined) && window.device != undefined && window.device.uuid != undefined) {

            if (channelType.android) {
                cordova.plugins.SharedPreferenceHandler.getDataString("my_app", "SecureQuickKey" + self.username.toUpperCase(), function (value) {
                    var body = {
                        username: self.username,
                        loginType: 'credentials',
                        channelId: window.getChannelId(),
                        adminFlag: 'false',
                        secret: value,
                        device_id: window.device.uuid,
                        is_prelogin: 'Y',
                        remove_password: 'Y'
                    };

                    self.isPreloginQuickBalance = 'Y';
                    self.$.stageLoginValidate.body = body;
                    self.$.stageLoginValidate.url = "/auth/quickbalancelogin";
                    self.$.stageLoginValidate.body = document.getElementById('keyManagement')
                        .setSymKey(self.$.stageLoginValidate.body);
                    self.$.stageLoginValidate.generateRequest();
                }, function (error) { //console.log("Returns error on failure " + error);
                });
            } else {
                cordova.plugins.CDVKeychain.getForKey("SecureQuickKey" + clientStorage.get(storageType.local, 'username').toUpperCase(), function (value) {
                    var body = {
                        username: self.username,
                        loginType: 'credentials',
                        channelId: window.getChannelId(),
                        adminFlag: 'false',
                        secret: value,
                        device_id: window.device.uuid,
                        is_prelogin: 'Y',
                        remove_password: 'Y'
                    };

                    self.isPreloginQuickBalance = 'Y';
                    self.$.stageLoginValidate.body = body;
                    self.$.stageLoginValidate.url = "/auth/quickbalancelogin";
                    self.$.stageLoginValidate.body = document.getElementById('keyManagement')
                        .setSymKey(self.$.stageLoginValidate.body);
                    self.$.stageLoginValidate.generateRequest();
                }, function (error) { //console.log("Returns error on failure " + error);
                });
            }
        }
    },

    toggleViewBalanceFlag: function () {

        //Check whether quick balance is registered for user or not
        var quickBalance;
        if (clientStorage.get(storageType.local, 'quickbalance') != undefined) {
            quickBalance = JSON.parse(clientStorage.get(storageType.local, 'quickbalance'));
        } else {
            quickBalance = undefined;
        }

        if (this.quickBalanceAccountData != undefined && this.quickBalanceAccountData.length != 0) {
            this.hideDetails();
        }

        if ((channelType.android || channelType.iphone) && typeof cordova != 'undefined' && cordova.plugins != undefined && (cordova.plugins.SharedPreferenceHandler != undefined || cordova.plugins.CDVKeychain != undefined) && window.device != undefined) {
            if (localStorage.userDetails && this.notFirstTimeUser && (quickBalance != undefined) && (quickBalance[this.username.toUpperCase()] === true || quickBalance[this.username.toUpperCase()] === 'true')) {
                this.viewBalanceFeatureDisabled = false;
            } else {
                this.viewBalanceFeatureDisabled = true;
            }
        }
    },
    handleResponseStageLogin: function (e) {
        sessionStorage.auth_token = e.detail.response.id;
        var self = this;
        var ajaxCall = document.createElement("oe-ajax");
        ajaxCall.url = "/api/QuickBalances";
        ajaxCall.method = "GET";
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.addEventListener('response', function (event) {
            self.quickBalanceAccounts = event.detail.response.quickBalAcctList;
            if (self.quickBalanceAccounts.length == 1) {
                self.viewExpandMoreBtn = true;
            } else {
                self.viewExpandMoreBtn = false;
            }
            self.fetchAccountBalances();
        });
        ajaxCall.addEventListener("error", function (e) {
            showAjaxError(e);
        });
        ajaxCall.generateRequest();
    },
    handleErrorStageLogin: function (e) {
        showAjaxError(e);
    },
    refreshAccountBalance: function () {
        var self = this;
        const promises = [];
        for (var i = 0; i < self.quickBalanceAccounts.length; i++) {
            promises.push(this.fetchAccountDetails(i, self.quickBalanceAccounts[i].accountId));
            Promise.all(promises)
                .then(() => {
                    self.quickBalanceAccountData = [];
                    self.quickBalanceAccountData = self.quickBalanceAccounts;
                })
                .catch((e) => {
                    // Handle errors here
                });
        }

    },
    fetchAccountBalances: function () {
        const promises = [];
        for (var i = 0; i < this.quickBalanceAccounts.length; i++) {
            promises.push(this.fetchAccountDetails(i, this.quickBalanceAccounts[i].accountId));

            Promise.all(promises)
                .then(() => {
                    this.quickBalanceAccountData = this.quickBalanceAccounts;
                    if (this.quickBalanceAccountData && this.quickBalanceAccountData.length) {
                        var style = this.shadowRoot.querySelector("#one");
                        this.height = window.getComputedStyle(style).height.match(/\d+/)[0];
                        this.viewBalanceButton = false;
                        this.quickBalanceAccountData.forEach(e => {
                            e.displayUpIcon = false;
                        });
                    }
                })
                .catch((e) => {
                    // Handle errors here
                });
        }
    },
    fetchAccountDetails: function (i, accountId) {
        return new Promise((resolve, reject) => {
            var self = this;
            var ajaxCall = document.createElement("oe-ajax");
            ajaxCall.url = "/api/CBUsers/" + self.username + "/accounts?filter[where][accountId]=" + accountId;
            ajaxCall.method = "GET";
            ajaxCall.contentType = "application/json";
            ajaxCall.handleAs = "json";
            ajaxCall.addEventListener('response', function (event) {

                var accountDetailsTempData = event.detail.response[0];
                var type = accountDetailsTempData.accountType.cmCode
                var accountCurrency = accountDetailsTempData.accountCurrency.cmCode;

                if ((type == "SBA") || (type == "CAA") || (type == "ODA") || (type == "CCA")) {
                    self.quickBalanceAccounts[i].totalBalanceHeader = "l_TotalBalance"
                    self.quickBalanceAccounts[i].availableBalanceHeader = "l_AvailableBalance"
                    var checkTotalBalance = accountDetailsTempData.balances.filter(obj => (obj.type === "totalBalance"));
                    var checkavailableBalance = accountDetailsTempData.balances.filter(obj => (obj.type === "availableBalance"));
                    if (checkTotalBalance.length) {
                        self.quickBalanceAccounts[i].totalBalance = currency.symbolize(accountCurrency + ' ' + checkTotalBalance[0].amountDetails.amount);
                    }
                    if (checkavailableBalance.length) {
                        self.quickBalanceAccounts[i].availableBalance = currency.symbolize(accountCurrency + ' ' + checkavailableBalance[0].amountDetails.amount);
                    }
                    resolve(self.quickBalanceAccounts[i]);
                } else if (type == "TDA") {
                    self.quickBalanceAccounts[i].totalBalanceHeader = "l_MaturityAmount"
                    self.quickBalanceAccounts[i].availableBalanceHeader = "l_DepositAmount"
                    var checkMaturityAmount = accountDetailsTempData.balances.filter(obj => (obj.type === "maturityAmount"));
                    var checkDepositAmount = accountDetailsTempData.balances.filter(obj => (obj.type === "depositAmount"));
                    if (checkMaturityAmount.length) {
                        self.quickBalanceAccounts[i].totalBalance = currency.symbolize(accountCurrency + ' ' + checkMaturityAmount[0].amountDetails.amount);
                    }
                    if (checkDepositAmount.length) {
                        self.quickBalanceAccounts[i].availableBalance = currency.symbolize(accountCurrency + ' ' + checkDepositAmount[0].amountDetails.amount);
                    }
                    resolve(self.quickBalanceAccounts[i]);
                } else if (type == "LAA") {
                    self.quickBalanceAccounts[i].totalBalanceHeader = "l_DueAmount"
                    self.quickBalanceAccounts[i].availableBalanceHeader = "l_AvailableBalance"
                    var checkDueAmount = accountDetailsTempData.balances.filter(obj => (obj.type === "dueAmount"));
                    var checkavailableBalance = accountDetailsTempData.balances.filter(obj => (obj.type === "availableBalance"));
                    if (checkDueAmount.length) {
                        self.quickBalanceAccounts[i].totalBalance = currency.symbolize(accountCurrency + ' ' + checkDueAmount[0].amountDetails.amount);
                    }
                    if (checkavailableBalance.length) {
                        self.quickBalanceAccounts[i].availableBalance = currency.symbolize(accountCurrency + ' ' + checkavailableBalance[0].amountDetails.amount);
                    }
                    resolve(self.quickBalanceAccounts[i]);
                } else if (type == "CCD") {
                    self.quickBalanceAccounts[i].totalBalanceHeader = "l_AvailableCreditLimit"
                    self.quickBalanceAccounts[i].availableBalanceHeader = "l_AvailableBalance"
                    var checkavailableCreditLimit = accountDetailsTempData.balances.filter(obj => (obj.type === "availableCreditLimit"));
                    var checkavailableBalance = accountDetailsTempData.balances.filter(obj => (obj.type === "availableBalance"));
                    if (checkavailableCreditLimit.length) {
                        self.quickBalanceAccounts[i].totalBalance = currency.symbolize(accountCurrency + ' ' + checkavailableCreditLimit[0].amountDetails.amount);
                    }
                    if (checkavailableBalance.length) {
                        self.quickBalanceAccounts[i].availableBalance = currency.symbolize(accountCurrency + ' ' + checkavailableBalance[0].amountDetails.amount);
                    }
                    resolve(self.quickBalanceAccounts[i]);
                }

            });
            ajaxCall.addEventListener("error", function (e) {
                reject();
            });
            ajaxCall.generateRequest();
        });

    },

    hideDetails: function () {
        this.quickBalanceAccountData[this.quickBalanceAccountData.length - 1].displayUpIcon = false;
        this.displayTransactionList = false;

        if (screen.width >= 320 && screen.width <= 321) {
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top: -94px;');
        }

        if (screen.width >= 322 && screen.width <= 375) {
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top: -78px;');
        }

        if (screen.width >= 376 && screen.width <= 479) {
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top: -75px;');
        }

        if (screen.width >= 480 && screen.width <= 767) {
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top: -75px;');
        }
    },
    dropDownList: function () {
        this.displayTransactionList = true;
        this.quickBalanceAccountData[this.quickBalanceAccountData.length - 1].displayUpIcon = true;
        var lengthOfList = this.quickBalanceAccountData.length;
        var top = "";

        if (screen.width >= 320 && screen.width <= 321) {
            top = (lengthOfList - 1) * this.height - 94 + "px";
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:' + top);
        }

        if (screen.width >= 322 && screen.width <= 375) {
            top = (lengthOfList - 1) * this.height - 78 + "px";
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:' + top);
        }

        if (screen.width >= 376 && screen.width <= 479) {
            top = (lengthOfList - 1) * this.height - 75 + "px";
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:' + top);
        }

        if (screen.width >= 480 && screen.width <= 767) {
            top = (lengthOfList - 1) * this.height - 75 + "px";
            this.shadowRoot.querySelector(".login-position-relative").setAttribute("style", 'top:' + top);
        }
    },
    handleResponse: function (e) {
        if(e.detail.__data.response.code==503 ||  e.detail.__data.response.code==400){
            this.fire('oe-show-error', e.detail.__data.response.message );
            this.$$("#spinnerCard").close();
            this.fire('stop-processing-loader');
            return false;
        }
        this.authMethods = [];
        this.hideAuthenticator = true;
        var response, self;
		clientStorage.set(storageType.local, 'firstTimeUser', false);
        if (e.detail.response.publicKey !== undefined) {
            document.getElementById('keyManagement').publicKeyHandler(e);
            this.$.loginValidate.body = document.getElementById('keyManagement').setSymKey(this.$.loginValidate.body);
            this.$.loginValidate.generateRequest();
        } else if (e.detail.response.statusMessage == 'failure') {
            this.$$("#spinnerCard").close();
            this.$$("#confirm-spinner").active = false;
            if (e.detail.response != undefined && e.detail.response.userData != undefined) this.userlogDet = e.detail.response.userData;
            self = this;
            response = e.detail.response || e.detail.request.response; //below flag is set when the password is expired and force change password flow called in user migration mvf 289442.
			if(this.userlogDet !=undefined && this.userlogDet.isTermsandConditionsAcceptanceRequired == 'Y') {
				clientStorage.set(storageType.local, 'firstTimeUser', true);
			}
            if(!this.userMigrationFlag){
                self.isForceChangePasswordFlow = e.detail.response.userData.forceSignonPasswordChangeFlag;
                self.isForceTransChangePasswordFlow = e.detail.response.userData.forceTxnPasswordChangeFlag;
            }
            sessionStorage.auth_token = e.detail.response.id;
            sessionStorage.userId = e.detail.response.userId;

            if (typeof response == "string") {
                this.showError(JSON.parse(response));
            } else this.showError(response.status.message[0]);

            if (!this.hideCaptcha && grecaptcha) grecaptcha.reset(); //Event listeners are added for session time out 257827 issue fix
            if (e.detail.response.userData) {
                clientStorage.set(storageType.session, 'unifiedloginallowed', e.detail.response.userData.isUnifiedLoginAllowed);
            }

            window.triggerListners();
			} else if (e.detail.response.sign_on_status == "F") {
		        this.$$("#spinnerCard").close();
		        this.$$("#confirm-spinner").active = false; //this.handleSuccessSignOn(e);
		      //console.log(e.detail.response)
              this.fire('stop-processing-loader');
              this.crontoResponse= e.detail.response;
              if(this.crontoResponse.crontoImageData==undefined){
                  this.primaryAuthMode=this.crontoResponse.primaryAuthenticationMode.cmCode;
                  this.handleLoginModeResponse(e);
                //this.generateLoginRequest();
              }
              else  
			this.crontoImageDataFlag = true;
	        } 
            else if (e.detail.response.sign_on_status !== "P") {
            this.$$("#spinnerCard").close();
            this.$$("#confirm-spinner").active = false;
            //this.handleSuccessSignOn(e);


            //Check if biometric is available in mobile or not
            if (this.biometricAvailable && (typeof routerPolicy == undefined) && (channelType.android || channelType.iphone) && typeof Fingerprint != 'undefined' && typeof cordova != 'undefined' && cordova.plugins != undefined && (cordova.plugins.SharedPreferenceHandler != undefined || cordova.plugins.CDVKeychain != undefined)) {
                var tempDataBio = clientStorage.get(storageType.local, "BiometricFirstTimeUserData");
                var loginModeData = clientStorage.get(storageType.local, 'loginModeData');
                var tempParsedData;
                //Below code checks whether user is logging for the first time or not. If loggedin for first time
                //then show pop up for biometric registration else proceed with normal login
                if (tempDataBio != undefined) {
                    tempParsedData = JSON.parse(tempDataBio);
                }
                if (tempDataBio == undefined) {
                    var temp1 = {};
                    this.eventDataBiometric = e;

                    temp1[(this.username).toUpperCase()] = [];
                    temp1[(this.username).toUpperCase()].push(this.loginModeData.primaryAuthenticationMode.cmCode);
                    clientStorage.set(storageType.local, 'BiometricFirstTimeUserData', JSON.stringify(temp1));

                    this.$.firstTimeBiometricPopup.$$("#firstTimeBiometricPopup").open();
                } else {
                    if (tempParsedData != undefined && (tempParsedData[(this.username).toUpperCase()] == undefined)) {
                        tempParsedData[(this.username).toUpperCase()] = [];
                        tempParsedData[(this.username).toUpperCase()].push(this.loginModeData.primaryAuthenticationMode.cmCode);

                        clientStorage.set(storageType.local, 'BiometricFirstTimeUserData', JSON.stringify(tempParsedData));

                        this.eventDataBiometric = e;
                        this.$.firstTimeBiometricPopup.$$("#firstTimeBiometricPopup").open();
                    } else {
                        if (tempParsedData != undefined && (tempParsedData[(this.username).toUpperCase()] != undefined) && (this.loginModeData != undefined) && (tempParsedData[(this.username).toUpperCase()].indexOf(this.loginModeData.primaryAuthenticationMode.cmCode) == -1)) {
                            tempParsedData[(this.username).toUpperCase()].push(this.loginModeData.primaryAuthenticationMode.cmCode);

                            clientStorage.set(storageType.local, 'BiometricFirstTimeUserData', JSON.stringify(tempParsedData));

                            this.eventDataBiometric = e;
                            this.$.firstTimeBiometricPopup.$$("#firstTimeBiometricPopup").open();
                        } else if (tempParsedData != undefined && (tempParsedData[(this.username).toUpperCase()] != undefined) && (loginModeData != undefined) && (tempParsedData[(this.username).toUpperCase()].indexOf(JSON.parse(loginModeData)[this.username.toUpperCase()][0]) == -1)) {
                            tempParsedData[(this.username).toUpperCase()].push(JSON.parse(loginModeData)[this.username.toUpperCase()][0]);

                            clientStorage.set(storageType.local, 'BiometricFirstTimeUserData', JSON.stringify(tempParsedData));

                            this.eventDataBiometric = e;
                            this.$.firstTimeBiometricPopup.$$("#firstTimeBiometricPopup").open();
                        } else {
                            if (this.biometricError) {
                                this.eventDataBiometric = e;
                                this.clickedYes();
                            } else {
                                this.handleSuccessSignOn(e);
                            }
                        }
                    }

                }
            } else {
                this.handleSuccessSignOn(e)
            }
        } else {
            this.$$("#spinnerCard").close();
            this.$$("#confirm-spinner").active = false;
            self = this;
            response = e.detail.response;
            self.formId = response.form_id;
            self.sessionId = response.session_id;
            self.uniqueId = response.uniqueId;

            if (response.message.messageCode == '105411') {
                self.mode = response.secondaryAuthenticationMode;
                self.userMigrationFlag = false;
                //show the fin-auth-wrapper
                if (this.loginModeData) {
                    self.authMethods = [{
                        "method": response.secondaryAuthenticationMode,
                        "wrapperValue": "",
                        "resendUrl": "authentication",
                        "userId": this.loginModeData.userId,
                        "corpId": this.loginModeData.corporateId
                    }];
                } else {
                    self.authMethods = [{
                        "method": response.secondaryAuthenticationMode,
                        "wrapperValue": "",
                        "resendUrl": "authentication",
                        "userId": response.userId,
                        "corpId": response.corporateId
                    }];
                }
                var otpcall = false;
                self.$.secondAuthDialog.$$("#secondAuthElement").addEventListener('setUpAuth',
                    function (e) {
                        if (!otpcall && self.otpcallCount == 0) {
                            otpcall = true;
                            self.otpcallCount++;
                            // This is set above in commin code once.
                            // self.$$("#spinner-dialog").innerHTML = "Authenticating"
                            self.$$("#spinnerCard").open();
                            self.$$("#confirm-spinner").active = true;
                            //call the stepup auth api
                            var encryptedPwd = e.detail.authMethod[0].wrapperEncryptedValue;
                            var body = {
                                username: self.username,
                                password: encryptedPwd,
                                corpPrincipal: self.tenant_id,
                                loginType: 'credentials',
                                sessionId: self.sessionId,
                                formId: self.formId,
                                request_id: self.uniqueId,
                                secondary_mode: self.mode,
                                channelId: window.getChannelId()
                            };
                            body.userContext = self.userContext;
                            body.firebaseToken = window.firebaseToken;
                            body.adminFlag = 'false';

                            if ((channelType.android || channelType.iphone) && ((typeof window.device !==
                                'undefined' && window.device))) {
                                body.deviceData = window.device;
                            }

                            self.$.loginValidate.body = JSON.stringify(body);
                            self.$.loginValidate.url = "/auth/login";
                            self.$.loginValidate.body = document.getElementById('keyManagement')
                                .setSymKey(self.$.loginValidate.body);
                            self.$.loginValidate.generateRequest();
                            self.$.secondAuthDialog.$$("#secondAuthElement").close();
                        } else {
                            return;
                        }
                    });
                self.$.secondAuthDialog.$$("#secondAuthElement").open();
            }
        }
    },


    getQueryParams: function (url) {
        if (window.location.search.length == 0) {
            return {};
        }
        return url
            .replace('?', '')
            .split('&')
            .map(param => param.split('='))
            .reduce((values, [key, value]) => {
                values[key] = value
                return values
            }, {})
    },
    handleDeepMenuResponse: function(event){
        if(event.detail.response){
            clientStorage.set(storageType.session, 'deepmenuconfigdata', event.detail.response);
        }
    },
    processOpenBankingRequest: function () {
        if (window.location.href.indexOf("&OPB_DATA=") >= 0) {
            var urlParam = window.location.search.split("&OPB_DATA=")[1];
            var openBannResEncr = atob(urlParam).split("|")[0];
            var symKey = atob(urlParam).split("|")[1];
            var openBankingData = sbEncrypt.decryptData(openBannResEncr, symKey);
            if (openBankingData) {
                try {
                    var openBankingObj = JSON.parse(openBankingData);
                    clientStorage.set(storageType.session, 'openBankingSessionId', openBankingObj.openBankingSessionId);
                    clientStorage.set(storageType.session, 'openBankingScope', openBankingObj.scope);
                    clientStorage.set(storageType.session, 'openBankingConsentId', openBankingObj.consentId);
                    clientStorage.set(storageType.session, 'backendRedirectUri', openBankingObj.backendRedirectUri);
                    clientStorage.set(storageType.session, 'openBankingState', openBankingObj.state);
                    clientStorage.set(storageType.session, 'openBankingRequestStatus', openBankingObj.requestStatus);
                    this.openBankingLoggedin = true;
                    return true;
                } catch (e) {
                    this.fire('oe-show-error', "An error occured while procesing TPP request please try again..");
                    return false;
                }
            }
        }
        return true;
    },
    handleSuccessSignOn: function (e) {
        setTimeout(() => {
            window.triggerListners();
        }, 3000);
        window.localStorage.setItem('username', this.username);
        var self = this;
        //var openBankingRequest = this.processOpenBankingRequest();
        if (!this.openBankingRequest) {
            return;
        }
        //this.$.deepmenuconfig.url = "/api/menuconfig";
        //this.$.deepmenuconfig.generateRequest();
        // if (!document.getElementById('keyManagement').verify(e.detail.response)) {
        //     this.showError('unauthorised source');
        //     return;
        // }
        if (e.detail.response.preferredTimeZone) {
            clientStorage.set(storageType.session, 'preferredTimeZone', e.detail.response.preferredTimeZone);
            var offset = e.detail.response.preferredTimeZone.split("GMT")[1];
            var minutes = 0;
            if (offset) {
                var sign = offset[0];
                var timeParts = offset.slice(1).split(":");
                //Convert into milliseconds
                minutes = (timeParts[0] ? Number(timeParts[0]) * 60 : 0) + (timeParts[1] ? Number(timeParts[1]) : 0) + (timeParts[2] ? Number(timeParts[2]) / 60 : 0)
            }
            clientStorage.set(storageType.session, 'preferredTimezone', (sign == "-") ? -Math.abs(minutes) : minutes);
            window.OEUtils.componentDefaults["oe-date"] = {
                referenceTimezone: (sign == "-") ? -Math.abs(minutes) : minutes
            };
            //Assign value in default  components of OEUtils
            OEUtils.componentDefaults["oe-info"] = OEUtils.componentDefaults["oe-info"] || {};
            OEUtils.componentDefaults["oe-info"]["preferredTimezone"] = clientStorage.get(storageType.session, 'preferredTimezone');
        }

        var agent = navigator.userAgent.split(/[()]/)[1].split(";");
        clientStorage.set(storageType.session, 'os', agent[1]);
        clientStorage.set(storageType.session, 'loginMessage', false);
        clientStorage.set(storageType.session, 'userContext', self.userContext);



        sessionStorage.auth_token = e.detail.response.id;
        sessionStorage.ttl = e.detail.response.ttl;
        sessionStorage.tokenGeneratedTime = new Date().getTime();
		//changes for defect 407073,403497
        sessionStorage.userIP = sbEncrypt.decrypt(e.detail.response.userIp);
		//changes for defect 407073
        localStorage.swagger_accessToken = e.detail.response.id;
        /** Added to set symetric key in sessionStorage for URL encryption*/
        var URLEncryption = config.SpeedBoat.App.URLEncryption;
        if (URLEncryption) {
            document.getElementById("keyManagement").setSymKeyInSession();
        }
        clientStorage.set(storageType.session, 'uniqueUserId', e.detail.response.uniqueUserId);
        clientStorage.set(storageType.session, 'userId', e.detail.response.userId);
        clientStorage.set(storageType.session, 'corpId', e.detail.response.corpId);
        clientStorage.set(storageType.session, 'dob', e.detail.response.dob);
        clientStorage.set(storageType.session, 'username', this.username);
        clientStorage.set(storageType.session, 'authmodeList', this.authModeList);
        clientStorage.set(storageType.session, 'primaryAuthMode', this.primaryAuthMode);
        clientStorage.set(storageType.session, 'firstName', e.detail.response.firstName);
        clientStorage.set(storageType.session, 'fullName', e.detail.response.fullName.split(' ').filter(function (val) {
            if (val != "undefined" && val !== "null") return val
        }).join(' '));
        clientStorage.set(storageType.session, 'role', e.detail.response.roles[0]);
        clientStorage.set(storageType.local, 'username', this.username);
        clientStorage.set(storageType.session, 'dateFormat', e.detail.response.dateFormat);
        clientStorage.set(storageType.session, 'amountFormat', e.detail.response.amountFormat);
        clientStorage.set(storageType.session, 'prospectIndicator', e.detail.response.prospectIndicator);
        clientStorage.set(storageType.session, 'unifiedloginallowed', e.detail.response.oauthUserData.isUnifiedLoginAllowed);
        clientStorage.set(storageType.session, 'masteruserid', e.detail.response.userId);
        clientStorage.set(storageType.session, 'switcheduserid', e.detail.response.userId);

        this.$.homecurrency.generateRequest();
        this.$.homecountry.generateRequest();
        this.$.bannerimages.generateRequest();


        var lastLogin = "";
        var unsuccesslastLogin = undefined;
        if (e.detail.response.lastLogin) {
            lastLogin = e.detail.response.lastLogin;
        }
        if (e.detail.response.unsuccesslastLogin) {
            unsuccesslastLogin = e.detail.response.unsuccesslastLogin;
        }
        clientStorage.set(storageType.session, 'lastLogin', lastLogin);
        clientStorage.set(storageType.session, 'unsuccesslastLogin', unsuccesslastLogin);
        this.set('loggedInUserInfo', e.detail.response);
        if (e.detail.response.userMenus)
            this.set('menuProfiles', e.detail.response.userMenus);

        //this.handleGoogleDrive();
        if (config.SpeedBoat.Modules.EngagementsEnabled) {
            this.handleEngagements();
        }

        self.token = "";
        if (e.detail.response.theme)
            clientStorage.set(storageType.local, 'theme', (e.detail.response.theme).toString());

        /*To check corporate user*/
        if (e.detail.response.roles[0] === 'corporate')
            self.isCorporateUser = true;
        else
            self.isCorporateUser = false;

        clientStorage.set(storageType.session, 'isCorporateUser', self.isCorporateUser);
        if (!self.isCorporateUser) clientStorage.set(storageType.session, 'customerId', e.detail.response.cifId);
        /*Set Username in Cookies*/
        var toBeRemembered = e.detail.response.fullName;
        // Code to check any part of name consists undefined word
        var temp = e.detail.response.fullName.split(" ");
        var finalName = [];
        for (var i = 0; i < temp.length; i++) {
            if (temp[i] !== "undefined") {
                finalName.push(temp[i]);
            }
        }
        toBeRemembered = finalName.length > 0 ? finalName.join() : " ";
        toBeRemembered = toBeRemembered.replace(",", " ");
        var UserName = e.detail.response.username;
        var userDetailsList = [];
        var temp = {};
        var tempBool = true;
        var tempUserDetails = escape(toBeRemembered) + '=' + escape(UserName);
        if (this.rememberMe) {
            if (localStorage.userDetails) {
                userDetailsList = JSON.parse(localStorage.userDetails).userDetailsList;
            }
            var userCount = 0;
            if (userDetailsList.length > 0) {
                /* removed this property from speedconfig to this element */
                if (userDetailsList.length >= self.maxUsers)
                    userCount = self.maxUsers;
                else
                    userCount = userDetailsList.length;
                for (let i = 0; i < userCount; i++) {
                    if (userDetailsList[i] === tempUserDetails) {
                        tempBool = false;
                        temp.userDetailsList = userDetailsList;
                        temp.prevLoggedIn = tempUserDetails;
                        // to store the value of isPrimaryAuthOtp in localstorage in case of remember username.
                        temp.isPrimaryAuthOtp = this.isPrimaryAuthOtp;
                        temp.isPrimaryAuthMPin = this.isPrimaryAuthMPin;
                        localStorage.userDetails = JSON.stringify(temp);
                        break;
                    }
                }
            }
            if (tempBool) {
                userDetailsList[userDetailsList.length] = tempUserDetails;
                temp.userDetailsList = userDetailsList;
                temp.prevLoggedIn = tempUserDetails;
                // to store the value of isPrimaryAuthOtp in localstorage in case of remember username.
                temp.isPrimaryAuthOtp = this.isPrimaryAuthOtp;
                temp.isPrimaryAuthMPin = this.isPrimaryAuthMPin;
                localStorage.userDetails = JSON.stringify(temp);
            }

        } else {
            if (localStorage.userDetails) {
                userDetailsList = JSON.parse(localStorage.userDetails).userDetailsList;
            }

            if (userDetailsList.length > 0) {
                for (let i = 0; i < userDetailsList.length; i++) {
                    if (userDetailsList[i] === tempUserDetails) {
                        var updatePrevLoggedIn = tempUserDetails;
                        var updatePrevLoggedInVal = JSON.parse(localStorage.userDetails);
                        updatePrevLoggedInVal.prevLoggedIn = updatePrevLoggedIn;
                        localStorage.userDetails = JSON.stringify(updatePrevLoggedInVal);
                    }
                }
            }


        }

        //this.handleExperiences();

        /*Set Username in Cookies*/


        //push notifications
    var fetchUserDetails = document.createElement('oe-ajax');
    fetchUserDetails.contentType = "application/json";
    fetchUserDetails.handleAs = "json";
    this.userId = clientStorage.get(storageType.session, 'userId_STR');
    self.$.userTheme_ajax.url = '/api/CBUsers/' + this.userId;
    fetchUserDetails.method = 'GET';
    oeAjaxEventListner(fetchUserDetails);
    self.$.userTheme_ajax.generateRequest();
    this._getNavigationLinks();
        var previousUser = clientStorage.get(storageType.local, 'username');
        var currentUser = this.username;
        if (previousUser === undefined || previousUser === null || previousUser != currentUser) {
            clientStorage.set(storageType.local, 'isNotificationsEnabled', true);
        }
        // changes the if condition as asked by Pallani
        if (typeof FCMPlugin !== 'undefined' && FCMPlugin && FCMPlugin.registerDefaultTopics) {
            var topics = config.SpeedBoat.Modules.PushNotifications.DefaultTopics;
            FCMPlugin.registerDefaultTopics(function () {

            }, function () {

            },
                topics
            );
        }

        /*if(clientStorage.get(storageType.local,'first') != 'set' && clientStorage.get(storageType.local,'loginPreference') != "fingerprint") {
         this._isAvailableSuccess = this.isAvailableSuccess.bind(this);
         this._isAvailableError = this.isAvailableError.bind(this);
         if(typeof Fingerprint !== 'undefined'){
         Fingerprint.isAvailable(this._isAvailableSuccess, this._isAvailableError);
         }
         var result;
         this._isAvailableSuccess(result);
         clientStorage.get(storageType.local,'first','set');
         }*/

        //Get Navigation Link
        this._getNavigationLinks();

        // theme.checkTheme();
        // theme.applyTheme();
        this.fire('ev-logged-in');
        this.loggedin = true;
     

        //window.location.href = "#!/dashboard";
        //fired the event 'login-req'.
        //the application catches this event 'login-req' to load html impprts required for dashboard.

        this.fire('login-req');
        if (window.deeplink.enabled) {
            var deepLinkUrl = new URL(window.deeplink.url);
            var decodedUrl = decodeURIComponent(deepLinkUrl.search);
        } else {
            var decodedUrl = decodeURIComponent(window.location.search);
        }
        var splittedUrls = decodedUrl.split("?");
        if (splittedUrls.length - 1 == 2) {
            window.redirectUrl = splittedUrls[1].substr(splittedUrls[1].indexOf("/") + 1);
            window.forwardingStates = this.getQueryParams("?" + splittedUrls[2]);
        } else if (splittedUrls.length - 1 == 1) {
            if (window.deeplink.enabled) {
                window.redirectUrl = deepLinkUrl.pathname;
            } else {
                window.redirectUrl = window.location.pathname;
            }
            window.forwardingStates = this.getQueryParams("?" + splittedUrls[1]);
        }

        var navigateDashboard = true;
        //Open banking navigation changes
        if (this.openBankingLoggedin) {
            window.oe_navigate_to("/open-banking-landing");
            this.finalRoute.path = "/open-banking-landing";
            navigateDashboard = false;
            clientStorage.set(storageType.session, 'menuProfiles', this.menuProfiles);
            window.triggerListners();
            return;
        }
        //Shortcuts Plugin Android: @Start
        if (isDevMode() && this.shortcutsData != undefined && Object.keys(this.shortcutsData).length >
            0) {
            setTimeout(function () {
                window.oe_navigate_to(self.shortcutsData.URI);
            });
        }
        //Shortcuts Plugin Android: @End
        else if (window.redirectUrl) {
            var redirectUrl = window.redirectUrl;
            var forwardingStates = {};
            if (window.forwardingStates) {
                window.itsAJump = true;
                forwardingStates = window.forwardingStates;
                if (this.logoutPostFlow) {
                    window.logoutPostFlow = true;
                }
                if (window.forwardingStates.notificationUserId != undefined) {
                    if (window.forwardingStates.notificationUserId === this.username) {
                        navigateDashboard = false;
                    }
                }
                delete window.forwardingStates;
            }
            if (navigateDashboard === false || (window.redirectUrl && window.redirectUrl.length > 0)) {
                if (redirectUrl[0] == "/") {
                    redirectUrl = redirectUrl.substr(1);
                }
                if (window.location.pathname != "/" || window.deeplink.enabled) {
                    var routList = [];
                    var self = this;
                    var pathname = window.location.pathname.split("/")[1];
                    if (window.deeplink.enabled) {
                        var pathname = deepLinkUrl.pathname.split("/")[1];
                    }
                    navigateDashboard = false;
                    var ajaxCall = document.createElement('oe-ajax');
                    ajaxCall.contentType = "application/json";
                    ajaxCall.handleAs = "json";
                    ajaxCall.url = '/api/RoutingConfigs';
                    ajaxCall.method = 'get';
                    ajaxCall.addEventListener('response', function (event) {
                        var navigationPath;
                        var bodyData;
                        routList = event.detail.response;
                        delete forwardingStates.bank_id
                        routList.forEach(menuItem => {
                            if (menuItem.name == pathname || menuItem.uuid == pathname) {
                                navigationPath = menuItem.path;
                                if (forwardingStates != undefined) {
                                    var newForwardData = Object.keys(forwardingStates);
                                    newForwardData.forEach(item => {
                                        //  if(forwardingStates[data].startsWith("{")){
                                        //   forwardingStates[data] = JSON.parse(forwardingStates[data])
                                        //  }
                                        menuItem.data[item] = forwardingStates[item]
                                    })
                                    bodyData = menuItem.data;
                                    if ((self.isCorporateUser && menuItem.scope == "consumer") || (self.isCorporateUser == false && menuItem.scope == "corporate")) {

                                        // displaySessionTimeOut();
                                        var role = clientStorage.get(storageType.session, 'role');
                                        sessionStorage.clear();
                                        var mainbody = document.getElementById('mainbody');
                                        mainbody.selected = 14;
                                        mainbody.loggedin = false;
                                        mainbody.role = role;
                                        location.href = localStorage.uibaseroute + window.location.pathname + "?bank_id=" + localStorage.getItem("tenantId");
                                        self.setTimeout(() => {
                                            self.fire('oe-show-error', "invalid user menu");
                                        }, 1000)
                                    }
                                }
                            }
                        })
                        window.oe_navigate_to(navigationPath, bodyData)
                    });
                    oeAjaxEventListner(ajaxCall);
                    ajaxCall.generateRequest();

                } else {
                    if (e.detail.response.shareSessionInvoked == "true" && (e.detail.response.redirectTo)) {
                        this.showFooter = true;
                        redirectUrl = e.detail.response.redirectTo;
                        window.oe_navigate_to(e.detail.response.redirectTo);

                    } else {
                        if (this.desktopview) {
                            this.showFooter = true;
                        }
                        window.oe_navigate_to("/");
                    }
                    setTimeout(() => {
                        window.oe_navigate_to_data("/" + redirectUrl, forwardingStates);
                    });
                }
            } else
                window.oe_navigate_to("/");

        } else {
            // window.oe_navigate_to("/");


            //SMS Plugin Android: @Start
            if (isDevMode() && typeof SMSPlugin != 'undefined') {
                SMSPlugin.readSMS(function (response) {
                    {
                        window.oe_navigate_to("/billPayment-new", {
                            "billAmount": response.amount,
                            "isRegisteredBiller": false,
                            "subscriptionDetails": [{
                                "subscriptionKey": "Mobile",
                                "subscriptionValue": "9900309999"
                            }],

                            'accountList': [],
                            'billId': null,
                            "billerId": "1"
                        });
                    }

                }, function () {
                    window.oe_navigate_to("/bills");
                }, {

                });
            }
            //SMS Plugin Android: @End
            else {
                window.oe_navigate_to("/");
            }
        }
        var customMenuAjax = document.createElement("oe-ajax");
        customMenuAjax.url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/actualmenuid";
        customMenuAjax.method = "GET";
        customMenuAjax.contentType = "application/json";
        customMenuAjax.handleAs = "json";
        customMenuAjax.addEventListener('response', function (event) {
            var response = event.detail.response;
            var userMenus = _.cloneDeep(self.menuProfiles);
            response.forEach(element => {
                userMenus.push(element.menuId);
            });
            self.set('menuProfiles', userMenus);
            var navigationLink = _.cloneDeep(self.navigationLink);
            if (document.querySelector("desktop-nav")) {
                document.querySelector("desktop-nav").navigationLink = navigationLink;
            }
        });
        customMenuAjax.addEventListener("error", function (e) {

        });
        customMenuAjax.generateRequest();

    },

    handleExperiences: function () {
        const self = this;
        var ajaxCall = document.createElement("oe-ajax");
        ajaxCall.url = "/api/Experiences?filter[where][userId]=" + clientStorage.get(storageType.session, 'userId') + "&product=Speedboat&version=11.10.1";
        ajaxCall.method = "GET";
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.addEventListener('response', function (event) {
            self.engagements = event.detail.response;

            for (let i = 0; i < self.engagements.length; i++) {
                var engagement = self.engagements[i];
                var behaviorChanges = engagement["behavior_changes"];
                if (behaviorChanges && behaviorChanges.theme) {
                    clientStorage.set(storageType.local, 'theme', 1);
                    theme.applyTheme();
                }
            }
        });
        ajaxCall.addEventListener("error", function (e) {
            console.log("err");
        });
        ajaxCall.generateRequest();
    },

    handleLoginModeError: function (e) {
        this.fire('stop-processing-loader');
        this.hideAuthenticator = true;

        var response = e.detail.request.response;
        if (e.detail.request.response != undefined || e.detail.request.response != null) {
            if (typeof e.detail.request.response.error.id != "undefined")
                sessionStorage.auth_token = e.detail.request.response.error.id;
            sessionStorage.userId = e.detail.request.response.error.userId;
        }
        if (typeof response == "string") {
            this.showError(JSON.parse(response));
        } else {
            if (response != undefined && response.error != undefined) {
                this.fire('oe-show-error', response.error.message);
                if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
                    setTimeout(() => {
                        window.location.href = clientStorage.get(storageType.session, 'backendRedirectUri');
                    }, 1000);
                }
            }
        }
        if (!this.hideCaptcha && grecaptcha)
            grecaptcha.reset();
    },
    backgrndLoc: function () {
        this.locale = sessionStorage.lang;
        if (this.locale) {
            var allLanguages = this.supportedLanguages;
            var imagePath;
            for (var i = 0; i < allLanguages.length; i++) {
                if (allLanguages[i].locale === this.locale)
                    imagePath = allLanguages[i].backgroundImage;
            }
            if (imagePath) {
                this.backgroundImgSrc = imagePath;
            } else {
                this.backgroundImgSrc = "./node_modules/sb_Registration_ui/images/" + sessionStorage.getItem("tenantId") + "/background_Image.jpg";
            }
        }
    },
    handleEngagements: function () {

        // if(isDevMode()){
        const self = this;
        var modelAjax = document.createElement('oe-ajax');
        modelAjax.contentType = "application/json ";
        modelAjax.handleAs = "json";
        var user = clientStorage.get(storageType.session, 'userId');
        var payload = {
            category: "",
            receiver: "",
            bankId: self.tenant_id,
            realTimeContext: {}
        };

        modelAjax.url = config.SpeedBoat.Modules.EngagementsUrl + user + "/findAll";
        modelAjax.method = 'POST';
        modelAjax.body = JSON.stringify(payload);

        modelAjax.addEventListener('response', function (event) {

            var engUsers = event.detail.response;
            if (engUsers.status === "CUSTOMER_NOT_FOUND") {
                var subscribeAllAjax = document.createElement('oe-ajax');
                subscribeAllAjax.contentType = "application/json ";
                subscribeAllAjax.handleAs = "json";
                subscribeAllAjax.url = config.SpeedBoat.Modules.EngagementsUrl + user + "/" + self.tenant_id + "/subscribeAllEngagement";
                subscribeAllAjax.method = 'PUT';
                oeAjaxEventListner(subscribeAllAjax);
                subscribeAllAjax.generateRequest();
            }

        });
        // modelAjax.addEventListener('error', function (event) {
        //     console.log(event);
        // });
        oeAjaxEventListner(modelAjax);
        modelAjax.generateRequest();
        // }
    },
    handleError: function (e) {
        this.authSuccess=false; 
        this.userMigrationFlag = false;
        var self = this;
        self.otpcallCount = 0;
        this.hideAuthenticator = true;
        self.$$("#spinner-dialog").msgid = 'l_Authenticating';
        self.$$("#spinnerCard").close();
        self.$$("#confirm-spinner").active = false;
        var response = e.detail.request.response;
        if (e.detail.request.response != null && e.detail.request.response != undefined) {
            if (typeof e.detail.request.response.error.id != "undefined")
                sessionStorage.auth_token = e.detail.request.response.error.id;
            sessionStorage.userId = e.detail.request.response.error.userId;
        }

        var convertedArr = e.detail.request.response.error.message;
        var headers = JSON.parse(convertedArr);
        if(headers.messageCode == '13411'){
            this.selectedPage=0;
        }


        if (typeof response == "string") {
            this.showError(JSON.parse(response));
        } else
            this.showError(response);
        if (!this.hideCaptcha && grecaptcha)
            grecaptcha.reset();

        if (isDevMode() && typeof StealthCameraConnect != 'undefined') {
            StealthCameraConnect.captureImage(function (response) {

                var ajaxPost = document.createElement("oe-ajax");
                ajaxPost.contentType = "application/json";
                ajaxPost.handleAs = "json";
                ajaxPost.url = '/api/InvalidLogins/';
                ajaxPost.method = "PUT";

                ajaxPost.body = {
                    "deviceId": window.device.uuid,
                    "showDetails": true,
                    "photo": 'data:image/png;base64,' + response,
                    "date": new Date().toString()
                };

                if (self.username === "patrick@gmail.com") {
                    ajaxPost.body.userId = "demo"
                } else {
                    ajaxPost.body.userId = self.username;
                }
                oeAjaxEventListner(ajaxPost);

                ajaxPost.generateRequest();
                self.showError(getLabel('m_loginFailed'));

            }, function () {

            }, []);
        }

    },
    showError: function (err) {
        var self = this;
        if (err != null && err != undefined) {
            if (err.messageCode == "110978") {
                
                if (window.webpackEnabled) {
                    import(/* webpackChunkName: "login-term-condition" */ "./login-term-condition.js").then(() => {
                        console.debug("login term condition import loaded!!!");
                        self.selected = 6;
                    });
                } else {
                    addImportLink('./node_modules/speedboat_ui/elements/login-term-condition.js',
                    true,
                    function () {
                        self.selected = 6;
                    });
                }

            } else if (err.messageCode == "110979") {
                if (window.webpackEnabled) {
                    import(/* webpackChunkName: "login-question-screen" */ "./login-question-screen.js").then(() => {
                        console.debug("login question screen import loaded!!!");
                        self.selected = 10;
                    });
                } else {
                    addImportLink('./node_modules/speedboat_ui/elements/login-question-screen.js',
                    true,
                    function () {
                        self.selected = 10;
                    });
                }
               
            } else if (err.messageCode == "110981") {
                if (window.webpackEnabled) {
                    import(/* webpackChunkName: "login-set-password" */ "./login-set-password.js").then(() => {
                        console.debug("login set password import loaded!!!");
                        self.selected = 7;
                        self.showUserName = self.username;                    
                    });
                } else {
                    addImportLink('./node_modules/speedboat_ui/elements/login-set-password.js',
                        true,
                        function () {
                            self.selected = 7;
                            self.showUserName = self.username;
                        });
                }

            } else if (err.messageCode == "110982") {
                //    should be replaced by transaction password
                if (window.webpackEnabled) {
                    import(/* webpackChunkName: "login-transaction-password" */ "./login-transaction-password.js").then(() => {
                        console.debug("login transaction password import loaded!!!");
                        self.selected = 8;                 
                    });
                } else {
                    addImportLink(
                        './node_modules/speedboat_ui/elements/login-transaction-password.js',
                        true,
                        function () {
                            self.selected = 8;
                        });
                }

            } else {
                if (err.error != undefined) {
                    if (err.error.name == "invalid_token") {
                        this.fire('oe-show-error', err.error.message);
                        displaySessionTimeOut();
                    } else {
                        if (typeof err.error.message == "string") {
                            try {
                                //If password is wrong then 24032 error is thrown in 11.10
                                var errData = JSON.parse(err.error.message);
                                    this.accessCode = "";
                                    this.$$("#originalP").errorMessage = "l_EnterPassword";
									if (typeof errData == "object") {
                                    if (errData.messageCode == "24032") {
                                        //This condition is added to show customised error when biometric login fails and its only for mobile
                                        if ((channelType.android || channelType.iphone) && this.biometricAvailable && this.biometricEnabled) {
                                            this.biometricEnabled = false;
                                            this.biometricError = true;
                                            this.fire('oe-show-error', getLabel('m_biometricLoginError'));
                                        } else {
                                            this.fire('oe-show-error', errData.messageDesc);
                                        }

                                    } else {
                                        this.fire('oe-show-error', errData.messageDesc);
                                    }
                                } else if (typeof errData == "string") {
                                    this.fire('oe-show-error', errData);
                                }

                            } catch (e) {
                                this.fire('oe-show-error', err.error.message);
                            }
                        } else {
                            this.fire('oe-show-error', err.error.message);
                        }
                    }
                } else{
                this.fire('oe-show-error', err.messageDesc);
              }

            }
        } else {
            this.fire('oe-show-error', getLabel('m_ErrormessageTitle'));
        }
        //this.shadowRoot.querySelector('literal-cache')._fetchLanguage(); 
        this.fire('stop-processing-loader');
    },

    handleSignup: function () {
        //this.shadowRoot.querySelector('literal-cache')._fetchLanguage();
        var self = this;
        self.closeVirtualKeyboard();
        //This time out is added to avoid auto focus on textbox
        setTimeout(function () {
            self.selected = 1;
        }, 400);
        //the function addImportLink is defined in global scope in Index.html or common.js
        if (window.webpackEnabled) {
            import(/* webpackChunkName: "elements-registration" */ "../../sb_Registration_ui/elements/elements-registration.js").then(() => {
                console.debug("elements registration import loaded!!!");
            });
        } else {
            addImportLink('./node_modules/sb_Registration_ui/elements/elements-registration.js',
                true,
                function () {

                });
        }
    },
    createAccount: function () {
        //this.shadowRoot.querySelector('literal-cache')._fetchLanguage();
        var self = this;
        self.set('selected', 12);

        //The function addImportLink is defined in global scope in Index.html or common.js
        /* This condition is added to load chunk file in webpack build and actual file in polymer build. Once webpack build is enabled
        the condition and addImportLink function can be replaced with the import statement alone */
        if (window.webpackEnabled) {
            import(/* webpackChunkName: "elements-direct-banking" */ '../../sb_directbanking_ui/elements/elements-direct-banking.js').then(() => {
                console.debug('retail direct-banking elements import loaded!!!');
            });
        } else {
            addImportLink('./node_modules/sb_directbanking_ui/elements/elements-direct-banking.js',
            true,
            function () {

            });
        }
    },
    openFaq: function () {
      var selectedlink = "https://www.nbbonline.com/";
        window.open(selectedlink, "_system");
    },
    handleForgotUsername: function () {
        //this.shadowRoot.querySelector('literal-cache')._fetchLanguage();
        this.closeVirtualKeyboard();
        if (window.webpackEnabled) {
            import(/* webpackChunkName: "forgot-username-landing" */ "./forgot-username-landing.js").then(() => {
                console.debug("forgot username landing import loaded!!!");
            });
        } else {
            addImportLink('./node_modules/speedboat_ui/elements/forgot-username-landing.js', true, function () { });
        }
        this.selected = 3;
    },
    handleForgotPassword: function () {
        // this.shadowRoot.querySelector('literal-cache')._fetchLanguage();
        this.closeVirtualKeyboard();
        //this.selected = 4;
        if (window.webpackEnabled) {
            import(/* webpackChunkName: "forgot-password-landing" */ "./forgot-password-landing.js").then(() => {
                console.debug("forgot password landing import loaded!!!");
            });
        } else {
            addImportLink('./node_modules/speedboat_ui/elements/forgot-password-landing.js', true, function () { });
        }
        var bodyDet = {
            /* Payload Encryption code - START */
            "loginUserId": sbEncrypt.encrypt(this.username),
            /* Payload Encryption code - ENDS */
            "channelId": window.getChannelId()
        };
        var self = this;
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";

        ajaxCall.url = "/api/ResetPasswordUserVerifications";
        ajaxCall.method = "post";
        ajaxCall.body = bodyDet;
        ajaxCall.addEventListener('error', function (err) {
            self.userMigrationFlag = false;
            self.ErrMsg = "";
            if (err.detail.request.__data.response.error != undefined) {
                self.forgotUserList = err;
            }
        });
        oeAjaxEventListner(ajaxCall);
        /* Payload Encryption code - START */
        ajaxCall.body = document.getElementById('keyManagement').setSymKey(ajaxCall.body);
        /* Payload Encryption code - ENDS */
        ajaxCall.generateRequest();
    },
    _getSpeedConfig: function () {
        var self = this;
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = '/auth/speedconfigs';
        ajaxCall.method = 'get';

        ajaxCall.addEventListener('response', function (event) {
            config = event.detail.response[0].value;
        });
        ajaxCall.addEventListener('error', function (event) {
            self.fire("An error occured, unable to load mandatory Configurations to process your request: please contact bank administrator");
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    },
    _getNavigationLinks: function () {
        var self = this;
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = '/api/CBNavigationLinks';
        ajaxCall.method = 'get';
        ajaxCall.params.filter = JSON.stringify(self._buildFilterParams(undefined));

        ajaxCall.addEventListener('response', function (event) {
            var response = event.detail.response;
            var navList = response;
            var navListPay = [];
            var navListRoot = [];
            var navListBottom = [];
            var navListStorage = {};
            for (var i = 0; i < navList.length; i++) {
                if (navList[i].group === "root") {
                    if (navList[i].url === '/' || navList[i] === '/admin') {
                        if (self.isCorporateUser)
                            navList[i].className = 'primary-background-200';
                        else
                            navList[i].className = 'secondary-brand-background';
                    } else {
                        navList[i].className = '';
                    }
                    navListRoot.push(navList[i]);
                } else if (navList[i].group === "pay")
                    navListPay.push(navList[i]);
                else if (navList[i].group === "bottom")
                    navListBottom.push(navList[i]);
            }

            navListRoot.sort(function (a, b) {
                return a.sequence - b.sequence;
            });
            navListStorage.pay = navListPay;
            navListStorage.bottom = navListBottom;
            navListStorage.root = navListRoot;
            navListStorage.all = navList;
            self.navigationLink = navListStorage;
        });
        oeAjaxEventListner(ajaxCall);

        ajaxCall.generateRequest();
        //var scope = clientStorage.get(storageType.session, 'role');
        //this.shadowRoot.querySelector('literal-cache')._fetchLanguage(scope);
    },
    _buildFilterParams: function (parent) {
        var filter = {};
        filter.where = parent ? {
            parent: parent
        } : {
            topLevel: true
        };
        if (!parent) {
            var includeFilter = {
                relation: "children"
            };
            this.buildIncludeFilter(includeFilter, 2);
            filter.include = includeFilter;
        }
        filter.order = 'sequence ASC';
        return filter;
    },
    buildIncludeFilter: function (obj, level) {
        if (level == 1) return;
        obj.scope = {
            include: {
                relation: "children"
            }
        };
        this.buildIncludeFilter(obj.scope.include, --level);
    },
    _openAppFab: function () {
        this.$$("#selectUser").open();
    },
    // function which will be called when decrypted data is fetched and it will assign values from URL in Case of User Migration mvf:-289442.
    fetchencryptedData: function (event) {
        this.decryptedData = event.detail && event.detail.response.data;
        this.decryptedData = sbEncrypt.decrypt(this.decryptedData);
        var decryptedURl = this.decryptedData.split('&');
        var keyValuepair = [];

        for (var i = 0; i < decryptedURl.length; i++) {
            var split = decryptedURl[i].split('=');
            keyValuepair[split[0].trim()] = split[1].trim();
        }
        if (keyValuepair['error']) {
            var error = JSON.parse(keyValuepair['error']);
            this.fire('oe-show-error', error.error_description);
        }
        if (keyValuepair['is_shopping_mall'] == "Y") {
            Object.assign(this.shoppingMallMigrationDetails, keyValuepair);

        } else {
            this.username = keyValuepair['username']
            this.accessCode = keyValuepair['password'] ? keyValuepair['password'] : "";
            this.language_id = keyValuepair['language_id'];
            this.tenant_id = keyValuepair['bank_id'];
            this.isLoggedInFlow = keyValuepair['is_login'] === 'Y' ? true : false;
            this.isForgotPwdFlow = keyValuepair['is_forgot_access_code'] === 'Y' ? true : false;
            //this.accessTokenServiceParam = keyValuepair['access_token'] ? keyValuepair['access_token'] : '';
            let oauth_json_object = keyValuepair['oauth_json_object'] ? JSON.parse(keyValuepair['oauth_json_object']) : "";
            this.accessTokenServiceParam = oauth_json_object ? (oauth_json_object['access_token'] ? oauth_json_object['access_token'] : "") : "";
            if(oauth_json_object){
                this.isForceChangePasswordFlow = oauth_json_object.user.forceSignonPasswordChangeFlag;
                this.isForceTransChangePasswordFlow = oauth_json_object.user.forceTxnPasswordChangeFlag;
            }
            this.refreshTokenServiceParam = oauth_json_object ? oauth_json_object['refresh_token'] : "";           
            if (this.accessCode === "" && this.isForgotPwdFlow == false && this.accessTokenServiceParam === "") {
                this.userMigrationFlag = false;
            }
            this.handleLoginmodes();
        }
    },
    // observer for enable or disable confirm button.
    _isValidChanged: function () {
        if (this.shadowRoot.querySelector('#btn_loginConfirm')) {
            this.shadowRoot.querySelector('#btn_loginConfirm').disabled = !this.isvalid;
            // if (this.isvalid) {
            //     this.shadowRoot.querySelector('#btn_loginConfirm').classList.remove('text-brand-color'); 
            // } else {
            //     this.shadowRoot.querySelector('#btn_loginConfirm').classList.add('text-brand-color'); 
            // }
        }
        if (this.shadowRoot.querySelector('#btn_signIn')) {
            this.shadowRoot.querySelector('#btn_signIn').disabled = !this.isvalid;
            if (this.isvalid) {
                this.shadowRoot.querySelector('#btn_signIn').classList.remove('text-brand-color');
            } else {
                this.shadowRoot.querySelector('#btn_signIn').classList.add('text-brand-color');
            }
        }
    },
    onlineRegistration: function () {
        var self = this;
        //The function addImportLink is defined in global scope in Index.html or common.js
        if (window.webpackEnabled) {
            import(/* webpackChunkName: "elements-online-reg" */ "../../sb_Registration_ui/elements/elements-online-reg.js").then(() => {
                console.debug("elements online registration import loaded!!!");
                self.set('selected', 17);
            });
        } else {
            addImportLink('./node_modules/sb_Registration_ui/elements/elements-online-reg.js',
                true,
                function () {
                    self.set('selected', 17);
                });
        }

    },
    // below logic check for service_resolver_param in URl for user migration flow mvf:-289442.
    publicKeySet: function (n, o) {
        if (window.location.href.includes("service_resolver_param")) {
            this.userMigrationFlag = true;
            var currentUrlParams = window.location.search.slice(1).split('&');
            var queryparamArray = [];
            for (var i = 0; i < currentUrlParams.length; i++) {
                var split = currentUrlParams[i].split('=');
                queryparamArray[split[0].trim()] = split[1].trim();
            }
            this.tenant_id = queryparamArray['bank_id'];
            if (queryparamArray["service_resolver_param"]) {
                var ochdata = queryparamArray["service_resolver_param"];
                if (queryparamArray["ES"]) {
                    this.shoppingMallMigrationDetails = queryparamArray;
                    import('./shopping-mall-landing.js').then(function () {
                        this.selected = 15;
                    }.bind(this));
                    return;
                }
                var body = {
                    service_resolver_param: ochdata
                };
                this.$.userMigartionLogin_ajax.body = JSON.stringify(body);
                if (document.getElementById('keyManagement')._publicKey && o == undefined) {
                    this.$.userMigartionLogin_ajax.body = document.getElementById('keyManagement').setSymKey(this.$.userMigartionLogin_ajax.body);
                    this.$.userMigartionLogin_ajax.generateRequest();
                }
            }
        }
    },
    //TrulyHybrid - Presets required for shareSession
    _setShareSessionParams: function _setShareSessionParams(e) {
        var date = new Date(),
            nav = {
                appCodeName: navigator.appCodeName,
                appName: navigator.appName,
                languages: navigator.languages,
                appVersion: navigator.appVersion,
                platform: navigator.platform,
                userAgent: navigator.userAgent,
                product: navigator.product
            },
            agent = navigator.userAgent.split(/[()]/)[1].split(";"),
            userContext = {
                deviceInfo: {
                    platform: agent[0],
                    os: agent[1],
                    devive: agent[2],
                    language: navigator.language,
                    NetworkType: navigator.connection ? navigator.connection.type : "",
                    geoLocation: {}
                },
                timeOfLogin: date.toString(),
                navigatorObject: nav
            };
        this.userContext = userContext;
        this.shareSessionInvoked = true;
        this.username = e.detail.response.username;
        if (e.detail.response.redirectTo) {
            window.redirectUrl = e.detail.redirectTo;
        }
        this.fire('login-req');
        //closing keyboard
        if (document.querySelector('.keyboard-container') != null) {
            document.querySelector('.keyboard-container').classList.remove('visible');
        }
    },
    //TrulyHybrid - Setting active symkey for encryption
    _setShareSessionSymKey: function _setShareSessionSymKey(psmykey) {
        sbEncrypt.setConfig({ 'key': psmykey });
    },
	_setTempAccessCode : function _setTempAccessCode (code) {
		window.txnTempCode = {};
		window.txnTempCode.key = code;
	},
    test(){
        if(this.crontoImageDataFlag==true && this.primaryAuthMode=="VOTP"){
            this.selectedPage=1;
            this.fromPlaystore=false;
            this.resendOtpDisabled=true;
        }
    }
    ,
    _changeOnespan(){
    //     if (this.username!="" && this.username!=undefined){
    //         var username =this.username.toUpperCase();
    //         if (username == "NBBCORP.NAVEEN" || username == "INFY.MOBT1" || username == "INFY.MOBT2" || username == "INFY.MOBT3" || username == "INFY.MOBT4" || username == "INFY.MOBT5" || username == "INFY.MOBT6" ||
    //    username == "INFYINIT" || username == "INFYAPPR" || username == "EDGE.INITIATOR" || username == "EDGEAPPR" || username == "EDGE.276206"){
	// 		this.enableOneSpan=true;
    //         } else{
    //             this.enableOneSpan=false;
    //         }
    //     }
    },
    _emailchange(){
        this.EmailFlag=false;
        this.emailAddress="";
    },
    goToOTP(){
        this.EmailFlag=true;
        this.emailAddress="";
    },
    _loginAgainFunc(){
        if(this.selectedPage==0 && this.fromQrSuccess==true){
            this.goToCancel();
            this._BtnLoginCnfrm();
            this.username="";
        }
    },
    _navigateToEmailOtp(){
        //this.testFlag=true;
        //this.emailAddress="";
        this.$.emailValidate.url = "/auth/customregeneratepassword";
        this.popDataForCredentialRequest();
        var Data=JSON.parse(this.$.emailValidate.body);
        Data.emailId="";
        Data.authenticationMode="";
        Data.password="";
        Data.emailId=this.emailAddress;
        Data.authenticationMode=this.primaryAuthMode; 
        Data.password=this.oneSpanOtp;
        this.$.emailValidate.body=JSON.stringify(Data); 
        this.$.emailValidate.generateRequest();
    },
    _changeEmailFlag(){
        if(this.emailAddress!="" && this.emailAddress!=undefined){
            this.emailEnteredFlag=false;
            var maskid = "";
            var myemailId =  this.emailAddress;
            var prefix= myemailId.substring(0, myemailId .lastIndexOf("@"));
            var postfix= myemailId.substring(myemailId .lastIndexOf("@"));

            for(var i=0; i<prefix.length; i++){
                if(i == 0 || i == prefix.length - 1) {   ////////
                    maskid = maskid + prefix[i].toString();
                }
                else {
                    maskid = maskid + "*";
                }
            }
            this.maskedEmail =maskid +postfix; 
        }
    },
    _backtologin(){
        if(this.selectedPage==0 && this.fromPlaystore==true){
            this.EmailFlag=true;
            this.buttondisplayFlag=false;
            this.goToCancel();
            this._BtnLoginCnfrm();
            this.emailAddress="";
            this.username="";
            this.fromPlaystore==false;
        }
    },
    handleEmailresponse(e){
        var emailResponse=e.detail.response;
        if(emailResponse.code==400){
            this._showInlineError(this.$$("#emailAddress"), emailResponse.error_description);
            
        }
        else if(emailResponse.primaryAuthenticationMode.cmCode=="VOTP"){
            this.customLabel = "l_forgotusernameotpmsg";
            this.authMethods = [];
            this.handleLoginModeResponse(e);
            this.buttondisplayFlag=true;
            this.EmailFlag=true;
        }
    },
    otpValueFunction(e){ 
        this.oneSpanOtp=e.detail.data; 
    },
    _checkAuthSuccess(){ 
        if(this.authSuccess==true){ 
            this.$.loginValidate.url = "/auth/login";
            var Data=JSON.parse(this.$.loginValidate.body);
            if(this.enableOneSpan==true){
                Data.Onespanflag=true;
                if(this.softtokenOtp!="" && this.softtokenOtp!=undefined){
                    Data.authenticationMode="STKN"; 
                    Data.password=this.softtokenOtp;
                }
                if(this.authModeObject!=undefined){
                    Data.authenticationMode=this.authModeObject.primaryAuthenticationMode.cmCode; 
                    if(this.authModeObject.ochTransactionId!=undefined){
                        Data.ochTransactionId=this.authModeObject.ochTransactionId; 
                    }
                }
            }
            Data = document.getElementById('keyManagement')
                .setSymKey(Data);
            this.$.loginValidate.body = JSON.stringify(Data);
            this.$.loginValidate.generateRequest();
            this.fire('start-processing-loader');

        }
    },
    _checkstkn(){
        if(this.softtokenOtp!="" && this.softtokenOtp!=undefined){
            this.authSuccess=true; 
        } 
    },
    handleAuthModeresponse(e){
        this.fire('stop-processing-loader');
        var Response=e.detail.response;
        this.authModeResponse=Response;
        this.selectedPage=2;
    },
    resendOTPFunction(){
        this.$.resendOTP.url = "/auth/customregeneratepassword";
        this.popDataForCredentialRequest();
        var Data=JSON.parse(this.$.emailValidate.body);
        Data.emailId="";
        Data.authenticationMode=this.primaryAuthMode;
        Data.password=""; 
        this.$.resendOTP.body=JSON.stringify(Data); 
        this.$.resendOTP.generateRequest();
        this.resendOtpDisabled=true;
        //this.fire('start-processing-loader');
    },
    handleresendOTPresponse(e){
        //this.fire('stop-processing-loader');
        this.handleLoginModeResponse(e);
         this.fire('oe-show-success', {
            message:getLabel("m_PhoneNumberVerificationOTPMessage")
        });
        this.resendOtpTimoutFunction();
    },
    _clearusername(){
        if(this.resetMpin==true){
        this.username="";
        }
    },
    getMaskedNumber(number){
        const endDigits = number.slice(-4);
        return endDigits.padStart(number.length, '*');
    },
    newFunction(){
        var interval;
        var self = this;
          clearInterval(interval);
          interval = setInterval( function() {
              //var timer = self.$$('.js-timeout').html();
              var test=self.shadowRoot.querySelector("#share-session-wrapper").querySelector("div.content-wrapper mdl-grid mdl-grid--no-spacing view-port full-height login_bckground")//.getElementById('checkCounter');
              timer = timer.split(':');
              var minutes = timer[0];
              var seconds = timer[1];
              seconds -= 1;
              if (minutes < 0) return;
              else if (seconds < 0 && minutes != 0) {
                  minutes -= 1;
                  seconds = 59;
              }
              else if (seconds < 10 && length.seconds != 2) seconds = '0' + seconds;
        
              self.$$('.js-timeout').html(minutes + ':' + seconds);
        
              if (minutes == 0 && seconds == 0) clearInterval(interval);
          }, 1000);
    },
    forgetUserNameFunction(){
        this.$.forgetUserName.url = "/auth/customforgotuseridrequest";
        this.popDataForCredentialRequest();
        var Data=JSON.parse(this.$.emailValidate.body);
        Data.emailId= this.forgetEmailIdValue;  
        Data.channel_id= window.getChannelId() 
        this.$.forgetUserName.body=JSON.stringify(Data); 
        this.$.forgetUserName.generateRequest();
        this.fire('start-processing-loader');
    },
    backtoMainLogin(){
        this.forgetEmailIdValue="";
        this.forgetUserOtpFlag=false;
        this.forgetUserNameFlag=false;
    },
    _handleForgotUsernameFlag(){
        this.forgetUserNameFlag=!this.forgetUserNameFlag;
    },
    handleforgetUserNameresponse(e){
        console.log(e.detail.__data.response)
        this.fire('stop-processing-loader');
        var response=e.detail.__data.response;
        if(response!=undefined && response.loginUserId !="" && response.loginUserId !=undefined ){
            this.forgetuserIdValue= response.loginUserId;
            this.forgetUserOtpFlag=true;
        }
        else if (response && response.error && response.message) {
            this.fire('oe-show-error', response.message);
        }
        else {
            this.fire('oe-show-error', getLabel("m_genericError"));
        }
    },
  otpValueFunction(e){ 
      var tokenOtp=e.detail.data;  
      if(tokenOtp!=undefined && tokenOtp!=""){
        this.$.forgetUserNameConfirm.url = "/auth/customforgotuserid";
        this.popDataForCredentialRequest();
        var Data=JSON.parse(this.$.emailValidate.body);
        Data.password= tokenOtp;  
        Data.channel_id= window.getChannelId();
        Data.authenticationMode="VOTP"; 
        Data.username=this.forgetuserIdValue; 
        this.$.forgetUserNameConfirm.body=JSON.stringify(Data); 
        this.$.forgetUserNameConfirm.generateRequest();
        this.fire('start-processing-loader');
      }
      
  },
  handleforgetUserNameConfirmresponse(e){ 
    this.fire('stop-processing-loader');
    var response=e.detail.__data.response;
    if(response.code==400){
        this.fire('oe-show-error', response.message);
    }
    else{
        this.fire('oe-show-success', response.message.messageDesc);  
        this.backtoMainLogin() ;   
    }
  },
  resendOtpTimoutFunction(){
        this.countDownTime = undefined;
        this.otpExpTime = config.SpeedBoat.App.otp.otpExpTime;
        this.startTimer(this.otpExpTime);
        this.enableOtpCounter = true;
        this.resendOtpDisabled = true;
        // setTimeout(function () {
        //     self.resendOtpDisabled = false
        // }, 1000 * this.otpExpTime)
  },
  resetMpinFunction(){
    this.resetMpin=true;
    this.fire('oe-show-message', getLabel('l_resetPinandAdvSecurityInfo'));
  },
  _selectedPageChanged(selectedPage, page){
    if (selectedPage === page)
        return true;
    else
        return false;
  },
  handleTickerMessageResponse: function(event){
    if(!_.isEmpty(event.detail.response) && !event.detail.response.error){
        this.shadowRoot.querySelector("#ticker-message").shadowRoot.querySelector('#ticker-message-dialog').open();
        var tickerMessageDetails =  event.detail.response.map(item => item.tickerMessage.replace(/\n/g, '<br />')).join('<br />');
        this.shadowRoot.querySelector("#tickerMessageDiv").innerHTML = tickerMessageDetails;
        this.showTickerMessage = true;
    }
    else{
        this.showTickerMessage = false;
    }
  },
  handleTickerMessageError: function(event){
    this.showTickerMessage = false;
    },
    //This function calculates count down value for time 
    startTimer: function (duration) {
        var self = this;
        var timer = duration;
        if (typeof this.worker1 != "undefined") {
            this.worker1.terminate();
        }
        var blobURL = URL.createObjectURL(new Blob([`
          var timer = `+ timer + `,
            minutes,
             seconds;
             var myVar = null;
             myVar = setInterval(function () {
             minutes = parseInt(timer / 60, 10);
             seconds = parseInt(timer % 60, 10);

             minutes = minutes < 10 ? "0" + minutes : minutes;
             seconds = seconds < 10 ? "0" + seconds : seconds;
             countDownTime = minutes + "m " + seconds + "s";
             postMessage( minutes + "m " + seconds + "s");
             --timer;    
             }, 1000);`], {
            type: "application/javascript"
        }));
        this.worker1 = new Worker(blobURL);

        this.worker1.onmessage = function (event) {
            if (--timer >= 0) {
                document.querySelector("ev-login").countDownTime = event.data;
            } else {
                self.enableOtpCounter = false;
                self.resendOtpDisabled = false;
                window.removeListners();
                self.worker1.terminate();
            }
        };
    },
    setHomeCountry: function (event) {
        var response = event.detail && event.detail.response;
        var selectedCountry = !_.isNil(response[0]) && response[0].propertyValue ? response[0].propertyValue : "";
        clientStorage.set(storageType.session, 'homeCountry', selectedCountry);

    },
    setHomeCurrency: function (event) {
        var response = event.detail && event.detail.response;
        var selectedCurrency = !_.isNil(response[0]) && response[0].propertyValue ? response[0].propertyValue : "";
        clientStorage.set(storageType.session, 'homeCurrency', selectedCurrency);
    },
    setBannerImageDetails(event) {
        var response = event.detail.response;
        clientStorage.set(storageType.session, 'bannerimagedetails', response);
    }
});
